(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6f25"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6f25"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("34BFp", function(module, exports) {
module.exports = function(list) {
    return function(initValues, element, notCreate) {
        var item = this;
        this._values = {};
        this.found = false // Show if list.searched == true and this.found == true
        ;
        this.filtered = false // Show if list.filtered == true and this.filtered == true
        ;
        var init = function(initValues, element, notCreate) {
            if (element === undefined) {
                if (notCreate) item.values(initValues, notCreate);
                else item.values(initValues);
            } else {
                item.elm = element;
                var values = list.templater.get(item, initValues);
                item.values(values);
            }
        };
        this.values = function(newValues, notCreate) {
            if (newValues !== undefined) {
                for(var name in newValues)item._values[name] = newValues[name];
                if (notCreate !== true) list.templater.set(item, item.values());
            } else return item._values;
        };
        this.show = function() {
            list.templater.show(item);
        };
        this.hide = function() {
            list.templater.hide(item);
        };
        this.matching = function() {
            return list.filtered && list.searched && item.found && item.filtered || list.filtered && !list.searched && item.filtered || !list.filtered && list.searched && item.found || !list.filtered && !list.searched;
        };
        this.visible = function() {
            return item.elm && item.elm.parentNode == list.list ? true : false;
        };
        init(initValues, element, notCreate);
    };
};

});

parcelRegister("atDb6", function(module, exports) {
module.exports = function(list) {
    var addAsync = function(values, callback, items) {
        var valuesToAdd = values.splice(0, 50);
        items = items || [];
        items = items.concat(list.add(valuesToAdd));
        if (values.length > 0) setTimeout(function() {
            addAsync(values, callback, items);
        }, 1);
        else {
            list.update();
            callback(items);
        }
    };
    return addAsync;
};

});

parcelRegister("7fnRJ", function(module, exports) {

var $lJ2hG = parcelRequire("lJ2hG");

var $7q4zh = parcelRequire("7q4zh");

var $i0a3b = parcelRequire("i0a3b");
module.exports = function(list) {
    var isHidden = false;
    var refresh = function(pagingList, options) {
        if (list.page < 1) {
            list.listContainer.style.display = 'none';
            isHidden = true;
            return;
        } else if (isHidden) list.listContainer.style.display = 'block';
        var item, l = list.matchingItems.length, index = list.i, page = list.page, pages = Math.ceil(l / page), currentPage = Math.ceil(index / page), innerWindow = options.innerWindow || 2, left = options.left || options.outerWindow || 0, right = options.right || options.outerWindow || 0;
        right = pages - right;
        pagingList.clear();
        for(var i = 1; i <= pages; i++){
            var className = currentPage === i ? 'active' : '';
            //console.log(i, left, right, currentPage, (currentPage - innerWindow), (currentPage + innerWindow), className);
            if (is.number(i, left, right, currentPage, innerWindow)) {
                item = pagingList.add({
                    page: i,
                    dotted: false
                })[0];
                if (className) $lJ2hG(item.elm).add(className);
                item.elm.firstChild.setAttribute('data-i', i);
                item.elm.firstChild.setAttribute('data-page', page);
            } else if (is.dotted(pagingList, i, left, right, currentPage, innerWindow, pagingList.size())) {
                item = pagingList.add({
                    page: '...',
                    dotted: true
                })[0];
                $lJ2hG(item.elm).add('disabled');
            }
        }
    };
    var is = {
        number: function(i, left, right, currentPage, innerWindow) {
            return this.left(i, left) || this.right(i, right) || this.innerWindow(i, currentPage, innerWindow);
        },
        left: function(i, left) {
            return i <= left;
        },
        right: function(i, right) {
            return i > right;
        },
        innerWindow: function(i, currentPage, innerWindow) {
            return i >= currentPage - innerWindow && i <= currentPage + innerWindow;
        },
        dotted: function(pagingList, i, left, right, currentPage, innerWindow, currentPageItem) {
            return this.dottedLeft(pagingList, i, left, right, currentPage, innerWindow) || this.dottedRight(pagingList, i, left, right, currentPage, innerWindow, currentPageItem);
        },
        dottedLeft: function(pagingList, i, left, right, currentPage, innerWindow) {
            return i == left + 1 && !this.innerWindow(i, currentPage, innerWindow) && !this.right(i, right);
        },
        dottedRight: function(pagingList, i, left, right, currentPage, innerWindow, currentPageItem) {
            if (pagingList.items[currentPageItem - 1].values().dotted) return false;
            else return i == right && !this.innerWindow(i, currentPage, innerWindow) && !this.right(i, right);
        }
    };
    return function(options) {
        var pagingList = new $i0a3b(list.listContainer.id, {
            listClass: options.paginationClass || 'pagination',
            item: options.item || "<li><a class='page' href='#'></a></li>",
            valueNames: [
                'page',
                'dotted'
            ],
            searchClass: 'pagination-search-that-is-not-supposed-to-exist',
            sortClass: 'pagination-sort-that-is-not-supposed-to-exist'
        });
        $7q4zh.bind(pagingList.listContainer, 'click', function(e) {
            var target = e.target || e.srcElement, page = list.utils.getAttribute(target, 'data-page'), i = list.utils.getAttribute(target, 'data-i');
            if (i) list.show((i - 1) * page + 1, page);
        });
        list.on('updated', function() {
            refresh(pagingList, options);
        });
        refresh(pagingList, options);
    };
};

});
parcelRegister("lJ2hG", function(module, exports) {
/**
 * Module dependencies.
 */ 
var $86c9F = parcelRequire("86c9F");
/**
 * Whitespace regexp.
 */ var $fd0f928c3083aa32$var$re = /\s+/;
/**
 * toString reference.
 */ var $fd0f928c3083aa32$var$toString = Object.prototype.toString;
/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */ module.exports = function(el) {
    return new $fd0f928c3083aa32$var$ClassList(el);
};
/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */ function $fd0f928c3083aa32$var$ClassList(el) {
    if (!el || !el.nodeType) throw new Error('A DOM element reference is required');
    this.el = el;
    this.list = el.classList;
}
/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */ $fd0f928c3083aa32$var$ClassList.prototype.add = function(name) {
    // classList
    if (this.list) {
        this.list.add(name);
        return this;
    }
    // fallback
    var arr = this.array();
    var i = $86c9F(arr, name);
    if (!~i) arr.push(name);
    this.el.className = arr.join(' ');
    return this;
};
/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */ $fd0f928c3083aa32$var$ClassList.prototype.remove = function(name) {
    // classList
    if (this.list) {
        this.list.remove(name);
        return this;
    }
    // fallback
    var arr = this.array();
    var i = $86c9F(arr, name);
    if (~i) arr.splice(i, 1);
    this.el.className = arr.join(' ');
    return this;
};
/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */ $fd0f928c3083aa32$var$ClassList.prototype.toggle = function(name, force) {
    // classList
    if (this.list) {
        if ('undefined' !== typeof force) {
            if (force !== this.list.toggle(name, force)) this.list.toggle(name) // toggle again to correct
            ;
        } else this.list.toggle(name);
        return this;
    }
    // fallback
    if ('undefined' !== typeof force) {
        if (!force) this.remove(name);
        else this.add(name);
    } else if (this.has(name)) this.remove(name);
    else this.add(name);
    return this;
};
/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */ $fd0f928c3083aa32$var$ClassList.prototype.array = function() {
    var className = this.el.getAttribute('class') || '';
    var str = className.replace(/^\s+|\s+$/g, '');
    var arr = str.split($fd0f928c3083aa32$var$re);
    if ('' === arr[0]) arr.shift();
    return arr;
};
/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */ $fd0f928c3083aa32$var$ClassList.prototype.has = $fd0f928c3083aa32$var$ClassList.prototype.contains = function(name) {
    return this.list ? this.list.contains(name) : !!~$86c9F(this.array(), name);
};

});
parcelRegister("86c9F", function(module, exports) {
var $5e584ff997659459$var$indexOf = [].indexOf;
module.exports = function(arr, obj) {
    if ($5e584ff997659459$var$indexOf) return arr.indexOf(obj);
    for(var i = 0, il = arr.length; i < il; ++i){
        if (arr[i] === obj) return i;
    }
    return -1;
};

});


parcelRegister("7q4zh", function(module, exports) {

$parcel$export(module.exports, "bind", function () { return $566e813c5efe2493$export$2385a24977818dd0; }, function (v) { return $566e813c5efe2493$export$2385a24977818dd0 = v; });
$parcel$export(module.exports, "unbind", function () { return $566e813c5efe2493$export$433e98592e7124fd; }, function (v) { return $566e813c5efe2493$export$433e98592e7124fd = v; });
$parcel$export(module.exports, "debounce", function () { return $566e813c5efe2493$export$61fc7d43ac8f84b0; }, function (v) { return $566e813c5efe2493$export$61fc7d43ac8f84b0 = v; });
/**
 * Bind `el` event `type` to `fn`.
 *
 * @param {Element} el, NodeList, HTMLCollection or Array
 * @param {String} type
 * @param {Function} fn
 * @param {Boolean} capture
 * @api public
 */ var $566e813c5efe2493$export$2385a24977818dd0;
/**
 * Unbind `el` event `type`'s callback `fn`.
 *
 * @param {Element} el, NodeList, HTMLCollection or Array
 * @param {String} type
 * @param {Function} fn
 * @param {Boolean} capture
 * @api public
 */ var $566e813c5efe2493$export$433e98592e7124fd;
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * `wait` milliseconds. If `immediate` is true, trigger the function on the
 * leading edge, instead of the trailing.
 *
 * @param {Function} fn
 * @param {Integer} wait
 * @param {Boolean} immediate
 * @api public
 */ var $566e813c5efe2493$export$61fc7d43ac8f84b0;
var $566e813c5efe2493$var$bind = window.addEventListener ? 'addEventListener' : 'attachEvent', $566e813c5efe2493$var$unbind = window.removeEventListener ? 'removeEventListener' : 'detachEvent', $566e813c5efe2493$var$prefix = $566e813c5efe2493$var$bind !== 'addEventListener' ? 'on' : '';

var $gj517 = parcelRequire("gj517");
$566e813c5efe2493$export$2385a24977818dd0 = function(el, type, fn, capture) {
    el = $gj517(el);
    for(var i = 0, il = el.length; i < il; i++)el[i][$566e813c5efe2493$var$bind]($566e813c5efe2493$var$prefix + type, fn, capture || false);
};
$566e813c5efe2493$export$433e98592e7124fd = function(el, type, fn, capture) {
    el = $gj517(el);
    for(var i = 0, il = el.length; i < il; i++)el[i][$566e813c5efe2493$var$unbind]($566e813c5efe2493$var$prefix + type, fn, capture || false);
};
$566e813c5efe2493$export$61fc7d43ac8f84b0 = function(fn, wait, immediate) {
    var timeout;
    return wait ? function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) fn.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) fn.apply(context, args);
    } : fn;
};

});
parcelRegister("gj517", function(module, exports) {
/**
 * Source: https://github.com/timoxley/to-array
 *
 * Convert an array-like object into an `Array`.
 * If `collection` is already an `Array`, then will return a clone of `collection`.
 *
 * @param {Array | Mixed} collection An `Array` or array-like object to convert e.g. `arguments` or `NodeList`
 * @return {Array} Naive conversion of `collection` to a new `Array`.
 * @api public
 */ module.exports = function toArray(collection) {
    if (typeof collection === 'undefined') return [];
    if (collection === null) return [
        null
    ];
    if (collection === window) return [
        window
    ];
    if (typeof collection === 'string') return [
        collection
    ];
    if ($bdf24ffec7d86ef0$var$isArray(collection)) return collection;
    if (typeof collection.length != 'number') return [
        collection
    ];
    if (typeof collection === 'function' && collection instanceof Function) return [
        collection
    ];
    var arr = [];
    for(var i = 0, il = collection.length; i < il; i++)if (Object.prototype.hasOwnProperty.call(collection, i) || i in collection) arr.push(collection[i]);
    if (!arr.length) return [];
    return arr;
};
function $bdf24ffec7d86ef0$var$isArray(arr) {
    return Object.prototype.toString.call(arr) === '[object Array]';
}

});


parcelRegister("i0a3b", function(module, exports) {

var $8qGk4 = parcelRequire("8qGk4");

var $fLPVz = parcelRequire("fLPVz");

var $8UWm9 = parcelRequire("8UWm9");

var $86c9F = parcelRequire("86c9F");

var $7q4zh = parcelRequire("7q4zh");

var $dWCJP = parcelRequire("dWCJP");

var $lJ2hG = parcelRequire("lJ2hG");

var $5rrWn = parcelRequire("5rrWn");

var $gj517 = parcelRequire("gj517");









module.exports = function(id, options, values) {
    var self = this, init, Item = (parcelRequire("34BFp"))(self), addAsync = (parcelRequire("atDb6"))(self), initPagination = (parcelRequire("7fnRJ"))(self);
    init = {
        start: function() {
            self.listClass = 'list';
            self.searchClass = 'search';
            self.sortClass = 'sort';
            self.page = 10000;
            self.i = 1;
            self.items = [];
            self.visibleItems = [];
            self.matchingItems = [];
            self.searched = false;
            self.filtered = false;
            self.searchColumns = undefined;
            self.searchDelay = 0;
            self.handlers = {
                updated: []
            };
            self.valueNames = [];
            self.utils = {
                getByClass: $fLPVz,
                extend: $8UWm9,
                indexOf: $86c9F,
                events: $7q4zh,
                toString: $dWCJP,
                naturalSort: $8qGk4,
                classes: $lJ2hG,
                getAttribute: $5rrWn,
                toArray: $gj517
            };
            self.utils.extend(self, options);
            self.listContainer = typeof id === 'string' ? document.getElementById(id) : id;
            if (!self.listContainer) return;
            self.list = $fLPVz(self.listContainer, self.listClass, true);
            self.parse = (parcelRequire("inQRm"))(self);
            self.templater = (parcelRequire("9x9tg"))(self);
            self.search = (parcelRequire("3I4XJ"))(self);
            self.filter = (parcelRequire("48Udb"))(self);
            self.sort = (parcelRequire("hk5LX"))(self);
            self.fuzzySearch = (parcelRequire("jZlBF"))(self, options.fuzzySearch);
            this.handlers();
            this.items();
            this.pagination();
            self.update();
        },
        handlers: function() {
            for(var handler in self.handlers)if (self[handler] && self.handlers.hasOwnProperty(handler)) self.on(handler, self[handler]);
        },
        items: function() {
            self.parse(self.list);
            if (values !== undefined) self.add(values);
        },
        pagination: function() {
            if (options.pagination !== undefined) {
                if (options.pagination === true) options.pagination = [
                    {}
                ];
                if (options.pagination[0] === undefined) options.pagination = [
                    options.pagination
                ];
                for(var i = 0, il = options.pagination.length; i < il; i++)initPagination(options.pagination[i]);
            }
        }
    };
    /*
   * Re-parse the List, use if html have changed
   */ this.reIndex = function() {
        self.items = [];
        self.visibleItems = [];
        self.matchingItems = [];
        self.searched = false;
        self.filtered = false;
        self.parse(self.list);
    };
    this.toJSON = function() {
        var json = [];
        for(var i = 0, il = self.items.length; i < il; i++)json.push(self.items[i].values());
        return json;
    };
    /*
   * Add object to list
   */ this.add = function(values, callback) {
        if (values.length === 0) return;
        if (callback) {
            addAsync(values.slice(0), callback);
            return;
        }
        var added = [], notCreate = false;
        if (values[0] === undefined) values = [
            values
        ];
        for(var i = 0, il = values.length; i < il; i++){
            var item = null;
            notCreate = self.items.length > self.page ? true : false;
            item = new Item(values[i], undefined, notCreate);
            self.items.push(item);
            added.push(item);
        }
        self.update();
        return added;
    };
    this.show = function(i, page) {
        this.i = i;
        this.page = page;
        self.update();
        return self;
    };
    /* Removes object from list.
   * Loops through the list and removes objects where
   * property "valuename" === value
   */ this.remove = function(valueName, value, options) {
        var found = 0;
        for(var i = 0, il = self.items.length; i < il; i++)if (self.items[i].values()[valueName] == value) {
            self.templater.remove(self.items[i], options);
            self.items.splice(i, 1);
            il--;
            i--;
            found++;
        }
        self.update();
        return found;
    };
    /* Gets the objects in the list which
   * property "valueName" === value
   */ this.get = function(valueName, value) {
        var matchedItems = [];
        for(var i = 0, il = self.items.length; i < il; i++){
            var item = self.items[i];
            if (item.values()[valueName] == value) matchedItems.push(item);
        }
        return matchedItems;
    };
    /*
   * Get size of the list
   */ this.size = function() {
        return self.items.length;
    };
    /*
   * Removes all items from the list
   */ this.clear = function() {
        self.templater.clear();
        self.items = [];
        return self;
    };
    this.on = function(event, callback) {
        self.handlers[event].push(callback);
        return self;
    };
    this.off = function(event, callback) {
        var e = self.handlers[event];
        var index = $86c9F(e, callback);
        if (index > -1) e.splice(index, 1);
        return self;
    };
    this.trigger = function(event) {
        var i = self.handlers[event].length;
        while(i--)self.handlers[event][i](self);
        return self;
    };
    this.reset = {
        filter: function() {
            var is = self.items, il = is.length;
            while(il--)is[il].filtered = false;
            return self;
        },
        search: function() {
            var is = self.items, il = is.length;
            while(il--)is[il].found = false;
            return self;
        }
    };
    this.update = function() {
        var is = self.items, il = is.length;
        self.visibleItems = [];
        self.matchingItems = [];
        self.templater.clear();
        for(var i = 0; i < il; i++){
            if (is[i].matching() && self.matchingItems.length + 1 >= self.i && self.visibleItems.length < self.page) {
                is[i].show();
                self.visibleItems.push(is[i]);
                self.matchingItems.push(is[i]);
            } else if (is[i].matching()) {
                self.matchingItems.push(is[i]);
                is[i].hide();
            } else is[i].hide();
        }
        self.trigger('updated');
        return self;
    };
    init.start();
};

});
parcelRegister("8qGk4", function(module, exports) {
'use strict';
var $623194d84eb71268$var$alphabet;
var $623194d84eb71268$var$alphabetIndexMap;
var $623194d84eb71268$var$alphabetIndexMapLength = 0;
function $623194d84eb71268$var$isNumberCode(code) {
    return code >= 48 && code <= 57;
}
function $623194d84eb71268$var$naturalCompare(a, b) {
    var lengthA = (a += '').length;
    var lengthB = (b += '').length;
    var aIndex = 0;
    var bIndex = 0;
    while(aIndex < lengthA && bIndex < lengthB){
        var charCodeA = a.charCodeAt(aIndex);
        var charCodeB = b.charCodeAt(bIndex);
        if ($623194d84eb71268$var$isNumberCode(charCodeA)) {
            if (!$623194d84eb71268$var$isNumberCode(charCodeB)) return charCodeA - charCodeB;
            var numStartA = aIndex;
            var numStartB = bIndex;
            while(charCodeA === 48 && ++numStartA < lengthA)charCodeA = a.charCodeAt(numStartA);
            while(charCodeB === 48 && ++numStartB < lengthB)charCodeB = b.charCodeAt(numStartB);
            var numEndA = numStartA;
            var numEndB = numStartB;
            while(numEndA < lengthA && $623194d84eb71268$var$isNumberCode(a.charCodeAt(numEndA)))++numEndA;
            while(numEndB < lengthB && $623194d84eb71268$var$isNumberCode(b.charCodeAt(numEndB)))++numEndB;
            var difference = numEndA - numStartA - numEndB + numStartB; // numA length - numB length
            if (difference) return difference;
            while(numStartA < numEndA){
                difference = a.charCodeAt(numStartA++) - b.charCodeAt(numStartB++);
                if (difference) return difference;
            }
            aIndex = numEndA;
            bIndex = numEndB;
            continue;
        }
        if (charCodeA !== charCodeB) {
            if (charCodeA < $623194d84eb71268$var$alphabetIndexMapLength && charCodeB < $623194d84eb71268$var$alphabetIndexMapLength && $623194d84eb71268$var$alphabetIndexMap[charCodeA] !== -1 && $623194d84eb71268$var$alphabetIndexMap[charCodeB] !== -1) return $623194d84eb71268$var$alphabetIndexMap[charCodeA] - $623194d84eb71268$var$alphabetIndexMap[charCodeB];
            return charCodeA - charCodeB;
        }
        ++aIndex;
        ++bIndex;
    }
    if (aIndex >= lengthA && bIndex < lengthB && lengthA >= lengthB) return -1;
    if (bIndex >= lengthB && aIndex < lengthA && lengthB >= lengthA) return 1;
    return lengthA - lengthB;
}
$623194d84eb71268$var$naturalCompare.caseInsensitive = $623194d84eb71268$var$naturalCompare.i = function(a, b) {
    return $623194d84eb71268$var$naturalCompare(('' + a).toLowerCase(), ('' + b).toLowerCase());
};
Object.defineProperties($623194d84eb71268$var$naturalCompare, {
    alphabet: {
        get: function() {
            return $623194d84eb71268$var$alphabet;
        },
        set: function(value) {
            $623194d84eb71268$var$alphabet = value;
            $623194d84eb71268$var$alphabetIndexMap = [];
            var i = 0;
            if ($623194d84eb71268$var$alphabet) for(; i < $623194d84eb71268$var$alphabet.length; i++)$623194d84eb71268$var$alphabetIndexMap[$623194d84eb71268$var$alphabet.charCodeAt(i)] = i;
            $623194d84eb71268$var$alphabetIndexMapLength = $623194d84eb71268$var$alphabetIndexMap.length;
            for(i = 0; i < $623194d84eb71268$var$alphabetIndexMapLength; i++)if ($623194d84eb71268$var$alphabetIndexMap[i] === undefined) $623194d84eb71268$var$alphabetIndexMap[i] = -1;
        }
    }
});
module.exports = $623194d84eb71268$var$naturalCompare;

});

parcelRegister("fLPVz", function(module, exports) {
/**
 * A cross-browser implementation of getElementsByClass.
 * Heavily based on Dustin Diaz's function: http://dustindiaz.com/getelementsbyclass.
 *
 * Find all elements with class `className` inside `container`.
 * Use `single = true` to increase performance in older browsers
 * when only one element is needed.
 *
 * @param {String} className
 * @param {Element} container
 * @param {Boolean} single
 * @api public
 */ var $b7b386896cb832d2$var$getElementsByClassName = function(container, className, single) {
    if (single) return container.getElementsByClassName(className)[0];
    else return container.getElementsByClassName(className);
};
var $b7b386896cb832d2$var$querySelector = function(container, className, single) {
    className = '.' + className;
    if (single) return container.querySelector(className);
    else return container.querySelectorAll(className);
};
var $b7b386896cb832d2$var$polyfill = function(container, className, single) {
    var classElements = [], tag = '*';
    var els = container.getElementsByTagName(tag);
    var elsLen = els.length;
    var pattern = new RegExp('(^|\\s)' + className + '(\\s|$)');
    for(var i = 0, j = 0; i < elsLen; i++)if (pattern.test(els[i].className)) {
        if (single) return els[i];
        else {
            classElements[j] = els[i];
            j++;
        }
    }
    return classElements;
};
module.exports = function() {
    return function(container, className, single, options) {
        options = options || {};
        if (options.test && options.getElementsByClassName || !options.test && document.getElementsByClassName) return $b7b386896cb832d2$var$getElementsByClassName(container, className, single);
        else if (options.test && options.querySelector || !options.test && document.querySelector) return $b7b386896cb832d2$var$querySelector(container, className, single);
        else return $b7b386896cb832d2$var$polyfill(container, className, single);
    };
}();

});

parcelRegister("8UWm9", function(module, exports) {
/*
 * Source: https://github.com/segmentio/extend
 */ module.exports = function extend(object) {
    // Takes an unlimited number of extenders.
    var args = Array.prototype.slice.call(arguments, 1);
    // For each extender, copy their properties on our object.
    for(var i = 0, source; source = args[i]; i++){
        if (!source) continue;
        for(var property in source)object[property] = source[property];
    }
    return object;
};

});

parcelRegister("dWCJP", function(module, exports) {
module.exports = function(s) {
    s = s === undefined ? '' : s;
    s = s === null ? '' : s;
    s = s.toString();
    return s;
};

});

parcelRegister("5rrWn", function(module, exports) {
/**
 * A cross-browser implementation of getAttribute.
 * Source found here: http://stackoverflow.com/a/3755343/361337 written by Vivin Paliath
 *
 * Return the value for `attr` at `element`.
 *
 * @param {Element} el
 * @param {String} attr
 * @api public
 */ module.exports = function(el, attr) {
    var result = el.getAttribute && el.getAttribute(attr) || null;
    if (!result) {
        var attrs = el.attributes;
        var length = attrs.length;
        for(var i = 0; i < length; i++){
            if (attrs[i] !== undefined) {
                if (attrs[i].nodeName === attr) result = attrs[i].nodeValue;
            }
        }
    }
    return result;
};

});

parcelRegister("inQRm", function(module, exports) {

module.exports = function(list) {
    var Item = (parcelRequire("34BFp"))(list);
    var getChildren = function(parent) {
        var nodes = parent.childNodes, items = [];
        for(var i = 0, il = nodes.length; i < il; i++)// Only textnodes have a data attribute
        if (nodes[i].data === undefined) items.push(nodes[i]);
        return items;
    };
    var parse = function(itemElements, valueNames) {
        for(var i = 0, il = itemElements.length; i < il; i++)list.items.push(new Item(valueNames, itemElements[i]));
    };
    var parseAsync = function(itemElements, valueNames) {
        var itemsToIndex = itemElements.splice(0, 50) // TODO: If < 100 items, what happens in IE etc?
        ;
        parse(itemsToIndex, valueNames);
        if (itemElements.length > 0) setTimeout(function() {
            parseAsync(itemElements, valueNames);
        }, 1);
        else {
            list.update();
            list.trigger('parseComplete');
        }
    };
    list.handlers.parseComplete = list.handlers.parseComplete || [];
    return function() {
        var itemsToIndex = getChildren(list.list), valueNames = list.valueNames;
        if (list.indexAsync) parseAsync(itemsToIndex, valueNames);
        else parse(itemsToIndex, valueNames);
    };
};

});

parcelRegister("9x9tg", function(module, exports) {
var $6f0e8ae4795eecb9$var$Templater = function(list) {
    var createItem, templater = this;
    var init = function() {
        var itemSource;
        if (typeof list.item === 'function') {
            createItem = function(values) {
                var item = list.item(values);
                return getItemSource(item);
            };
            return;
        }
        if (typeof list.item === 'string') {
            if (list.item.indexOf('<') === -1) itemSource = document.getElementById(list.item);
            else itemSource = getItemSource(list.item);
        } else /* If item source does not exists, use the first item in list as
      source for new items */ itemSource = getFirstListItem();
        if (!itemSource) throw new Error("The list needs to have at least one item on init otherwise you'll have to add a template.");
        itemSource = createCleanTemplateItem(itemSource, list.valueNames);
        createItem = function() {
            return itemSource.cloneNode(true);
        };
    };
    var createCleanTemplateItem = function(templateNode, valueNames) {
        var el = templateNode.cloneNode(true);
        el.removeAttribute('id');
        for(var i = 0, il = valueNames.length; i < il; i++){
            var elm = undefined, valueName = valueNames[i];
            if (valueName.data) for(var j = 0, jl = valueName.data.length; j < jl; j++)el.setAttribute('data-' + valueName.data[j], '');
            else if (valueName.attr && valueName.name) {
                elm = list.utils.getByClass(el, valueName.name, true);
                if (elm) elm.setAttribute(valueName.attr, '');
            } else {
                elm = list.utils.getByClass(el, valueName, true);
                if (elm) elm.innerHTML = '';
            }
        }
        return el;
    };
    var getFirstListItem = function() {
        var nodes = list.list.childNodes;
        for(var i = 0, il = nodes.length; i < il; i++){
            // Only textnodes have a data attribute
            if (nodes[i].data === undefined) return nodes[i].cloneNode(true);
        }
        return undefined;
    };
    var getItemSource = function(itemHTML) {
        if (typeof itemHTML !== 'string') return undefined;
        if (/<tr[\s>]/g.exec(itemHTML)) {
            var tbody = document.createElement('tbody');
            tbody.innerHTML = itemHTML;
            return tbody.firstElementChild;
        } else if (itemHTML.indexOf('<') !== -1) {
            var div = document.createElement('div');
            div.innerHTML = itemHTML;
            return div.firstElementChild;
        }
        return undefined;
    };
    var getValueName = function(name) {
        for(var i = 0, il = list.valueNames.length; i < il; i++){
            var valueName = list.valueNames[i];
            if (valueName.data) {
                var data = valueName.data;
                for(var j = 0, jl = data.length; j < jl; j++){
                    if (data[j] === name) return {
                        data: name
                    };
                }
            } else if (valueName.attr && valueName.name && valueName.name == name) return valueName;
            else if (valueName === name) return name;
        }
    };
    var setValue = function(item, name, value) {
        var elm = undefined, valueName = getValueName(name);
        if (!valueName) return;
        if (valueName.data) item.elm.setAttribute('data-' + valueName.data, value);
        else if (valueName.attr && valueName.name) {
            elm = list.utils.getByClass(item.elm, valueName.name, true);
            if (elm) elm.setAttribute(valueName.attr, value);
        } else {
            elm = list.utils.getByClass(item.elm, valueName, true);
            if (elm) elm.innerHTML = value;
        }
    };
    this.get = function(item, valueNames) {
        templater.create(item);
        var values = {};
        for(var i = 0, il = valueNames.length; i < il; i++){
            var elm = undefined, valueName = valueNames[i];
            if (valueName.data) for(var j = 0, jl = valueName.data.length; j < jl; j++)values[valueName.data[j]] = list.utils.getAttribute(item.elm, 'data-' + valueName.data[j]);
            else if (valueName.attr && valueName.name) {
                elm = list.utils.getByClass(item.elm, valueName.name, true);
                values[valueName.name] = elm ? list.utils.getAttribute(elm, valueName.attr) : '';
            } else {
                elm = list.utils.getByClass(item.elm, valueName, true);
                values[valueName] = elm ? elm.innerHTML : '';
            }
        }
        return values;
    };
    this.set = function(item, values) {
        if (!templater.create(item)) {
            for(var v in values)if (values.hasOwnProperty(v)) setValue(item, v, values[v]);
        }
    };
    this.create = function(item) {
        if (item.elm !== undefined) return false;
        item.elm = createItem(item.values());
        templater.set(item, item.values());
        return true;
    };
    this.remove = function(item) {
        if (item.elm.parentNode === list.list) list.list.removeChild(item.elm);
    };
    this.show = function(item) {
        templater.create(item);
        list.list.appendChild(item.elm);
    };
    this.hide = function(item) {
        if (item.elm !== undefined && item.elm.parentNode === list.list) list.list.removeChild(item.elm);
    };
    this.clear = function() {
        /* .innerHTML = ''; fucks up IE */ if (list.list.hasChildNodes()) while(list.list.childNodes.length >= 1)list.list.removeChild(list.list.firstChild);
    };
    init();
};
module.exports = function(list) {
    return new $6f0e8ae4795eecb9$var$Templater(list);
};

});

parcelRegister("3I4XJ", function(module, exports) {
module.exports = function(list) {
    var item, text, columns, searchString, customSearch;
    var prepare = {
        resetList: function() {
            list.i = 1;
            list.templater.clear();
            customSearch = undefined;
        },
        setOptions: function(args) {
            if (args.length == 2 && args[1] instanceof Array) columns = args[1];
            else if (args.length == 2 && typeof args[1] == 'function') {
                columns = undefined;
                customSearch = args[1];
            } else if (args.length == 3) {
                columns = args[1];
                customSearch = args[2];
            } else columns = undefined;
        },
        setColumns: function() {
            if (list.items.length === 0) return;
            if (columns === undefined) columns = list.searchColumns === undefined ? prepare.toArray(list.items[0].values()) : list.searchColumns;
        },
        setSearchString: function(s) {
            s = list.utils.toString(s).toLowerCase();
            s = s.replace(/[-[\]{}()*+?.,\\^$|#]/g, '\\$&') // Escape regular expression characters
            ;
            searchString = s;
        },
        toArray: function(values) {
            var tmpColumn = [];
            for(var name in values)tmpColumn.push(name);
            return tmpColumn;
        }
    };
    var search = {
        list: function() {
            // Extract quoted phrases "word1 word2" from original searchString
            // searchString is converted to lowercase by List.js
            var words = [], phrase, ss = searchString;
            while((phrase = ss.match(/"([^"]+)"/)) !== null){
                words.push(phrase[1]);
                ss = ss.substring(0, phrase.index) + ss.substring(phrase.index + phrase[0].length);
            }
            // Get remaining space-separated words (if any)
            ss = ss.trim();
            if (ss.length) words = words.concat(ss.split(/\s+/));
            for(var k = 0, kl = list.items.length; k < kl; k++){
                var item = list.items[k];
                item.found = false;
                if (!words.length) continue;
                for(var i = 0, il = words.length; i < il; i++){
                    var word_found = false;
                    for(var j = 0, jl = columns.length; j < jl; j++){
                        var values = item.values(), column = columns[j];
                        if (values.hasOwnProperty(column) && values[column] !== undefined && values[column] !== null) {
                            var text = typeof values[column] !== 'string' ? values[column].toString() : values[column];
                            if (text.toLowerCase().indexOf(words[i]) !== -1) {
                                // word found, so no need to check it against any other columns
                                word_found = true;
                                break;
                            }
                        }
                    }
                    // this word not found? no need to check any other words, the item cannot match
                    if (!word_found) break;
                }
                item.found = word_found;
            }
        },
        // Removed search.item() and search.values()
        reset: function() {
            list.reset.search();
            list.searched = false;
        }
    };
    var searchMethod = function(str) {
        list.trigger('searchStart');
        prepare.resetList();
        prepare.setSearchString(str);
        prepare.setOptions(arguments) // str, cols|searchFunction, searchFunction
        ;
        prepare.setColumns();
        if (searchString === '') search.reset();
        else {
            list.searched = true;
            if (customSearch) customSearch(searchString, columns);
            else search.list();
        }
        list.update();
        list.trigger('searchComplete');
        return list.visibleItems;
    };
    list.handlers.searchStart = list.handlers.searchStart || [];
    list.handlers.searchComplete = list.handlers.searchComplete || [];
    list.utils.events.bind(list.utils.getByClass(list.listContainer, list.searchClass), 'keyup', list.utils.events.debounce(function(e) {
        var target = e.target || e.srcElement, alreadyCleared = target.value === '' && !list.searched;
        if (!alreadyCleared) // If oninput already have resetted the list, do nothing
        searchMethod(target.value);
    }, list.searchDelay));
    // Used to detect click on HTML5 clear button
    list.utils.events.bind(list.utils.getByClass(list.listContainer, list.searchClass), 'input', function(e) {
        var target = e.target || e.srcElement;
        if (target.value === '') searchMethod('');
    });
    return searchMethod;
};

});

parcelRegister("48Udb", function(module, exports) {
module.exports = function(list) {
    // Add handlers
    list.handlers.filterStart = list.handlers.filterStart || [];
    list.handlers.filterComplete = list.handlers.filterComplete || [];
    return function(filterFunction) {
        list.trigger('filterStart');
        list.i = 1 // Reset paging
        ;
        list.reset.filter();
        if (filterFunction === undefined) list.filtered = false;
        else {
            list.filtered = true;
            var is = list.items;
            for(var i = 0, il = is.length; i < il; i++){
                var item = is[i];
                if (filterFunction(item)) item.filtered = true;
                else item.filtered = false;
            }
        }
        list.update();
        list.trigger('filterComplete');
        return list.visibleItems;
    };
};

});

parcelRegister("hk5LX", function(module, exports) {
module.exports = function(list) {
    var buttons = {
        els: undefined,
        clear: function() {
            for(var i = 0, il = buttons.els.length; i < il; i++){
                list.utils.classes(buttons.els[i]).remove('asc');
                list.utils.classes(buttons.els[i]).remove('desc');
            }
        },
        getOrder: function(btn) {
            var predefinedOrder = list.utils.getAttribute(btn, 'data-order');
            if (predefinedOrder == 'asc' || predefinedOrder == 'desc') return predefinedOrder;
            else if (list.utils.classes(btn).has('desc')) return 'asc';
            else if (list.utils.classes(btn).has('asc')) return 'desc';
            else return 'asc';
        },
        getInSensitive: function(btn, options) {
            var insensitive = list.utils.getAttribute(btn, 'data-insensitive');
            if (insensitive === 'false') options.insensitive = false;
            else options.insensitive = true;
        },
        setOrder: function(options) {
            for(var i = 0, il = buttons.els.length; i < il; i++){
                var btn = buttons.els[i];
                if (list.utils.getAttribute(btn, 'data-sort') !== options.valueName) continue;
                var predefinedOrder = list.utils.getAttribute(btn, 'data-order');
                if (predefinedOrder == 'asc' || predefinedOrder == 'desc') {
                    if (predefinedOrder == options.order) list.utils.classes(btn).add(options.order);
                } else list.utils.classes(btn).add(options.order);
            }
        }
    };
    var sort = function() {
        list.trigger('sortStart');
        var options = {};
        var target = arguments[0].currentTarget || arguments[0].srcElement || undefined;
        if (target) {
            options.valueName = list.utils.getAttribute(target, 'data-sort');
            buttons.getInSensitive(target, options);
            options.order = buttons.getOrder(target);
        } else {
            options = arguments[1] || options;
            options.valueName = arguments[0];
            options.order = options.order || 'asc';
            options.insensitive = typeof options.insensitive == 'undefined' ? true : options.insensitive;
        }
        buttons.clear();
        buttons.setOrder(options);
        // caseInsensitive
        // alphabet
        var customSortFunction = options.sortFunction || list.sortFunction || null, multi = options.order === 'desc' ? -1 : 1, sortFunction;
        if (customSortFunction) sortFunction = function(itemA, itemB) {
            return customSortFunction(itemA, itemB, options) * multi;
        };
        else sortFunction = function(itemA, itemB) {
            var sort = list.utils.naturalSort;
            sort.alphabet = list.alphabet || options.alphabet || undefined;
            if (!sort.alphabet && options.insensitive) sort = list.utils.naturalSort.caseInsensitive;
            return sort(itemA.values()[options.valueName], itemB.values()[options.valueName]) * multi;
        };
        list.items.sort(sortFunction);
        list.update();
        list.trigger('sortComplete');
    };
    // Add handlers
    list.handlers.sortStart = list.handlers.sortStart || [];
    list.handlers.sortComplete = list.handlers.sortComplete || [];
    buttons.els = list.utils.getByClass(list.listContainer, list.sortClass);
    list.utils.events.bind(buttons.els, 'click', sort);
    list.on('searchStart', buttons.clear);
    list.on('filterStart', buttons.clear);
    return sort;
};

});

parcelRegister("jZlBF", function(module, exports) {
parcelRequire("lJ2hG");

var $7q4zh = parcelRequire("7q4zh");

var $8UWm9 = parcelRequire("8UWm9");

var $dWCJP = parcelRequire("dWCJP");

var $fLPVz = parcelRequire("fLPVz");

var $haMCZ = parcelRequire("haMCZ");
module.exports = function(list, options) {
    options = options || {};
    options = $8UWm9({
        location: 0,
        distance: 100,
        threshold: 0.4,
        multiSearch: true,
        searchClass: 'fuzzy-search'
    }, options);
    var fuzzySearch = {
        search: function(searchString, columns) {
            // Substract arguments from the searchString or put searchString as only argument
            var searchArguments = options.multiSearch ? searchString.replace(/ +$/, '').split(/ +/) : [
                searchString
            ];
            for(var k = 0, kl = list.items.length; k < kl; k++)fuzzySearch.item(list.items[k], columns, searchArguments);
        },
        item: function(item, columns, searchArguments) {
            var found = true;
            for(var i = 0; i < searchArguments.length; i++){
                var foundArgument = false;
                for(var j = 0, jl = columns.length; j < jl; j++)if (fuzzySearch.values(item.values(), columns[j], searchArguments[i])) foundArgument = true;
                if (!foundArgument) found = false;
            }
            item.found = found;
        },
        values: function(values, value, searchArgument) {
            if (values.hasOwnProperty(value)) {
                var text = $dWCJP(values[value]).toLowerCase();
                if ($haMCZ(text, searchArgument, options)) return true;
            }
            return false;
        }
    };
    $7q4zh.bind($fLPVz(list.listContainer, options.searchClass), 'keyup', list.utils.events.debounce(function(e) {
        var target = e.target || e.srcElement // IE have srcElement
        ;
        list.search(target.value, fuzzySearch.search);
    }, list.searchDelay));
    return function(str, columns) {
        list.search(str, columns, fuzzySearch.search);
    };
};

});
parcelRegister("haMCZ", function(module, exports) {
module.exports = function(text, pattern, options) {
    // Aproximately where in the text is the pattern expected to be found?
    var Match_Location = options.location || 0;
    //Determines how close the match must be to the fuzzy location (specified above). An exact letter match which is 'distance' characters away from the fuzzy location would score as a complete mismatch. A distance of '0' requires the match be at the exact location specified, a threshold of '1000' would require a perfect match to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    var Match_Distance = options.distance || 100;
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match (of both letters and location), a threshold of '1.0' would match anything.
    var Match_Threshold = options.threshold || 0.4;
    if (pattern === text) return true // Exact match
    ;
    if (pattern.length > 32) return false // This algorithm cannot be used
    ;
    // Set starting location at beginning text and initialise the alphabet.
    var loc = Match_Location, s = function() {
        var q = {}, i;
        for(i = 0; i < pattern.length; i++)q[pattern.charAt(i)] = 0;
        for(i = 0; i < pattern.length; i++)q[pattern.charAt(i)] |= 1 << pattern.length - i - 1;
        return q;
    }();
    // Compute and return the score for a match with e errors and x location.
    // Accesses loc and pattern through being a closure.
    function match_bitapScore_(e, x) {
        var accuracy = e / pattern.length, proximity = Math.abs(loc - x);
        if (!Match_Distance) // Dodge divide by zero error.
        return proximity ? 1.0 : accuracy;
        return accuracy + proximity / Match_Distance;
    }
    var score_threshold = Match_Threshold, best_loc = text.indexOf(pattern, loc) // Is there a nearby exact match? (speedup)
    ;
    if (best_loc != -1) {
        score_threshold = Math.min(match_bitapScore_(0, best_loc), score_threshold);
        // What about in the other direction? (speedup)
        best_loc = text.lastIndexOf(pattern, loc + pattern.length);
        if (best_loc != -1) score_threshold = Math.min(match_bitapScore_(0, best_loc), score_threshold);
    }
    // Initialise the bit arrays.
    var matchmask = 1 << pattern.length - 1;
    best_loc = -1;
    var bin_min, bin_mid;
    var bin_max = pattern.length + text.length;
    var last_rd;
    for(var d = 0; d < pattern.length; d++){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from 'loc' we can stray at this
        // error level.
        bin_min = 0;
        bin_mid = bin_max;
        while(bin_min < bin_mid){
            if (match_bitapScore_(d, loc + bin_mid) <= score_threshold) bin_min = bin_mid;
            else bin_max = bin_mid;
            bin_mid = Math.floor((bin_max - bin_min) / 2 + bin_min);
        }
        // Use the result from this iteration as the maximum for the next.
        bin_max = bin_mid;
        var start = Math.max(1, loc - bin_mid + 1);
        var finish = Math.min(loc + bin_mid, text.length) + pattern.length;
        var rd = Array(finish + 2);
        rd[finish + 1] = (1 << d) - 1;
        for(var j = finish; j >= start; j--){
            // The alphabet (s) is a sparse hash, so the following line generates
            // warnings.
            var charMatch = s[text.charAt(j - 1)];
            if (d === 0) // First pass: exact match.
            rd[j] = (rd[j + 1] << 1 | 1) & charMatch;
            else // Subsequent passes: fuzzy match.
            rd[j] = (rd[j + 1] << 1 | 1) & charMatch | ((last_rd[j + 1] | last_rd[j]) << 1 | 1) | last_rd[j + 1];
            if (rd[j] & matchmask) {
                var score = match_bitapScore_(d, j - 1);
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (score <= score_threshold) {
                    // Told you so.
                    score_threshold = score;
                    best_loc = j - 1;
                    if (best_loc > loc) // When passing loc, don't exceed our current distance from loc.
                    start = Math.max(1, 2 * loc - best_loc);
                    else break;
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        if (match_bitapScore_(d + 1, loc) > score_threshold) break;
        last_rd = rd;
    }
    return best_loc < 0 ? false : true;
};

});




// Import CSS

var $9712f78f8da636c4$export$2e2bcd8739ae039 = {
    GE: {
        name: "Gen\xe8ve",
        flag: "\uD83C\uDFD9\uFE0F",
        region: 'Suisse romande',
        status: 'strict',
        statusLabel: "L\xe9gislation stricte & pionni\xe8re",
        summary: "Gen\xe8ve est le canton suisse le plus avanc\xe9 en mati\xe8re de d\xe9carbonation du b\xe2ti. La loi sur l'\xe9nergie du 18 septembre 1988 et son r\xe8glement d'application r\xe9vis\xe9 en 2022 imposent des mesures contraignantes bas\xe9es sur l'indice de d\xe9pense de chaleur (IDC).",
        timeline: [
            {
                date: '2010',
                type: 'past',
                text: "Introduction du r\xe9gime de l'IDC pour les grands propri\xe9taires (immeubles). Premier canton \xe0 imposer un suivi de la consommation \xe9nerg\xe9tique.",
                tag: 'loi'
            },
            {
                date: '1er sept. 2022',
                type: 'past',
                text: "R\xe9vision du r\xe8glement d'application (REn) : abaissement de l'IDC \xe0 450 MJ/m\xb2/an. Lors du remplacement d'une chaudi\xe8re fossile, obligation d'installer un syst\xe8me renouvelable (sauf impossibilit\xe9 technique). Exception : chaudi\xe8re \xe0 condensation autoris\xe9e si \u226530% renouvelable int\xe9gr\xe9.",
                tag: 'ord'
            },
            {
                date: "2022\u20132024",
                type: 'past',
                text: "Notifications IDC envoy\xe9es aux propri\xe9taires de villas et petits immeubles (<5 preneurs de chaleur). Base de calcul sur 3 ans.",
                tag: 'ord'
            },
            {
                date: "D\xe8s 2025",
                type: 'now',
                text: "Premi\xe8res d\xe9cisions d'assainissement rendues pour les petits propri\xe9taires dont l'IDC d\xe9passe le seuil. D\xe9lais n\xe9gociables par convention avec le D\xe9partement du territoire.",
                tag: 'ord'
            },
            {
                date: "Jusqu'en 2035",
                type: 'future',
                text: "R\xe9seau thermique GeniLac en d\xe9ploiement : les propri\xe9taires en zone desservie peuvent diff\xe9rer certains travaux jusqu'au raccordement.",
                tag: 'info'
            },
            {
                date: '2050',
                type: 'future',
                text: "Objectif z\xe9ro fossile total pour le parc b\xe2ti genevois. Align\xe9 sur la strat\xe9gie cantonale et la LCI f\xe9d\xe9rale.",
                tag: 'loi'
            }
        ],
        mazout: "Interdit lors de tout remplacement de chaudi\xe8re depuis 2022 (sauf d\xe9rogation technique prouv\xe9e). Remplacement par renouvelable obligatoire.",
        gaz: "Soumis au m\xeame r\xe9gime IDC que le mazout. Remplacement par renouvelable lors de tout changement d'installation.",
        propane: "Trait\xe9 comme combustible fossile, soumis aux m\xeames restrictions que le mazout.",
        elec: "Les chauffages \xe9lectriques \xe0 r\xe9sistance sont interdits dans les nouvelles constructions (MoPEC 2014 appliqu\xe9). Remplacement encourag\xe9.",
        referendum: null,
        subventions: "Programme B\xe2timents f\xe9d\xe9ral + subventions cantonales genevoises (ScanE). Jusqu'\xe0 30 000 CHF pour le remplacement d'une chaudi\xe8re fossile.",
        source: "R\xe8glement genevois sur l'\xe9nergie (REn) \u2014 DT/GE \xb7 admin.ge.ch"
    },
    VD: {
        name: 'Vaud',
        flag: "\uD83C\uDFD4\uFE0F",
        region: 'Suisse romande',
        status: 'voted',
        statusLabel: "R\xe9f\xe9rendum UDC en cours \u2014 loi suspendue",
        summary: "Le Grand Conseil vaudois a adopt\xe9 le 3 f\xe9vrier 2026 une r\xe9vision ambitieuse de la loi sur l'\xe9nergie (LVLEne). Toutefois, l'UDC Vaud a lanc\xe9 un r\xe9f\xe9rendum le 10 mars 2026. La loi actuelle de 2006 reste applicable jusqu'\xe0 l'issue de la proc\xe9dure.",
        timeline: [
            {
                date: '1er janv. 2025',
                type: 'past',
                text: "D\xe9cret DACCE (RSV 730.051) en vigueur : assainissement obligatoire des chauffages et chauffe-eau \xe9lectriques dans d\xe9lai fix\xe9.",
                tag: 'ord'
            },
            {
                date: "3 f\xe9vr. 2026",
                type: 'past',
                text: "Grand Conseil vaudois adopte la nouvelle LVLEne \xe0 99 voix pour, 31 contre. Fin du chauffage fossile act\xe9e. Assainissement obligatoire pour b\xe2timents >750 m\xb2.",
                tag: 'loi'
            },
            {
                date: '10 mars 2026',
                type: 'now',
                text: "\u26A0\uFE0F L'UDC Vaud lance officiellement le r\xe9f\xe9rendum. R\xe9colte de 12 000 signatures requises en 2 mois.",
                tag: 'ref'
            },
            {
                date: '~mi-mai 2026',
                type: 'future',
                text: "Date limite de d\xe9p\xf4t des signatures r\xe9f\xe9rendaires. Si abouti \u2192 loi suspendue jusqu'\xe0 votation.",
                tag: 'ref'
            },
            {
                date: 'Automne 2026',
                type: 'future',
                text: "Votation populaire vaudoise probable (si r\xe9f\xe9rendum aboutit). La loi de 2026 n'entre pas en vigueur avant ce vote.",
                tag: 'ref'
            },
            {
                date: 'Janv. 2027',
                type: 'future',
                text: "Entr\xe9e en vigueur pr\xe9vue de la nouvelle LVLEne (si votation favorable). Loi actuelle (2006) demeure jusque-l\xe0.",
                tag: 'loi'
            },
            {
                date: '2046',
                type: 'future',
                text: "Date butoir de la nouvelle loi : remplacement de tous les chauffages fossiles (mazout, gaz) par syst\xe8me renouvelable.",
                tag: 'loi'
            }
        ],
        mazout: "Actuellement (loi 2006) : remplacement par fossile encore possible avec CECB obligatoire. Nouvelle loi (si adopt\xe9e) : interdiction du remplacement par fossile, d\xe9lai jusqu'en 2046.",
        gaz: "M\xeame r\xe9gime que mazout. La nouvelle loi pr\xe9voit la fin du gaz comme combustible de chauffage d'ici 2046.",
        propane: "Assimil\xe9 au mazout dans la r\xe9glementation vaudoise.",
        elec: "Chauffages \xe9lectriques : assainissement obligatoire selon d\xe9cret DACCE en vigueur depuis le 1er janvier 2025.",
        referendum: {
            parti: 'UDC Vaud',
            date_lancement: '10 mars 2026',
            signatures: '12 000 en 2 mois',
            votation: 'Automne 2026 (probable)'
        },
        subventions: "Programme B\xe2timents f\xe9d\xe9ral + subventions cantonales vaudoises. 120 millions CHF pr\xe9vus pour la transition (si nouvelle loi adopt\xe9e).",
        source: "LVLEne du 16 mai 2006 \xb7 Nouvelle LVLEne adopt\xe9e le 3 f\xe9vr. 2026 \xb7 vd.ch/energie"
    },
    BE: {
        name: 'Berne',
        flag: "\uD83D\uDC3B",
        region: 'Suisse centrale',
        status: 'voted',
        statusLabel: "R\xe9vision de loi rejet\xe9e en votation (2023)",
        summary: "Le canton de Berne a v\xe9cu un \xe9pisode d\xe9mocratique marquant : la r\xe9vision de la loi sur l'\xe9nergie visant \xe0 r\xe9duire les chauffages fossiles a \xe9t\xe9 rejet\xe9e de justesse par le peuple bernois le 11 juin 2023 (50,6% de non). La loi en vigueur reste la version pr\xe9c\xe9dente, plus permissive.",
        timeline: [
            {
                date: '11 juin 2023',
                type: 'past',
                text: "Votation cantonale : rejet de la r\xe9vision de la loi sur l'\xe9nergie \xe0 50,6%. Les propri\xe9taires pourront continuer \xe0 utiliser le mazout. L'argument d'une hausse des loyers a emport\xe9 le vote.",
                tag: 'ref'
            },
            {
                date: 'Actuellement',
                type: 'now',
                text: "Loi actuelle applicable : obligation de r\xe9nover les chauffages \xe9lectriques dans un d\xe9lai de 20 ans. Pour les fossiles, MoPEC 2014 partiellement int\xe9gr\xe9.",
                tag: 'loi'
            },
            {
                date: "2025\u20132026",
                type: 'future',
                text: "Nouvelle proposition l\xe9gislative attendue, apr\xe8s l'adoption du MoPEC 2025 (ao\xfbt 2025). Le gouvernement bernois devrait pr\xe9senter un nouveau projet.",
                tag: 'loi'
            },
            {
                date: '2050',
                type: 'future',
                text: "Objectif f\xe9d\xe9ral : fin de tous les chauffages fossiles. Le canton devra s'y conformer via le MoPEC 2025.",
                tag: 'loi'
            }
        ],
        mazout: "PAS d'interdiction cantonale. Le remplacement par mazout reste l\xe9gal. La loi r\xe9vis\xe9e ayant \xe9t\xe9 rejet\xe9e, aucune obligation de remplacement.",
        gaz: "M\xeame situation que le mazout. Pas d'interdiction en vigueur.",
        propane: "Pas de restriction cantonale sp\xe9cifique.",
        elec: "Obligation de remplacement des chauffages \xe9lectriques dans un d\xe9lai de 20 ans (loi actuelle, d\xe9j\xe0 en vigueur).",
        referendum: {
            parti: "R\xe9f\xe9rendum citoyen + milieux \xe9conomiques",
            date_lancement: '2023',
            signatures: 'Abouti',
            votation: "11 juin 2023 \u2192 LOI REJET\xc9E (50,6% de non)"
        },
        subventions: "Programme B\xe2timents f\xe9d\xe9ral applicable. Subventions cantonales bernoises disponibles pour remplacement volontaire.",
        source: "Loi bernoise sur l'\xe9nergie (KEnG) \xb7 R\xe9sultat votation du 11 juin 2023"
    },
    BL: {
        name: "B\xe2le-Campagne",
        flag: "\uD83C\uDF3F",
        region: 'Suisse du Nord-Ouest',
        status: 'strict',
        statusLabel: "Parmi les plus stricts \u2014 Interdiction totale d\xe8s 2026",
        summary: "B\xe2le-Campagne est l'un des cantons les plus avanc\xe9s avec une interdiction totale des nouvelles installations de chauffage \xe0 mazout depuis le 1er janvier 2026, m\xeame pour les remplacements.",
        timeline: [
            {
                date: 'Oct. 2024',
                type: 'past',
                text: "Entr\xe9e en vigueur de la loi cantonale sur l'\xe9nergie : interdiction de chauffages fossiles dans les nouvelles constructions.",
                tag: 'loi'
            },
            {
                date: '1er janv. 2026',
                type: 'past',
                text: "Extension de l'interdiction : aucune nouvelle installation de chauffage \xe0 mazout, m\xeame en remplacement d'un chauffage existant (si installation >15 ans). Des exceptions restent possibles.",
                tag: 'loi'
            },
            {
                date: 'Actuellement',
                type: 'now',
                text: "\u26A0\uFE0F Forte hausse des demandes d'installation avant la date butoir signal\xe9e. D\xe9lais administratifs prolong\xe9s.",
                tag: 'ord'
            },
            {
                date: '2050',
                type: 'future',
                text: "Alignement sur l'objectif f\xe9d\xe9ral z\xe9ro fossile.",
                tag: 'loi'
            }
        ],
        mazout: "INTERDIT depuis le 1er janvier 2026 pour tout nouveau remplacement (si installation >15 ans). Seules des exceptions pr\xe9cises sont possibles.",
        gaz: "M\xeame interdiction que le mazout d\xe8s 2026. Seul le renouvelable est autoris\xe9 pour les nouveaux syst\xe8mes.",
        propane: "Assimil\xe9 aux combustibles fossiles \u2014 m\xeame interdiction.",
        elec: "Chauffages \xe9lectriques \xe0 r\xe9sistance interdits dans les nouvelles constructions.",
        referendum: null,
        subventions: "Subventions cantonales + Programme B\xe2timents f\xe9d\xe9ral. D\xe9lais administratifs possibles en raison de la forte demande.",
        source: "Loi sur l'\xe9nergie BL \u2014 Kantonales Energiegesetz (KEG) \xb7 bl.ch"
    },
    BS: {
        name: "B\xe2le-Ville",
        flag: "\uD83C\uDFDB\uFE0F",
        region: 'Suisse du Nord-Ouest',
        status: 'strict',
        statusLabel: "Pr\xe9curseur \u2014 interdiction depuis 2022",
        summary: "B\xe2le-Ville (canton-ville) est pr\xe9curseur avec une interdiction des chauffages fossiles lors des r\xe9novations en vigueur depuis 2022, parmi les premi\xe8res mesures de ce type en Suisse.",
        timeline: [
            {
                date: '2022',
                type: 'past',
                text: "Interdiction de l'installation de chauffages \xe0 \xe9nergie fossile lors de r\xe9novations. Canton-ville pr\xe9curseur national.",
                tag: 'loi'
            },
            {
                date: 'Actuellement',
                type: 'now',
                text: "Loi en vigueur. Remplacement d'une chaudi\xe8re fossile obligatoirement par un syst\xe8me renouvelable.",
                tag: 'loi'
            },
            {
                date: '2050',
                type: 'future',
                text: "Objectif : neutralit\xe9 carbone compl\xe8te du parc b\xe2ti.",
                tag: 'loi'
            }
        ],
        mazout: "INTERDIT lors de toute r\xe9novation depuis 2022. Remplacement obligatoire par une source renouvelable.",
        gaz: "M\xeame interdiction que le mazout depuis 2022.",
        propane: 'Inclus dans les restrictions sur les combustibles fossiles.',
        elec: "Chauffages \xe9lectriques \xe0 r\xe9sistance interdits dans les nouvelles constructions.",
        referendum: null,
        subventions: "Subventions cantonales basloises disponibles + Programme f\xe9d\xe9ral.",
        source: "Loi cantonale BS sur l'\xe9nergie \xb7 Energiegesetz (EnG) \xb7 bs.ch"
    },
    FR: {
        name: 'Fribourg',
        flag: "\u269C\uFE0F",
        region: 'Suisse romande',
        status: 'moderate',
        statusLabel: "L\xe9gislation avanc\xe9e depuis 2020",
        summary: "Fribourg a adopt\xe9 une approche mixte : interdiction des nouvelles installations fossiles pures sans renouvelable d\xe8s 2020, forte incitation financi\xe8re au remplacement des chauffages \xe9lectriques.",
        timeline: [
            {
                date: '1er janv. 2020',
                type: 'past',
                text: "Nouvelle loi sur l'\xe9nergie en vigueur : impossibilit\xe9 d'installer un chauffage \xe0 mazout ou gaz sans l'associer \xe0 une part d'\xe9nergie renouvelable. Nouveau b\xe2timents : fossile seul interdit.",
                tag: 'loi'
            },
            {
                date: 'Depuis 2020',
                type: 'past',
                text: "Enveloppe de 24 millions CHF mise \xe0 disposition pour le remplacement des chauffages \xe9lectriques. Aides financi\xe8res et abattements fiscaux.",
                tag: 'ord'
            },
            {
                date: 'Actuellement',
                type: 'now',
                text: "MoPEC 2014 int\xe9gr\xe9 sans obligation de r\xe9novation syst\xe9matique des chauffages fossiles existants. Chauffage fossile seul interdit pour tout remplacement dans les nouvelles normes.",
                tag: 'loi'
            },
            {
                date: '2025+',
                type: 'future',
                text: "Transposition du MoPEC 2025 en cours. Probables renforcements l\xe9gislatifs.",
                tag: 'loi'
            }
        ],
        mazout: "Interdit sans part renouvelable depuis 2020. Pour les b\xe2timents existants, le remplacement par fossile seul est soumis \xe0 des restrictions.",
        gaz: "M\xeame r\xe9gime que le mazout depuis 2020.",
        propane: "Soumis aux m\xeames restrictions que les combustibles fossiles.",
        elec: "Remplacement fortement encourag\xe9 financi\xe8rement (24 millions CHF). Pas d'obligation dans les d\xe9lais aussi stricts qu'\xe0 Vaud.",
        referendum: null,
        subventions: "Soutiens financiers cantonaux significatifs (24 millions CHF jusqu'en 2025) + Programme B\xe2timents f\xe9d\xe9ral.",
        source: "Loi fribourgeoise sur l'\xe9nergie (LCEn) \xb7 fr.ch/energie"
    },
    NE: {
        name: "Neuch\xe2tel",
        flag: "\uD83C\uDFD4\uFE0F",
        region: 'Suisse romande',
        status: 'strict',
        statusLabel: "Interdiction lors de r\xe9novations",
        summary: "Neuch\xe2tel a adopt\xe9 des mesures strictes interdisant les chauffages fossiles lors des r\xe9novations, align\xe9 sur le MoPEC 2014 avec des dispositions propres.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: "Int\xe9gration compl\xe8te des prescriptions MoPEC 2014 : lors du remplacement d'un chauffage, l'installation de syst\xe8mes fossiles seuls est interdite.",
                tag: 'loi'
            },
            {
                date: 'Actuellement',
                type: 'now',
                text: "Lors de r\xe9novations, le chauffage fossile seul est interdit. Obligation de renouvelable int\xe9gr\xe9.",
                tag: 'loi'
            },
            {
                date: '2025+',
                type: 'future',
                text: 'Transposition du MoPEC 2025 attendue.',
                tag: 'loi'
            }
        ],
        mazout: "Interdit lors des r\xe9novations. Remplacement fossile seul non autoris\xe9.",
        gaz: "M\xeame restriction que le mazout lors de r\xe9novations.",
        propane: 'Inclus dans les restrictions fossiles.',
        elec: 'Interdits dans les nouvelles constructions (MoPEC 2014).',
        referendum: null,
        subventions: "Programme B\xe2timents f\xe9d\xe9ral + aides cantonales neuch\xe2teloises.",
        source: "Loi neuch\xe2teloise sur l'\xe9nergie \xb7 ne.ch"
    },
    ZH: {
        name: 'Zurich',
        flag: "\uD83E\uDD81",
        region: "Suisse al\xe9manique",
        status: 'strict',
        statusLabel: "Remplacement syst\xe9matique obligatoire d'ici 2030",
        summary: "Zurich a introduit en 2022 (accept\xe9 en votation par 62,5% des voix) l'obligation de remplacer syst\xe9matiquement tous les chauffages fossiles, \xe9lectriques et chauffe-eaux \xe9lectriques centraux par des solutions climatiquement neutres, avec une \xe9ch\xe9ance \xe0 2030.",
        timeline: [
            {
                date: 'Nov. 2021',
                type: 'past',
                text: "Votation populaire cantonale : 62,5% des Zurichois acceptent la r\xe9vision de la loi sur l'\xe9nergie imposant la sortie des fossiles.",
                tag: 'ref'
            },
            {
                date: 'Sept. 2022',
                type: 'past',
                text: "Entr\xe9e en vigueur de la loi r\xe9vis\xe9e : principe du remplacement syst\xe9matique de tous les chauffages au mazout, gaz, chauffages \xe9lectriques \xe0 r\xe9sistance et chauffe-eaux \xe9lectriques. Tribunal f\xe9d\xe9ral a confirm\xe9 la constitutionnalit\xe9.",
                tag: 'loi'
            },
            {
                date: "D'ici 2030",
                type: 'future',
                text: "Date butoir : tous les chauffages fossiles existants doivent \xeatre remplac\xe9s par des solutions renouvelables.",
                tag: 'loi'
            },
            {
                date: '2050',
                type: 'future',
                text: "Objectif z\xe9ro fossile total. Align\xe9 sur LCI f\xe9d\xe9rale.",
                tag: 'loi'
            }
        ],
        mazout: "REMPLACEMENT OBLIGATOIRE d'ici 2030. Parmi les lois cantonales les plus strictes de Suisse.",
        gaz: "M\xeame obligation de remplacement que le mazout, d'ici 2030.",
        propane: "Assimil\xe9 aux combustibles fossiles \u2014 m\xeame obligation.",
        elec: "Chauffages \xe9lectriques \xe0 r\xe9sistance et chauffe-eaux \xe9lectriques : remplacement obligatoire \xe9galement d'ici 2030.",
        referendum: {
            parti: 'Votation du 21 nov. 2021',
            date_lancement: '2021',
            signatures: "R\xe9f\xe9rendum abouti",
            votation: "Accept\xe9 \xe0 62,5% \u2014 loi EN VIGUEUR"
        },
        subventions: "Subventions cantonales zurichi et Programme B\xe2timents f\xe9d\xe9ral.",
        source: "Energiegesetz ZH \xb7 Arr\xeat TF confirmant constitutionnalit\xe9 \xb7 zh.ch"
    },
    GL: {
        name: 'Glaris',
        flag: "\uD83C\uDFD4\uFE0F",
        region: 'Suisse orientale',
        status: 'moderate',
        statusLabel: 'Mesures actives depuis 2020',
        summary: "Glaris fait partie des cantons qui ont adopt\xe9 des mesures relativement pr\xe9coces contre les chauffages fossiles, avec une interdiction dans les nouvelles constructions.",
        timeline: [
            {
                date: "2020\u20132022",
                type: 'past',
                text: "Int\xe9gration MoPEC 2014 : interdiction du chauffage fossile seul dans les nouvelles constructions. P\xe9riode de 'sprint final' avant nouvelles normes.",
                tag: 'loi'
            },
            {
                date: 'Actuellement',
                type: 'now',
                text: 'Loi cantonale en vigueur. Restrictions sur les nouvelles installations fossiles.',
                tag: 'loi'
            },
            {
                date: '2025+',
                type: 'future',
                text: 'Transposition MoPEC 2025 en cours.',
                tag: 'loi'
            }
        ],
        mazout: "Interdit dans les nouvelles constructions. Remplacement dans l'existant soumis aux conditions MoPEC 2014.",
        gaz: "M\xeame r\xe9gime que le mazout.",
        propane: 'Soumis aux restrictions fossiles.',
        elec: 'Restrictions en vigueur selon MoPEC 2014.',
        referendum: null,
        subventions: "Programme B\xe2timents f\xe9d\xe9ral.",
        source: "Energiegesetz GL \xb7 gl.ch"
    },
    TI: {
        name: 'Tessin',
        flag: "\uD83C\uDF34",
        region: 'Suisse italophone',
        status: 'progres',
        statusLabel: "En progression \u2014 MoPEC 2014 int\xe9gr\xe9",
        summary: "Le Tessin applique le MoPEC 2014. Les nouvelles constructions doivent utiliser des sources renouvelables. Les b\xe2timents existants sont soumis aux r\xe8gles de remplacement progressif.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: "Int\xe9gration des prescriptions \xe9nerg\xe9tiques cantonales. Restrictions sur les fossiles dans les nouvelles constructions.",
                tag: 'loi'
            },
            {
                date: 'Actuellement',
                type: 'now',
                text: 'Loi cantonale applicable. Part de renouvelable obligatoire lors de tout remplacement de chauffage.',
                tag: 'loi'
            },
            {
                date: '2025+',
                type: 'future',
                text: "Transposition MoPEC 2025 pr\xe9vue.",
                tag: 'loi'
            }
        ],
        mazout: 'Restrictions lors du remplacement (part renouvelable obligatoire). Nouvelles constructions : fossile interdit.',
        gaz: "M\xeame r\xe9gime que le mazout.",
        propane: 'Soumis aux restrictions fossiles cantonales.',
        elec: "Chauffages \xe9lectriques soumis aux restrictions MoPEC 2014.",
        referendum: null,
        subventions: "Programme B\xe2timents f\xe9d\xe9ral + aides cantonales tessinoises.",
        source: "Legge sull'energia TI \xb7 ti.ch"
    },
    VS: {
        name: 'Valais',
        flag: "\u26F0\uFE0F",
        region: 'Suisse romande',
        status: 'progres',
        statusLabel: "En transition \u2014 MoPEC 2014 int\xe9gr\xe9",
        summary: "Le Valais a int\xe9gr\xe9 le MoPEC 2014. Le canton importe massivement son \xe9nergie et travaille \xe0 sa transition. La g\xe9othermie et le solaire pr\xe9sentent un potentiel important.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: "Int\xe9gration des prescriptions MoPEC 2014 dans la loi cantonale sur l'\xe9nergie.",
                tag: 'loi'
            },
            {
                date: 'Actuellement',
                type: 'now',
                text: 'Restrictions sur les nouvelles installations fossiles. Part de renouvelable obligatoire lors du remplacement.',
                tag: 'loi'
            },
            {
                date: '2025+',
                type: 'future',
                text: "Transposition MoPEC 2025 en cours d'int\xe9gration cantonale.",
                tag: 'loi'
            }
        ],
        mazout: 'Nouvelles constructions : fossile interdit seul. Remplacement : part renouvelable obligatoire.',
        gaz: "M\xeame r\xe9gime que le mazout.",
        propane: 'Inclus dans les restrictions fossiles.',
        elec: 'Restrictions MoPEC 2014 en vigueur.',
        referendum: null,
        subventions: "Programme B\xe2timents f\xe9d\xe9ral + subventions cantonales valaisannes.",
        source: "Loi valaisanne sur l'\xe9nergie (LCEn-VS) \xb7 vs.ch"
    },
    JU: {
        name: 'Jura',
        flag: "\uD83C\uDFDE\uFE0F",
        region: 'Suisse romande',
        status: 'federal',
        statusLabel: "Cadre f\xe9d\xe9ral \u2014 MoPEC 2014 int\xe9gr\xe9",
        summary: "Le Jura applique le cadre MoPEC 2014. La transition est progressive, soutenue par les m\xe9canismes f\xe9d\xe9raux.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Application des prescriptions MoPEC 2014.',
                tag: 'loi'
            },
            {
                date: 'Actuellement',
                type: 'now',
                text: 'Restrictions fossiles dans les nouvelles constructions. MoPEC 2025 en cours de transposition.',
                tag: 'loi'
            }
        ],
        mazout: 'Nouvelles constructions : part renouvelable obligatoire. Restrictions lors du remplacement.',
        gaz: "M\xeame r\xe9gime que le mazout.",
        propane: 'Soumis aux restrictions fossiles.',
        elec: 'Restrictions MoPEC 2014.',
        referendum: null,
        subventions: "Programme B\xe2timents f\xe9d\xe9ral.",
        source: "Loi jurassienne sur les \xe9conomies d'\xe9nergie \xb7 jura.ch"
    },
    AG: {
        name: 'Argovie',
        flag: "\uD83C\uDF3E",
        region: "Suisse al\xe9manique",
        status: 'moderate',
        statusLabel: "MoPEC 2014 appliqu\xe9",
        summary: "Argovie applique les prescriptions MoPEC 2014 et travaille \xe0 la transposition du MoPEC 2025.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: "Int\xe9gration dans la loi cantonale sur l'\xe9nergie.",
                tag: 'loi'
            },
            {
                date: 'Actuellement',
                type: 'now',
                text: 'Restrictions en vigueur. Part renouvelable requise lors de tout remplacement.',
                tag: 'loi'
            },
            {
                date: '2025+',
                type: 'future',
                text: 'Transposition MoPEC 2025.',
                tag: 'loi'
            }
        ],
        mazout: 'Restrictions en vigueur lors du remplacement (part renouvelable requise).',
        gaz: "M\xeame r\xe9gime.",
        propane: 'Soumis aux restrictions fossiles.',
        elec: 'Restrictions MoPEC 2014.',
        referendum: null,
        subventions: "Programme B\xe2timents f\xe9d\xe9ral + aides cantonales.",
        source: "Energiegesetz AG \xb7 ag.ch"
    },
    SO: {
        name: 'Soleure',
        flag: "\uD83C\uDFF0",
        region: "Suisse al\xe9manique",
        status: 'moderate',
        statusLabel: "MoPEC 2014 int\xe9gr\xe9",
        summary: 'Soleure applique le MoPEC 2014 avec les restrictions standard sur les combustibles fossiles.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: "Int\xe9gration MoPEC 2014. Restrictions fossiles dans les nouvelles constructions.",
                tag: 'loi'
            },
            {
                date: '2025+',
                type: 'future',
                text: 'Transposition MoPEC 2025.',
                tag: 'loi'
            }
        ],
        mazout: 'Part renouvelable obligatoire lors du remplacement.',
        gaz: "M\xeame r\xe9gime.",
        propane: 'Restrictions fossiles.',
        elec: 'Restrictions MoPEC 2014.',
        referendum: null,
        subventions: "Programme B\xe2timents + aides cantonales.",
        source: "Energiegesetz SO \xb7 so.ch"
    },
    LU: {
        name: 'Lucerne',
        flag: "\uD83C\uDFD4\uFE0F",
        region: 'Suisse centrale',
        status: 'moderate',
        statusLabel: "MoPEC 2014 int\xe9gr\xe9",
        summary: 'Lucerne applique le MoPEC 2014.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: "Int\xe9gration dans la loi cantonale.",
                tag: 'loi'
            },
            {
                date: '2025+',
                type: 'future',
                text: 'Transposition MoPEC 2025.',
                tag: 'loi'
            }
        ],
        mazout: 'Part renouvelable obligatoire lors du remplacement.',
        gaz: "M\xeame r\xe9gime.",
        propane: 'Restrictions fossiles.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: "Programme B\xe2timents + aides cantonales.",
        source: "Energiegesetz LU \xb7 lu.ch"
    },
    SG: {
        name: 'Saint-Gall',
        flag: "\uD83C\uDFA8",
        region: 'Suisse orientale',
        status: 'moderate',
        statusLabel: 'Restrictions en vigueur',
        summary: "Saint-Gall a connu un \"sprint final\" pour les installations de mazout avant l'entr\xe9e en vigueur des nouvelles normes (2021-2022). Les restrictions MoPEC 2014 s'appliquent.",
        timeline: [
            {
                date: '2021-2022',
                type: 'past',
                text: 'Sprint final : nombreuses installations de mazout avant nouvelles normes.',
                tag: 'ord'
            },
            {
                date: 'Actuellement',
                type: 'now',
                text: "MoPEC 2014 appliqu\xe9. Restrictions lors du remplacement.",
                tag: 'loi'
            }
        ],
        mazout: 'Part renouvelable requise lors du remplacement.',
        gaz: "M\xeame r\xe9gime.",
        propane: 'Restrictions fossiles.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: "Programme B\xe2timents f\xe9d\xe9ral.",
        source: "Energiegesetz SG \xb7 sg.ch"
    },
    TG: {
        name: 'Thurgovie',
        flag: "\uD83C\uDF4E",
        region: 'Suisse orientale',
        status: 'federal',
        statusLabel: "Cadre f\xe9d\xe9ral / MoPEC 2014",
        summary: 'Thurgovie applique le MoPEC 2014.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: "Int\xe9gration.",
                tag: 'loi'
            }
        ],
        mazout: 'Restrictions MoPEC 2014.',
        gaz: "M\xeame r\xe9gime.",
        propane: 'Restrictions fossiles.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: "Programme B\xe2timents f\xe9d\xe9ral.",
        source: "Energiegesetz TG \xb7 tg.ch"
    },
    SH: {
        name: 'Schaffhouse',
        flag: "\uD83D\uDC02",
        region: "Suisse al\xe9manique",
        status: 'federal',
        statusLabel: "Cadre f\xe9d\xe9ral / MoPEC 2014",
        summary: 'Schaffhouse applique le MoPEC 2014.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: "Int\xe9gration.",
                tag: 'loi'
            }
        ],
        mazout: 'Restrictions MoPEC 2014.',
        gaz: "M\xeame r\xe9gime.",
        propane: 'Restrictions fossiles.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: "Programme B\xe2timents f\xe9d\xe9ral.",
        source: "Energiegesetz SH \xb7 sh.ch"
    },
    ZG: {
        name: 'Zoug',
        flag: "\uD83D\uDC8E",
        region: 'Suisse centrale',
        status: 'federal',
        statusLabel: "Cadre f\xe9d\xe9ral / MoPEC 2014",
        summary: 'Zoug applique le MoPEC 2014.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: "Int\xe9gration.",
                tag: 'loi'
            }
        ],
        mazout: 'Restrictions MoPEC 2014.',
        gaz: "M\xeame r\xe9gime.",
        propane: 'Restrictions fossiles.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: "Programme B\xe2timents f\xe9d\xe9ral.",
        source: "Energiegesetz ZG \xb7 zg.ch"
    },
    GR: {
        name: 'Grisons',
        flag: "\uD83E\uDD85",
        region: 'Suisse orientale',
        status: 'federal',
        statusLabel: "Cadre f\xe9d\xe9ral / MoPEC 2014",
        summary: 'Les Grisons appliquent le MoPEC 2014.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: "Int\xe9gration.",
                tag: 'loi'
            }
        ],
        mazout: 'Restrictions MoPEC 2014.',
        gaz: "M\xeame r\xe9gime.",
        propane: 'Restrictions fossiles.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: "Programme B\xe2timents f\xe9d\xe9ral.",
        source: "Energiegesetz GR \xb7 gr.ch"
    },
    UR: {
        name: 'Uri',
        flag: "\u26F0\uFE0F",
        region: 'Suisse centrale',
        status: 'federal',
        statusLabel: "Cadre f\xe9d\xe9ral / MoPEC 2014",
        summary: 'Uri applique le MoPEC 2014.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: "Int\xe9gration.",
                tag: 'loi'
            }
        ],
        mazout: 'Restrictions MoPEC 2014.',
        gaz: "M\xeame r\xe9gime.",
        propane: 'Restrictions fossiles.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: "Programme B\xe2timents f\xe9d\xe9ral.",
        source: "Energiegesetz UR \xb7 ur.ch"
    },
    SZ: {
        name: 'Schwyz',
        flag: "\uD83C\uDFD4\uFE0F",
        region: 'Suisse centrale',
        status: 'federal',
        statusLabel: "Cadre f\xe9d\xe9ral / MoPEC 2014",
        summary: 'Schwyz applique le MoPEC 2014.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: "Int\xe9gration.",
                tag: 'loi'
            }
        ],
        mazout: 'Restrictions MoPEC 2014.',
        gaz: "M\xeame r\xe9gime.",
        propane: 'Restrictions fossiles.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: "Programme B\xe2timents f\xe9d\xe9ral.",
        source: "Energiegesetz SZ \xb7 sz.ch"
    },
    OW: {
        name: 'Obwald',
        flag: "\uD83C\uDF32",
        region: 'Suisse centrale',
        status: 'federal',
        statusLabel: "Cadre f\xe9d\xe9ral / MoPEC 2014",
        summary: 'Obwald applique le MoPEC 2014.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: "Int\xe9gration.",
                tag: 'loi'
            }
        ],
        mazout: 'Restrictions MoPEC 2014.',
        gaz: "M\xeame r\xe9gime.",
        propane: 'Restrictions fossiles.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: "Programme B\xe2timents f\xe9d\xe9ral.",
        source: "Energiegesetz OW \xb7 ow.ch"
    },
    NW: {
        name: 'Nidwald',
        flag: "\uD83C\uDF32",
        region: 'Suisse centrale',
        status: 'federal',
        statusLabel: "Cadre f\xe9d\xe9ral / MoPEC 2014",
        summary: 'Nidwald applique le MoPEC 2014.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: "Int\xe9gration.",
                tag: 'loi'
            }
        ],
        mazout: 'Restrictions MoPEC 2014.',
        gaz: "M\xeame r\xe9gime.",
        propane: 'Restrictions fossiles.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: "Programme B\xe2timents f\xe9d\xe9ral.",
        source: "Energiegesetz NW \xb7 nw.ch"
    },
    AI: {
        name: 'Appenzell Rh.-Int.',
        flag: "\uD83D\uDC04",
        region: 'Suisse orientale',
        status: 'federal',
        statusLabel: "Cadre f\xe9d\xe9ral / MoPEC 2014",
        summary: 'AI applique le MoPEC 2014.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: "Int\xe9gration.",
                tag: 'loi'
            }
        ],
        mazout: 'Restrictions MoPEC 2014.',
        gaz: "M\xeame r\xe9gime.",
        propane: 'Restrictions fossiles.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: "Programme B\xe2timents f\xe9d\xe9ral.",
        source: "Energiegesetz AI \xb7 ai.ch"
    },
    AR: {
        name: 'Appenzell Rh.-Ext.',
        flag: "\uD83D\uDC04",
        region: 'Suisse orientale',
        status: 'federal',
        statusLabel: "Cadre f\xe9d\xe9ral / MoPEC 2014",
        summary: 'AR applique le MoPEC 2014.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: "Int\xe9gration.",
                tag: 'loi'
            }
        ],
        mazout: 'Restrictions MoPEC 2014.',
        gaz: "M\xeame r\xe9gime.",
        propane: 'Restrictions fossiles.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: "Programme B\xe2timents f\xe9d\xe9ral.",
        source: "Energiegesetz AR \xb7 ar.ch"
    }
};



var $4994066c973aafb5$export$2e2bcd8739ae039 = {
    ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039),
    GE: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).GE,
        name: 'Geneva',
        flag: "\uD83C\uDFD9\uFE0F",
        region: 'French-speaking Switzerland',
        status: 'strict',
        statusLabel: 'Strict & pioneering legislation',
        summary: "Geneva is the most advanced Swiss canton in terms of building decarbonization. The Energy Law of September 18, 1988, and its implementing regulation revised in 2022 impose binding measures based on the heat expense index (IDC).",
        timeline: [
            {
                date: '2010',
                type: 'past',
                text: "Introduction of the IDC system for large property owners (apartment buildings). First canton to impose energy consumption monitoring.",
                tag: 'law'
            },
            {
                date: 'Sept. 1, 2022',
                type: 'past',
                text: "Revision of the implementing regulation (REn): lowering of the IDC to 450 MJ/m\xb2/year. When replacing a fossil fuel boiler, obligation to install a renewable system (unless technically impossible). Exception: condensing boiler allowed if \u226530% renewable energy integrated.",
                tag: 'ordinance'
            },
            {
                date: "2022\u20132024",
                type: 'past',
                text: "IDC notifications sent to owners of single-family homes and small buildings (<5 heat consumers). Calculation based on 3 years.",
                tag: 'ordinance'
            },
            {
                date: 'From 2025',
                type: 'now',
                text: "First renovation decisions issued for small owners whose IDC exceeds the threshold. Deadlines negotiable by agreement with the Department of Territory.",
                tag: 'ordinance'
            },
            {
                date: "Until 2035",
                type: 'future',
                text: "GeniLac district heating network being deployed: owners in served areas can postpone certain work until connection.",
                tag: 'info'
            },
            {
                date: '2050',
                type: 'future',
                text: 'Total zero fossil fuel target for the Geneva building stock. Aligned with cantonal strategy and federal LCI.',
                tag: 'law'
            }
        ],
        mazout: 'Prohibited during any boiler replacement since 2022 (unless proven technical exception). Replacement with renewable mandatory.',
        gaz: 'Subject to the same IDC regime as heating oil. Replacement with renewable mandatory whenever changing the system.',
        propane: 'Treated as a fossil fuel, subject to same restrictions as heating oil.',
        elec: 'Electric resistance heating is prohibited in new constructions (MoPEC 2014 applied). Replacement encouraged.',
        referendum: null,
        subventions: 'Federal Buildings Programme + cantonal Geneva subsidies (ScanE). Up to 30,000 CHF for replacing a fossil fuel boiler.',
        source: "R\xe8glement genevois sur l'\xe9nergie (REn) \u2014 DT/GE \xb7 admin.ge.ch"
    },
    VD: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).VD,
        name: 'Vaud',
        flag: "\uD83C\uDFD4\uFE0F",
        region: 'French-speaking Switzerland',
        status: 'voted',
        statusLabel: "Referendum underway \u2014 law suspended",
        summary: "The Vaud Grand Council adopted an ambitious revision of the energy law (LVLEne) on February 3, 2026. However, the UDC Vaud launched a referendum on March 10, 2026. The current law from 2006 remains applicable until the procedure is concluded.",
        timeline: [
            {
                date: 'Jan. 1, 2025',
                type: 'past',
                text: 'DACCE Decree (RSV 730.051) in force: mandatory renovation of electric heating and water heaters within a set deadline.',
                tag: 'ordinance'
            },
            {
                date: 'Feb. 3, 2026',
                type: 'past',
                text: "Vaud Grand Council adopts the new LVLEne with 99 votes for, 31 against. End of fossil fuel heating enacted. Mandatory renovation for buildings >750 m\xb2.",
                tag: 'law'
            },
            {
                date: 'March 10, 2026',
                type: 'now',
                text: "\u26A0\uFE0F UDC Vaud officially launches the referendum. 12,000 signatures required within 2 months.",
                tag: 'ref'
            },
            {
                date: '~mid-May 2026',
                type: 'future',
                text: "Deadline for submitting referendum signatures. If successful \u2192 law suspended until vote.",
                tag: 'ref'
            },
            {
                date: 'Autumn 2026',
                type: 'future',
                text: 'Probable popular vote in Vaud (if referendum succeeds). The 2026 law will not take effect before this vote.',
                tag: 'ref'
            },
            {
                date: 'Jan. 2027',
                type: 'future',
                text: 'Planned entry into force of the new LVLEne (if vote favorable). Current law (2006) remains until then.',
                tag: 'law'
            },
            {
                date: '2046',
                type: 'future',
                text: 'Deadline under the new law: replacement of all fossil fuel heating systems (oil, gas) with renewable systems.',
                tag: 'law'
            }
        ],
        mazout: 'Currently (2006 law): replacement with fossil still possible with mandatory CECB. New law (if adopted): prohibits replacement with fossil, deadline until 2046.',
        gaz: 'Same regime as heating oil. The new law provides for the end of gas as a heating fuel by 2046.',
        propane: 'Treated like heating oil in Vaud regulations.',
        elec: 'Electric heating: mandatory renovation according to DACCE decree in force since January 1, 2025.',
        referendum: {
            party: 'UDC Vaud',
            launch_date: 'March 10, 2026',
            signatures: '12,000 in 2 months',
            vote: 'Autumn 2026 (likely)'
        },
        subventions: 'Federal Buildings Programme + cantonal Vaud subsidies. 120 million CHF planned for the transition (if new law adopted).',
        source: "LVLEne du 16 mai 2006 \xb7 Nouvelle LVLEne adopt\xe9e le 3 f\xe9vr. 2026 \xb7 vd.ch/energie"
    },
    BE: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).BE,
        name: 'Bern',
        flag: "\uD83D\uDC3B",
        region: 'Central Switzerland',
        status: 'voted',
        statusLabel: 'Law revision rejected in referendum (2023)',
        summary: "The canton of Bern experienced a significant democratic episode: the revision of the energy law aimed at reducing fossil fuel heating was narrowly rejected by the Bernese people on June 11, 2023 (50.6% no). The current law remains the previous, more permissive version.",
        timeline: [
            {
                date: 'June 11, 2023',
                type: 'past',
                text: "Cantonal referendum: rejection of the energy law revision by 50.6%. Owners can continue to use heating oil. The argument of rising rents carried the vote.",
                tag: 'ref'
            },
            {
                date: 'Currently',
                type: 'now',
                text: 'Current applicable law: obligation to renovate electric heating within 20 years. For fossil fuels, MoPEC 2014 partially integrated.',
                tag: 'law'
            },
            {
                date: "2025\u20132026",
                type: 'future',
                text: 'New legislative proposal expected, following the adoption of MoPEC 2025 (August 2025). The Bernese government should present a new project.',
                tag: 'law'
            },
            {
                date: '2050',
                type: 'future',
                text: 'Federal target: end of all fossil fuel heating. The canton will have to comply via MoPEC 2025.',
                tag: 'law'
            }
        ],
        mazout: 'NO cantonal ban. Replacement with heating oil remains legal. The revised law having been rejected, no replacement obligation.',
        gaz: 'Same situation as heating oil. No ban in force.',
        propane: 'No specific cantonal restriction.',
        elec: 'Obligation to replace electric heating within 20 years (current law, already in force).',
        referendum: {
            party: 'Citizen referendum + economic circles',
            launch_date: '2023',
            signatures: 'Successful',
            vote: "June 11, 2023 \u2192 LAW REJECTED (50.6% no)"
        },
        subventions: 'Federal Buildings Programme applicable. Bernese cantonal subsidies available for voluntary replacement.',
        source: "Loi bernoise sur l'\xe9nergie (KEnG) \xb7 R\xe9sultat votation du 11 juin 2023"
    },
    BL: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).BL,
        name: 'Basel-Landschaft',
        flag: "\uD83C\uDF3F",
        region: 'Northwestern Switzerland',
        status: 'strict',
        statusLabel: "Among the strictest \u2014 Total ban from 2026",
        summary: "Basel-Landschaft is one of the most advanced cantons with a total ban on new oil heating installations since January 1, 2026, even for replacements.",
        timeline: [
            {
                date: 'Oct. 2024',
                type: 'past',
                text: 'Entry into force of the cantonal energy law: ban on fossil fuel heating in new constructions.',
                tag: 'law'
            },
            {
                date: 'Jan. 1, 2026',
                type: 'past',
                text: 'Extension of the ban: no new oil heating installations, even as a replacement for an existing heating system (if installation >15 years old). Exceptions remain possible.',
                tag: 'law'
            },
            {
                date: 'Currently',
                type: 'now',
                text: "\u26A0\uFE0F Significant increase in installation requests before the deadline reported. Extended administrative delays.",
                tag: 'ordinance'
            },
            {
                date: '2050',
                type: 'future',
                text: 'Alignment with the federal zero fossil fuel target.',
                tag: 'law'
            }
        ],
        mazout: 'BANNED since January 1, 2026 for any new replacement (if installation >15 years old). Only specific exceptions are possible.',
        gaz: 'Same ban as heating oil from 2026. Only renewable energy is allowed for new systems.',
        propane: "Treated as a fossil fuel \u2014 same ban.",
        elec: 'Electric resistance heating prohibited in new constructions.',
        referendum: null,
        subventions: 'Cantonal subsidies + Federal Buildings Programme. Possible administrative delays due to high demand.',
        source: "Loi sur l'\xe9nergie BL \u2014 Kantonales Energiegesetz (KEG) \xb7 bl.ch"
    },
    BS: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).BS,
        name: 'Basel-Stadt',
        flag: "\uD83C\uDFDB\uFE0F",
        region: 'Northwestern Switzerland',
        status: 'strict',
        statusLabel: "Pioneer \u2014 ban since 2022",
        summary: "Basel-Stadt (city-canton) is a pioneer with a ban on fossil fuel heating during renovations in force since 2022, among the first measures of this kind in Switzerland.",
        timeline: [
            {
                date: '2022',
                type: 'past',
                text: 'Ban on installing fossil fuel heating during renovations. Nationally pioneering city-canton.',
                tag: 'law'
            },
            {
                date: 'Currently',
                type: 'now',
                text: 'Law in force. Replacement of a fossil fuel boiler mandatory with a renewable system.',
                tag: 'law'
            },
            {
                date: '2050',
                type: 'future',
                text: 'Target: complete carbon neutrality of the building stock.',
                tag: 'law'
            }
        ],
        mazout: 'BANNED during any renovation since 2022. Mandatory replacement with a renewable source.',
        gaz: 'Same ban as heating oil since 2022.',
        propane: 'Included in restrictions on fossil fuels.',
        elec: 'Electric resistance heating prohibited in new constructions.',
        referendum: null,
        subventions: 'Cantonal Basel subsidies available + Federal Programme.',
        source: "Loi cantonale BS sur l'\xe9nergie \xb7 Energiegesetz (EnG) \xb7 bs.ch"
    },
    FR: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).FR,
        name: 'Fribourg',
        flag: "\u269C\uFE0F",
        region: 'French-speaking Switzerland',
        status: 'moderate',
        statusLabel: 'Advanced legislation since 2020',
        summary: "Fribourg has adopted a mixed approach: ban on new pure fossil fuel installations without renewable energy from 2020, strong financial incentives to replace electric heating.",
        timeline: [
            {
                date: 'Jan. 1, 2020',
                type: 'past',
                text: 'New energy law in force: impossibility of installing oil or gas heating without associating it with a share of renewable energy. New buildings: fossil fuel alone prohibited.',
                tag: 'law'
            },
            {
                date: 'Since 2020',
                type: 'past',
                text: 'Budget of 24 million CHF made available for replacing electric heating. Financial aid and tax reductions.',
                tag: 'ordinance'
            },
            {
                date: 'Currently',
                type: 'now',
                text: "MoPEC 2014 integrated without systematic renovation obligation for existing fossil fuel heating. Fossil fuel heating alone prohibited for any replacement under new standards.",
                tag: 'law'
            },
            {
                date: '2025+',
                type: 'future',
                text: 'Transposition of MoPEC 2025 in progress. Probable legislative reinforcements.',
                tag: 'law'
            }
        ],
        mazout: 'Prohibited without a renewable share since 2020. For existing buildings, replacement with fossil fuel alone is subject to restrictions.',
        gaz: 'Same regime as heating oil since 2020.',
        propane: 'Subject to the same restrictions as fossil fuels.',
        elec: 'Replacement strongly encouraged financially (24 million CHF). No obligation with deadlines as strict as in Vaud.',
        referendum: null,
        subventions: 'Significant cantonal financial support (24 million CHF until 2025) + Federal Buildings Programme.',
        source: "Loi fribourgeoise sur l'\xe9nergie (LCEn) \xb7 fr.ch/energie"
    },
    NE: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).NE,
        name: "Neuch\xe2tel",
        flag: "\uD83C\uDFD4\uFE0F",
        region: 'French-speaking Switzerland',
        status: 'strict',
        statusLabel: 'Ban during renovations',
        summary: "Neuch\xe2tel has adopted strict measures banning fossil fuel heating during renovations, aligned with MoPEC 2014 with its own provisions.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: "Full integration of MoPEC 2014 requirements: when replacing a heating system, installing fossil fuel-only systems is prohibited.",
                tag: 'law'
            },
            {
                date: 'Currently',
                type: 'now',
                text: 'During renovations, fossil fuel heating alone is prohibited. Mandatory integration of renewable energy.',
                tag: 'law'
            },
            {
                date: '2025+',
                type: 'future',
                text: 'Transposition of MoPEC 2025 expected.',
                tag: 'law'
            }
        ],
        mazout: 'Prohibited during renovations. Fossil fuel-only replacement not allowed.',
        gaz: 'Same restriction as heating oil during renovations.',
        propane: 'Included in fossil fuel restrictions.',
        elec: 'Prohibited in new constructions (MoPEC 2014).',
        referendum: null,
        subventions: "Federal Buildings Programme + cantonal Neuch\xe2tel aid.",
        source: "Loi neuch\xe2teloise sur l'\xe9nergie \xb7 ne.ch"
    },
    ZH: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).ZH,
        name: 'Zurich',
        flag: "\uD83E\uDD81",
        region: 'German-speaking Switzerland',
        status: 'strict',
        statusLabel: 'Mandatory systematic replacement by 2030',
        summary: "Zurich introduced in 2022 (accepted by referendum with 62.5% of votes) the obligation to systematically replace all fossil fuel, electric, and central electric water heaters with climate-neutral solutions, with a deadline of 2030.",
        timeline: [
            {
                date: 'Nov. 2021',
                type: 'past',
                text: "Cantonal popular vote: 62.5% of Zurich residents accept the revision of the energy law imposing the phase-out of fossil fuels.",
                tag: 'ref'
            },
            {
                date: 'Sept. 2022',
                type: 'past',
                text: "Entry into force of the revised law: principle of systematic replacement of all oil, gas, electric resistance heaters, and electric water heaters. Federal Court confirmed constitutionality.",
                tag: 'law'
            },
            {
                date: "By 2030",
                type: 'future',
                text: 'Deadline: all existing fossil fuel heating systems must be replaced with renewable solutions.',
                tag: 'law'
            },
            {
                date: '2050',
                type: 'future',
                text: 'Total zero fossil fuel target. Aligned with federal LCI.',
                tag: 'law'
            }
        ],
        mazout: "MANDATORY REPLACEMENT by 2030. Among the strictest cantonal laws in Switzerland.",
        gaz: "Same replacement obligation as heating oil, by 2030.",
        propane: "Treated as a fossil fuel \u2014 same obligation.",
        elec: "Electric resistance heaters and electric water heaters: also mandatory replacement by 2030.",
        referendum: {
            party: 'Referendum of Nov. 21, 2021',
            launch_date: '2021',
            signatures: 'Referendum successful',
            vote: "Accepted by 62.5% \u2014 law IN FORCE"
        },
        subventions: 'Zurich cantonal subsidies + Federal Buildings Programme.',
        source: "Energiegesetz ZH \xb7 Arr\xeat TF confirmant constitutionnalit\xe9 \xb7 zh.ch"
    },
    GL: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).GL,
        name: 'Glarus',
        flag: "\uD83C\uDFD4\uFE0F",
        region: 'Eastern Switzerland',
        status: 'moderate',
        statusLabel: 'Active measures since 2020',
        summary: "Glarus is among the cantons that adopted relatively early measures against fossil fuel heating, with a ban in new constructions.",
        timeline: [
            {
                date: "2020\u20132022",
                type: 'past',
                text: "Integration of MoPEC 2014: ban on fossil fuel heating alone in new constructions. 'Final sprint' period before new standards.",
                tag: 'law'
            },
            {
                date: 'Currently',
                type: 'now',
                text: 'Cantonal law in force. Restrictions on new fossil fuel installations.',
                tag: 'law'
            },
            {
                date: '2025+',
                type: 'future',
                text: 'Transposition of MoPEC 2025 in progress.',
                tag: 'law'
            }
        ],
        mazout: "Prohibited in new constructions. Replacement in existing buildings subject to MoPEC 2014 conditions.",
        gaz: 'Same regime as heating oil.',
        propane: 'Subject to fossil fuel restrictions.',
        elec: 'Restrictions in force according to MoPEC 2014.',
        referendum: null,
        subventions: 'Federal Buildings Programme.',
        source: "Energiegesetz GL \xb7 gl.ch"
    },
    TI: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).TI,
        name: 'Ticino',
        flag: "\uD83C\uDF34",
        region: 'Italian-speaking Switzerland',
        status: 'progres',
        statusLabel: "In progress \u2014 MoPEC 2014 integrated",
        summary: "Ticino applies MoPEC 2014. New constructions must use renewable sources. Existing buildings are subject to progressive replacement rules.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integration of cantonal energy requirements. Restrictions on fossil fuels in new constructions.',
                tag: 'law'
            },
            {
                date: 'Currently',
                type: 'now',
                text: 'Cantonal law applicable. Mandatory share of renewable energy for any heating replacement.',
                tag: 'law'
            },
            {
                date: '2025+',
                type: 'future',
                text: 'Transposition of MoPEC 2025 planned.',
                tag: 'law'
            }
        ],
        mazout: 'Restrictions during replacement (mandatory renewable share). New constructions: fossil fuel prohibited.',
        gaz: 'Same regime as heating oil.',
        propane: 'Subject to cantonal fossil fuel restrictions.',
        elec: 'Electric heating subject to MoPEC 2014 restrictions.',
        referendum: null,
        subventions: 'Federal Buildings Programme + cantonal Ticino aid.',
        source: "Legge sull'energia TI \xb7 ti.ch"
    },
    VS: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).VS,
        name: 'Valais',
        flag: "\u26F0\uFE0F",
        region: 'French-speaking Switzerland',
        status: 'progres',
        statusLabel: "In transition \u2014 MoPEC 2014 integrated",
        summary: "Valais has integrated MoPEC 2014. The canton imports most of its energy and is working on its transition. Geothermal and solar energy have significant potential.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: "Integration of MoPEC 2014 requirements into the cantonal energy law.",
                tag: 'law'
            },
            {
                date: 'Currently',
                type: 'now',
                text: 'Restrictions on new fossil fuel installations. Mandatory renewable share during replacement.',
                tag: 'law'
            },
            {
                date: '2025+',
                type: 'future',
                text: "Transposition of MoPEC 2025 in the process of cantonal integration.",
                tag: 'law'
            }
        ],
        mazout: 'New constructions: fossil fuel alone prohibited. Replacement: mandatory renewable share.',
        gaz: 'Same regime as heating oil.',
        propane: 'Included in fossil fuel restrictions.',
        elec: 'MoPEC 2014 restrictions in force.',
        referendum: null,
        subventions: 'Federal Buildings Programme + cantonal Valais subsidies.',
        source: "Loi valaisanne sur l'\xe9nergie (LCEn-VS) \xb7 vs.ch"
    },
    JU: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).JU,
        name: 'Jura',
        flag: "\uD83C\uDFDE\uFE0F",
        region: 'French-speaking Switzerland',
        status: 'federal',
        statusLabel: "Federal framework \u2014 MoPEC 2014 integrated",
        summary: "Jura applies the MoPEC 2014 framework. The transition is progressive, supported by federal mechanisms.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Application of MoPEC 2014 requirements.',
                tag: 'law'
            },
            {
                date: 'Currently',
                type: 'now',
                text: 'Fossil fuel restrictions in new constructions. MoPEC 2025 transposition in progress.',
                tag: 'law'
            }
        ],
        mazout: 'New constructions: mandatory renewable share. Restrictions during replacement.',
        gaz: 'Same regime as heating oil.',
        propane: 'Subject to fossil fuel restrictions.',
        elec: 'MoPEC 2014 restrictions.',
        referendum: null,
        subventions: 'Federal Buildings Programme.',
        source: "Loi jurassienne sur les \xe9conomies d'\xe9nergie \xb7 jura.ch"
    },
    AG: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).AG,
        name: 'Aargau',
        flag: "\uD83C\uDF3E",
        region: 'German-speaking Switzerland',
        status: 'moderate',
        statusLabel: 'MoPEC 2014 applied',
        summary: "Aargau applies MoPEC 2014 requirements and is working on the transposition of MoPEC 2025.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: "Integration into the cantonal energy law.",
                tag: 'law'
            },
            {
                date: 'Currently',
                type: 'now',
                text: 'Restrictions in force. Mandatory renewable share required for any replacement.',
                tag: 'law'
            },
            {
                date: '2025+',
                type: 'future',
                text: 'Transposition of MoPEC 2025.',
                tag: 'law'
            }
        ],
        mazout: 'Restrictions in force during replacement (mandatory renewable share required).',
        gaz: 'Same regime.',
        propane: 'Subject to fossil fuel restrictions.',
        elec: 'MoPEC 2014 restrictions.',
        referendum: null,
        subventions: 'Federal Buildings Programme + cantonal aid.',
        source: "Energiegesetz AG \xb7 ag.ch"
    },
    SO: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).SO,
        name: 'Solothurn',
        flag: "\uD83C\uDFF0",
        region: 'German-speaking Switzerland',
        status: 'moderate',
        statusLabel: 'MoPEC 2014 integrated',
        summary: "Solothurn applies MoPEC 2014 with standard restrictions on fossil fuels.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integration of MoPEC 2014. Fossil fuel restrictions in new constructions.',
                tag: 'law'
            },
            {
                date: '2025+',
                type: 'future',
                text: 'Transposition of MoPEC 2025.',
                tag: 'law'
            }
        ],
        mazout: 'Mandatory renewable share during replacement.',
        gaz: 'Same regime.',
        propane: 'Fossil fuel restrictions.',
        elec: 'MoPEC 2014 restrictions.',
        referendum: null,
        subventions: 'Federal Buildings Programme + cantonal aid.',
        source: "Energiegesetz SO \xb7 so.ch"
    },
    LU: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).LU,
        name: 'Lucerne',
        flag: "\uD83C\uDFD4\uFE0F",
        region: 'Central Switzerland',
        status: 'moderate',
        statusLabel: 'MoPEC 2014 integrated',
        summary: "Lucerne applies MoPEC 2014.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integration into cantonal law.',
                tag: 'law'
            },
            {
                date: '2025+',
                type: 'future',
                text: 'Transposition of MoPEC 2025.',
                tag: 'law'
            }
        ],
        mazout: 'Mandatory renewable share during replacement.',
        gaz: 'Same regime.',
        propane: 'Fossil fuel restrictions.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: 'Federal Buildings Programme + cantonal aid.',
        source: "Energiegesetz LU \xb7 lu.ch"
    },
    SG: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).SG,
        name: 'St. Gallen',
        flag: "\uD83C\uDFA8",
        region: 'Eastern Switzerland',
        status: 'moderate',
        statusLabel: 'Restrictions in force',
        summary: "St. Gallen experienced a 'final sprint' for oil installations before the entry into force of new standards (2021-2022). MoPEC 2014 restrictions apply.",
        timeline: [
            {
                date: '2021-2022',
                type: 'past',
                text: 'Final sprint: numerous oil installations before new standards.',
                tag: 'ordinance'
            },
            {
                date: 'Currently',
                type: 'now',
                text: 'MoPEC 2014 applied. Restrictions during replacement.',
                tag: 'law'
            }
        ],
        mazout: 'Mandatory renewable share required during replacement.',
        gaz: 'Same regime.',
        propane: 'Fossil fuel restrictions.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: 'Federal Buildings Programme.',
        source: "Energiegesetz SG \xb7 sg.ch"
    },
    TG: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).TG,
        name: 'Thurgau',
        flag: "\uD83C\uDF4E",
        region: 'Eastern Switzerland',
        status: 'federal',
        statusLabel: 'Federal framework / MoPEC 2014',
        summary: "Thurgau applies MoPEC 2014.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integration.',
                tag: 'law'
            }
        ],
        mazout: 'MoPEC 2014 restrictions.',
        gaz: 'Same regime.',
        propane: 'Fossil fuel restrictions.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: 'Federal Buildings Programme.',
        source: "Energiegesetz TG \xb7 tg.ch"
    },
    SH: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).SH,
        name: 'Schaffhausen',
        flag: "\uD83D\uDC02",
        region: 'German-speaking Switzerland',
        status: 'federal',
        statusLabel: 'Federal framework / MoPEC 2014',
        summary: "Schaffhausen applies MoPEC 2014.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integration.',
                tag: 'law'
            }
        ],
        mazout: 'MoPEC 2014 restrictions.',
        gaz: 'Same regime.',
        propane: 'Fossil fuel restrictions.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: 'Federal Buildings Programme.',
        source: "Energiegesetz SH \xb7 sh.ch"
    },
    ZG: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).ZG,
        name: 'Zug',
        flag: "\uD83D\uDC8E",
        region: 'Central Switzerland',
        status: 'federal',
        statusLabel: 'Federal framework / MoPEC 2014',
        summary: "Zug applies MoPEC 2014.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integration.',
                tag: 'law'
            }
        ],
        mazout: 'MoPEC 2014 restrictions.',
        gaz: 'Same regime.',
        propane: 'Fossil fuel restrictions.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: 'Federal Buildings Programme.',
        source: "Energiegesetz ZG \xb7 zg.ch"
    },
    GR: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).GR,
        name: "Graub\xfcnden",
        flag: "\uD83E\uDD85",
        region: 'Eastern Switzerland',
        status: 'federal',
        statusLabel: 'Federal framework / MoPEC 2014',
        summary: "Graub\xfcnden applies MoPEC 2014.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integration.',
                tag: 'law'
            }
        ],
        mazout: 'MoPEC 2014 restrictions.',
        gaz: 'Same regime.',
        propane: 'Fossil fuel restrictions.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: 'Federal Buildings Programme.',
        source: "Energiegesetz GR \xb7 gr.ch"
    },
    UR: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).UR,
        name: 'Uri',
        flag: "\u26F0\uFE0F",
        region: 'Central Switzerland',
        status: 'federal',
        statusLabel: 'Federal framework / MoPEC 2014',
        summary: "Uri applies MoPEC 2014.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integration.',
                tag: 'law'
            }
        ],
        mazout: 'MoPEC 2014 restrictions.',
        gaz: 'Same regime.',
        propane: 'Fossil fuel restrictions.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: 'Federal Buildings Programme.',
        source: "Energiegesetz UR \xb7 ur.ch"
    },
    SZ: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).SZ,
        name: 'Schwyz',
        flag: "\uD83C\uDFD4\uFE0F",
        region: 'Central Switzerland',
        status: 'federal',
        statusLabel: 'Federal framework / MoPEC 2014',
        summary: "Schwyz applies MoPEC 2014.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integration.',
                tag: 'law'
            }
        ],
        mazout: 'MoPEC 2014 restrictions.',
        gaz: 'Same regime.',
        propane: 'Fossil fuel restrictions.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: 'Federal Buildings Programme.',
        source: "Energiegesetz SZ \xb7 sz.ch"
    },
    OW: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).OW,
        name: 'Obwalden',
        flag: "\uD83C\uDF32",
        region: 'Central Switzerland',
        status: 'federal',
        statusLabel: 'Federal framework / MoPEC 2014',
        summary: "Obwalden applies MoPEC 2014.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integration.',
                tag: 'law'
            }
        ],
        mazout: 'MoPEC 2014 restrictions.',
        gaz: 'Same regime.',
        propane: 'Fossil fuel restrictions.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: 'Federal Buildings Programme.',
        source: "Energiegesetz OW \xb7 ow.ch"
    },
    NW: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).NW,
        name: 'Nidwalden',
        flag: "\uD83C\uDF32",
        region: 'Central Switzerland',
        status: 'federal',
        statusLabel: 'Federal framework / MoPEC 2014',
        summary: "Nidwalden applies MoPEC 2014.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integration.',
                tag: 'law'
            }
        ],
        mazout: 'MoPEC 2014 restrictions.',
        gaz: 'Same regime.',
        propane: 'Fossil fuel restrictions.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: 'Federal Buildings Programme.',
        source: "Energiegesetz NW \xb7 nw.ch"
    },
    AI: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).AI,
        name: 'Appenzell Innerrhoden',
        flag: "\uD83D\uDC04",
        region: 'Eastern Switzerland',
        status: 'federal',
        statusLabel: 'Federal framework / MoPEC 2014',
        summary: "AI applies MoPEC 2014.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integration.',
                tag: 'law'
            }
        ],
        mazout: 'MoPEC 2014 restrictions.',
        gaz: 'Same regime.',
        propane: 'Fossil fuel restrictions.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: 'Federal Buildings Programme.',
        source: "Energiegesetz AI \xb7 ai.ch"
    },
    AR: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).VD,
        name: 'Appenzell Ausserrhoden',
        flag: "\uD83D\uDC04",
        region: 'Eastern Switzerland',
        status: 'federal',
        statusLabel: 'Federal framework / MoPEC 2014',
        summary: "AR applies MoPEC 2014.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integration.',
                tag: 'law'
            }
        ],
        mazout: 'MoPEC 2014 restrictions.',
        gaz: 'Same regime.',
        propane: 'Fossil fuel restrictions.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: 'Federal Buildings Programme.',
        source: "Energiegesetz AR \xb7 ar.ch"
    }
};



var $bcff7c38517d3d4a$export$2e2bcd8739ae039 = {
    ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039),
    GE: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).GE,
        name: 'Genf',
        flag: "\uD83C\uDFD9\uFE0F",
        region: 'Westschweiz',
        status: 'strict',
        statusLabel: 'Strenge & pionierhafte Gesetzgebung',
        summary: "Genf ist der fortgeschrittenste Kanton der Schweiz bei der Dekarbonisierung von Geb\xe4uden. Das Energiegesetz vom 18. September 1988 und seine 2022 revidierte Ausf\xfchrungsverordnung schreiben verbindliche Massnahmen auf Basis des W\xe4rmeverbrauchsindexes (IDC) vor.",
        timeline: [
            {
                date: '2010',
                type: 'past',
                text: "Einf\xfchrung des IDC-Regimes f\xfcr grosse Eigent\xfcmer (Mehrfamilienh\xe4user). Erster Kanton mit obligatorischem Energieverbrauchs-Monitoring.",
                tag: 'loi'
            },
            {
                date: '1. Sept. 2022',
                type: 'past',
                text: "Revision der Ausf\xfchrungsverordnung (REn): Senkung des IDC auf 450 MJ/m\xb2/Jahr. Beim Ersatz eines fossilen Heizkessels besteht Pflicht zur Installation eines erneuerbaren Systems (ausser bei technischer Unm\xf6glichkeit). Ausnahme: Brennwertkessel erlaubt, wenn \u226530% erneuerbare Energie integriert.",
                tag: 'ord'
            },
            {
                date: "2022\u20132024",
                type: 'past',
                text: "IDC-Mitteilungen an Eigent\xfcmer von Einfamilienh\xe4usern und kleinen Mehrfamilienh\xe4usern (<5 W\xe4rmebez\xfcger). Berechnungsbasis auf 3 Jahre.",
                tag: 'ord'
            },
            {
                date: 'Ab 2025',
                type: 'now',
                text: "Erste Sanierungsentscheide f\xfcr Kleineigent\xfcmer, deren IDC den Grenzwert \xfcberschreitet. Fristen verhandelbar durch Vereinbarung mit dem D\xe9partement du territoire.",
                tag: 'ord'
            },
            {
                date: "Bis 2035",
                type: 'future',
                text: "Fernw\xe4rmenetz GeniLac im Ausbau: Eigent\xfcmer in versorgten Gebieten k\xf6nnen bestimmte Arbeiten bis zum Anschluss verschieben.",
                tag: 'info'
            },
            {
                date: '2050',
                type: 'future',
                text: "Total Null fossile Energie f\xfcr den Genfer Geb\xe4udepark. Abgestimmt auf kantonale Strategie und Bundesgesetz CO2.",
                tag: 'loi'
            }
        ],
        mazout: 'Bei jedem Kesselersatz seit 2022 verboten (ausser nachgewiesene technische Ausnahme). Ersatz durch erneuerbare Energien obligatorisch.',
        gaz: "Unterliegt gleichem IDC-Regime wie Heiz\xf6l. Ersatz durch erneuerbare Energien bei jedem Anlagenwechsel.",
        propane: "Wird wie fossiler Brennstoff behandelt, unterliegt gleichen Beschr\xe4nkungen wie Heiz\xf6l.",
        elec: "Widerstandsheizungen in Neubauten verboten (MoPEC 2014 angewendet). Ersatz wird gef\xf6rdert.",
        referendum: null,
        subventions: "Bundesprogramm Geb\xe4ude + kantonale Genfer Subventionen (ScanE). Bis zu 30 000 CHF f\xfcr Ersatz eines fossilen Heizkessels.",
        source: "R\xe8glement genevois sur l'\xe9nergie (REn) \u2014 DT/GE \xb7 admin.ge.ch"
    },
    VD: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).VD,
        name: 'Waadt',
        flag: "\uD83C\uDFD4\uFE0F",
        region: 'Westschweiz',
        status: 'voted',
        statusLabel: "SVP-Referendum l\xe4uft \u2014 Gesetz ausgesetzt",
        summary: "Der Waadtl\xe4nder Grosse Rat hat am 3. Februar 2026 eine ehrgeizige Revision des Energiegesetzes (LVLEne) verabschiedet. Die SVP Waadt hat jedoch am 10. M\xe4rz 2026 ein Referendum ergriffen. Das aktuelle Gesetz von 2006 bleibt bis zum Abschluss des Verfahrens anwendbar.",
        timeline: [
            {
                date: '1. Jan. 2025',
                type: 'past',
                text: 'Dekret DACCE (RSV 730.051) in Kraft: obligatorische Sanierung von Heizungen und Elektroboilern innerhalb festgelegter Frist.',
                tag: 'ord'
            },
            {
                date: '3. Febr. 2026',
                type: 'past',
                text: "Waadtl\xe4nder Grosse Rat verabschiedet neue LVLEne mit 99 zu 31 Stimmen. Ende fossiler Heizungen beschlossen. Obligatorische Sanierung f\xfcr Geb\xe4ude >750 m\xb2.",
                tag: 'loi'
            },
            {
                date: "10. M\xe4rz 2026",
                type: 'now',
                text: "\u26A0\uFE0F SVP Waadt lanciert offiziell Referendum. 12 000 Unterschriften innert 2 Monaten erforderlich.",
                tag: 'ref'
            },
            {
                date: '~Mitte Mai 2026',
                type: 'future',
                text: "Frist zur Einreichung der Referendumsunterschriften. Bei Erfolg \u2192 Gesetz bis zur Abstimmung ausgesetzt.",
                tag: 'ref'
            },
            {
                date: 'Herbst 2026',
                type: 'future',
                text: 'Voraussichtliche kantonale Volksabstimmung (falls Referendum zustande kommt). Gesetz von 2026 tritt nicht vor diesem Urnengang in Kraft.',
                tag: 'ref'
            },
            {
                date: 'Jan. 2027',
                type: 'future',
                text: "Geplantes Inkrafttreten der neuen LVLEne (bei Zustimmung). Gesetz von 2006 bleibt bis dahin g\xfcltig.",
                tag: 'loi'
            },
            {
                date: '2046',
                type: 'future',
                text: "Stichtag des neuen Gesetzes: Ersatz aller fossilen Heizungen (\xd6l, Gas) durch erneuerbare Systeme.",
                tag: 'loi'
            }
        ],
        mazout: "Derzeit (Gesetz 2006): Ersatz durch fossil noch m\xf6glich mit obligatorischem CECB. Neues Gesetz (falls angenommen): Verbot von fossilem Ersatz, Frist bis 2046.",
        gaz: "Gleiches Regime wie Heiz\xf6l. Neues Gesetz sieht Ende von Gas als Heizbrennstoff bis 2046 vor.",
        propane: "Im waadtl\xe4ndischen Recht dem Heiz\xf6l gleichgestellt.",
        elec: "Elektroheizungen: obligatorische Sanierung gem\xe4ss Dekret DACCE in Kraft seit 1. Januar 2025.",
        referendum: {
            parti: 'UDC Waadt',
            date_lancement: "10. M\xe4rz 2026",
            signatures: '12 000 in 2 Monaten',
            votation: 'Herbst 2026 (voraussichtlich)'
        },
        subventions: "Bundesprogramm Geb\xe4ude + kantonale Waadtl\xe4nder Subventionen. 120 Mio. CHF f\xfcr die Transition vorgesehen (falls neues Gesetz angenommen).",
        source: "LVLEne du 16 mai 2006 \xb7 Nouvelle LVLEne adopt\xe9e le 3 f\xe9vr. 2026 \xb7 vd.ch/energie"
    },
    BE: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).BE,
        name: 'Bern',
        flag: "\uD83D\uDC3B",
        region: 'Zentralschweiz',
        status: 'voted',
        statusLabel: 'Gesetzesrevision in Volksabstimmung abgelehnt (2023)',
        summary: "Der Kanton Bern erlebte einen bedeutenden demokratischen Moment: Die Revision des Energiegesetzes zur Reduktion fossiler Heizungen wurde vom Stimmvolk am 11. Juni 2023 knapp abgelehnt (50,6% Nein). Das geltende Gesetz bleibt die fr\xfchere, permissivere Version.",
        timeline: [
            {
                date: '11. Juni 2023',
                type: 'past',
                text: "Kantonale Abstimmung: Ablehnung der Energiegesetzrevision mit 50,6%. Eigent\xfcmer k\xf6nnen weiterhin Heiz\xf6l verwenden. Argument der steigenden Mieten setzte sich durch.",
                tag: 'ref'
            },
            {
                date: 'Aktuell',
                type: 'now',
                text: 'Geltendes Gesetz: Pflicht zur Sanierung von Elektroheizungen innert 20 Jahren. Bei fossilen Energien: MoPEC 2014 teilweise integriert.',
                tag: 'loi'
            },
            {
                date: "2025\u20132026",
                type: 'future',
                text: "Neuer Gesetzesvorschlag erwartet, nach Annahme von MoPEC 2025 (August 2025). Berner Regierung d\xfcrfte neues Projekt vorlegen.",
                tag: 'loi'
            },
            {
                date: '2050',
                type: 'future',
                text: 'Bundesziel: Ende aller fossilen Heizungen. Kanton muss sich via MoPEC 2025 anpassen.',
                tag: 'loi'
            }
        ],
        mazout: "KEIN kantonaler Verbot. Ersatz durch Heiz\xf6l bleibt legal. Da revidierte Gesetz abgelehnt, keine Ersatzpflicht.",
        gaz: "Gleiche Situation wie Heiz\xf6l. Kein Verbot in Kraft.",
        propane: "Keine spezifische kantonale Einschr\xe4nkung.",
        elec: 'Pflicht zum Ersatz von Elektroheizungen innert 20 Jahren (geltendes Gesetz, bereits in Kraft).',
        referendum: {
            parti: "B\xfcrgerreferendum + Wirtschaftskreise",
            date_lancement: '2023',
            signatures: 'Zustande gekommen',
            votation: "11. Juni 2023 \u2192 GESETZ ABGELEHNT (50,6% Nein)"
        },
        subventions: "Bundesprogramm Geb\xe4ude anwendbar. Kantonale Berner Subventionen f\xfcr freiwilligen Ersatz verf\xfcgbar.",
        source: "Loi bernoise sur l'\xe9nergie (KEnG) \xb7 R\xe9sultat votation du 11 juin 2023"
    },
    BL: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).BL,
        name: 'Baselland',
        flag: "\uD83C\uDF3F",
        region: 'Nordwestschweiz',
        status: 'strict',
        statusLabel: "Unter den strengsten \u2014 Totalverbot ab 2026",
        summary: "Baselland ist einer der fortschrittlichsten Kantone mit einem Totalverbot neuer \xd6lheizungsinstallationen seit dem 1. Januar 2026, auch f\xfcr Ersatz.",
        timeline: [
            {
                date: 'Okt. 2024',
                type: 'past',
                text: 'Inkrafttreten des kantonalen Energiegesetzes: Verbot fossiler Heizungen in Neubauten.',
                tag: 'loi'
            },
            {
                date: '1. Jan. 2026',
                type: 'past',
                text: "Ausweitung des Verbots: keine neuen \xd6lheizungsinstallationen, auch nicht als Ersatz einer bestehenden Anlage (wenn Anlage >15 Jahre alt). Ausnahmen m\xf6glich.",
                tag: 'loi'
            },
            {
                date: 'Aktuell',
                type: 'now',
                text: "\u26A0\uFE0F Starker Anstieg der Installationsgesuche vor dem Stichtag gemeldet. Verl\xe4ngerte Verwaltungsfristen.",
                tag: 'ord'
            },
            {
                date: '2050',
                type: 'future',
                text: 'Angleichung an Bundes-Ziel Null fossile Energie.',
                tag: 'loi'
            }
        ],
        mazout: "VERBOTEN seit 1. Januar 2026 f\xfcr jeden neuen Ersatz (wenn Anlage >15 Jahre alt). Nur pr\xe4zise Ausnahmen m\xf6glich.",
        gaz: "Gleiches Verbot wie Heiz\xf6l ab 2026. Nur erneuerbare Energien f\xfcr neue Systeme erlaubt.",
        propane: "Fossilen Brennstoffen gleichgestellt \u2014 gleiches Verbot.",
        elec: 'Widerstandsheizungen in Neubauten verboten.',
        referendum: null,
        subventions: "Kantonale Subventionen + Bundesprogramm Geb\xe4ude. Verwaltungsfristen wegen hoher Nachfrage m\xf6glich verl\xe4ngert.",
        source: "Loi sur l'\xe9nergie BL \u2014 Kantonales Energiegesetz (KEG) \xb7 bl.ch"
    },
    BS: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).BS,
        name: 'Basel-Stadt',
        flag: "\uD83C\uDFDB\uFE0F",
        region: 'Nordwestschweiz',
        status: 'strict',
        statusLabel: "Vorreiter \u2014 Verbot seit 2022",
        summary: 'Basel-Stadt (Stadtkanton) ist Vorreiter mit einem Verbot fossiler Heizungen bei Renovationen in Kraft seit 2022, eine der ersten Massnahmen dieser Art in der Schweiz.',
        timeline: [
            {
                date: '2022',
                type: 'past',
                text: 'Verbot der Installation fossiler Heizungen bei Renovationen. Nationaler Vorreiterkanton.',
                tag: 'loi'
            },
            {
                date: 'Aktuell',
                type: 'now',
                text: 'Gesetz in Kraft. Ersatz eines fossilen Kessels obligatorisch durch erneuerbares System.',
                tag: 'loi'
            },
            {
                date: '2050',
                type: 'future',
                text: "Ziel: vollst\xe4ndige CO2-Neutralit\xe4t des Geb\xe4udeparks.",
                tag: 'loi'
            }
        ],
        mazout: 'VERBOTEN bei jeder Renovation seit 2022. Obligatorischer Ersatz durch erneuerbare Quelle.',
        gaz: "Gleiches Verbot wie Heiz\xf6l seit 2022.",
        propane: "In den Beschr\xe4nkungen f\xfcr fossile Brennstoffe enthalten.",
        elec: 'Widerstandsheizungen in Neubauten verboten.',
        referendum: null,
        subventions: "Kantonale Basler Subventionen verf\xfcgbar + Bundesprogramm.",
        source: "Loi cantonale BS sur l'\xe9nergie \xb7 Energiegesetz (EnG) \xb7 bs.ch"
    },
    FR: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).FR,
        name: 'Freiburg',
        flag: "\u269C\uFE0F",
        region: 'Westschweiz',
        status: 'moderate',
        statusLabel: 'Fortschrittliche Gesetzgebung seit 2020',
        summary: "Freiburg hat einen gemischten Ansatz gew\xe4hlt: Verbot neuer reiner fossiler Anlagen ohne erneuerbare Energien ab 2020, starke finanzielle Anreize f\xfcr den Ersatz von Elektroheizungen.",
        timeline: [
            {
                date: '1. Jan. 2020',
                type: 'past',
                text: "Neues Energiegesetz in Kraft: Unm\xf6glichkeit, \xd6l- oder Gasheizung ohne erneuerbaren Energieanteil zu installieren. Neubauten: fossile allein verboten.",
                tag: 'loi'
            },
            {
                date: 'Seit 2020',
                type: 'past',
                text: "Budget von 24 Mio. CHF f\xfcr Ersatz von Elektroheizungen bereitgestellt. Finanzhilfen und Steuerabz\xfcge.",
                tag: 'ord'
            },
            {
                date: 'Aktuell',
                type: 'now',
                text: 'MoPEC 2014 integriert ohne Pflicht zur systematischen Sanierung bestehender fossiler Heizungen. Fossile Heizung allein bei jedem Ersatz nach neuen Normen verboten.',
                tag: 'loi'
            },
            {
                date: '2025+',
                type: 'future',
                text: "Transposition von MoPEC 2025 l\xe4uft. Wahrscheinliche gesetzliche Versch\xe4rfungen.",
                tag: 'loi'
            }
        ],
        mazout: "Seit 2020 ohne erneuerbaren Anteil verboten. Bei Bestandesbauten ist Ersatz durch fossil allein Beschr\xe4nkungen unterworfen.",
        gaz: "Gleiches Regime wie Heiz\xf6l seit 2020.",
        propane: "Unterliegt gleichen Beschr\xe4nkungen wie fossile Brennstoffe.",
        elec: "Ersatz finanziell stark gef\xf6rdert (24 Mio. CHF). Keine Pflicht mit so strengen Fristen wie in der Waadt.",
        referendum: null,
        subventions: "Bedeutende kantonale finanzielle Unterst\xfctzung (24 Mio. CHF bis 2025) + Bundesprogramm Geb\xe4ude.",
        source: "Loi fribourgeoise sur l'\xe9nergie (LCEn) \xb7 fr.ch/energie"
    },
    NE: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).NE,
        name: 'Neuenburg',
        flag: "\uD83C\uDFD4\uFE0F",
        region: 'Westschweiz',
        status: 'strict',
        statusLabel: 'Verbot bei Renovationen',
        summary: 'Neuenburg hat strenge Massnahmen verabschiedet, die fossile Heizungen bei Renovationen verbieten, abgestimmt auf MoPEC 2014 mit eigenen Bestimmungen.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: "Vollst\xe4ndige Integration der MoPEC 2014 Vorschriften: Bei Ersatz einer Heizung ist Installation reiner fossiler Systeme verboten.",
                tag: 'loi'
            },
            {
                date: 'Aktuell',
                type: 'now',
                text: 'Bei Renovationen ist fossile Heizung allein verboten. Pflicht zur Integration erneuerbarer Energien.',
                tag: 'loi'
            },
            {
                date: '2025+',
                type: 'future',
                text: 'Transposition von MoPEC 2025 erwartet.',
                tag: 'loi'
            }
        ],
        mazout: 'Bei Renovationen verboten. Ersatz durch fossil allein nicht erlaubt.',
        gaz: "Gleiche Einschr\xe4nkung wie Heiz\xf6l bei Renovationen.",
        propane: "In fossilen Beschr\xe4nkungen enthalten.",
        elec: 'In Neubauten verboten (MoPEC 2014).',
        referendum: null,
        subventions: "Bundesprogramm Geb\xe4ude + kantonale Neuenburger Hilfen.",
        source: "Loi neuch\xe2teloise sur l'\xe9nergie \xb7 ne.ch"
    },
    ZH: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).ZH,
        name: "Z\xfcrich",
        flag: "\uD83E\uDD81",
        region: 'Deutschschweiz',
        status: 'strict',
        statusLabel: 'Obligatorischer systematischer Ersatz bis 2030',
        summary: "Z\xfcrich hat 2022 (in der Abstimmung mit 62,5% der Stimmen angenommen) die Pflicht eingef\xfchrt, alle fossilen Heizungen, Elektroheizungen und zentralen Elektroboiler systematisch durch klimaneutrale L\xf6sungen zu ersetzen, mit Frist bis 2030.",
        timeline: [
            {
                date: 'Nov. 2021',
                type: 'past',
                text: "Kantonale Volksabstimmung: 62,5% der Z\xfcrcher akzeptieren Revision des Energiegesetzes, die den Ausstieg aus fossilen Energien vorschreibt.",
                tag: 'ref'
            },
            {
                date: 'Sept. 2022',
                type: 'past',
                text: "Inkrafttreten des revidierten Gesetzes: Prinzip des systematischen Ersatzes aller \xd6l-, Gas-, Widerstandsheizungen und Elektroboiler. Bundesgericht best\xe4tigte Verfassungsm\xe4ssigkeit.",
                tag: 'loi'
            },
            {
                date: "Bis 2030",
                type: 'future',
                text: "Stichtag: Alle bestehenden fossilen Heizungen m\xfcssen durch erneuerbare L\xf6sungen ersetzt werden.",
                tag: 'loi'
            },
            {
                date: '2050',
                type: 'future',
                text: 'Total Null fossile Energie. Abgestimmt auf Bundesgesetz CO2.',
                tag: 'loi'
            }
        ],
        mazout: "OBLIGATORISCHER ERSATZ bis 2030. Eines der strengsten kantonalen Gesetze der Schweiz.",
        gaz: "Gleiche Ersatzpflicht wie Heiz\xf6l, bis 2030.",
        propane: "Fossilen Brennstoffen gleichgestellt \u2014 gleiche Pflicht.",
        elec: "Widerstandsheizungen und Elektroboiler: ebenfalls obligatorischer Ersatz bis 2030.",
        referendum: {
            parti: 'Abstimmung vom 21. Nov. 2021',
            date_lancement: '2021',
            signatures: 'Referendum zustande gekommen',
            votation: "Angenommen mit 62,5% \u2014 Gesetz IN KRAFT"
        },
        subventions: "Z\xfcrcher kantonale Subventionen + Bundesprogramm Geb\xe4ude.",
        source: "Energiegesetz ZH \xb7 Arr\xeat TF confirmant constitutionnalit\xe9 \xb7 zh.ch"
    },
    GL: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).GL,
        name: 'Glarus',
        flag: "\uD83C\uDFD4\uFE0F",
        region: 'Ostschweiz',
        status: 'moderate',
        statusLabel: 'Aktive Massnahmen seit 2020',
        summary: "Glarus geh\xf6rt zu den Kantonen, die relativ fr\xfch Massnahmen gegen fossile Heizungen ergriffen haben, mit Verbot in Neubauten.",
        timeline: [
            {
                date: "2020\u20132022",
                type: 'past',
                text: "Integration MoPEC 2014: Verbot fossiler Heizungen allein in Neubauten. 'Final Sprint'-Periode vor neuen Normen.",
                tag: 'loi'
            },
            {
                date: 'Aktuell',
                type: 'now',
                text: "Kantonales Gesetz in Kraft. Einschr\xe4nkungen bei neuen fossilen Installationen.",
                tag: 'loi'
            },
            {
                date: '2025+',
                type: 'future',
                text: "Transposition MoPEC 2025 l\xe4uft.",
                tag: 'loi'
            }
        ],
        mazout: "In Neubauten verboten. Ersatz im Bestand unterliegt MoPEC 2014 Bedingungen.",
        gaz: "Gleiches Regime wie Heiz\xf6l.",
        propane: "Unterliegt fossilen Beschr\xe4nkungen.",
        elec: "Geltende Einschr\xe4nkungen gem\xe4ss MoPEC 2014.",
        referendum: null,
        subventions: "Bundesprogramm Geb\xe4ude.",
        source: "Energiegesetz GL \xb7 gl.ch"
    },
    TI: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).TI,
        name: 'Tessin',
        flag: "\uD83C\uDF34",
        region: 'Italienische Schweiz',
        status: 'progres',
        statusLabel: "Im Fortschritt \u2014 MoPEC 2014 integriert",
        summary: "Das Tessin wendet MoPEC 2014 an. Neubauten m\xfcssen erneuerbare Quellen nutzen. Bestehende Geb\xe4ude unterliegen Regeln f\xfcr schrittweisen Ersatz.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: "Integration der kantonalen Energievorschriften. Einschr\xe4nkungen bei fossilen Brennstoffen in Neubauten.",
                tag: 'loi'
            },
            {
                date: 'Aktuell',
                type: 'now',
                text: 'Kantonales Gesetz anwendbar. Obligatorischer erneuerbarer Anteil bei jedem Heizungsersatz.',
                tag: 'loi'
            },
            {
                date: '2025+',
                type: 'future',
                text: 'Transposition MoPEC 2025 geplant.',
                tag: 'loi'
            }
        ],
        mazout: "Einschr\xe4nkungen beim Ersatz (obligatorischer erneuerbarer Anteil). Neubauten: fossil verboten.",
        gaz: "Gleiches Regime wie Heiz\xf6l.",
        propane: "Unterliegt den kantonalen fossilen Beschr\xe4nkungen.",
        elec: "Elektroheizungen unterliegen MoPEC 2014 Beschr\xe4nkungen.",
        referendum: null,
        subventions: "Bundesprogramm Geb\xe4ude + kantonale Tessiner Hilfen.",
        source: "Legge sull'energia TI \xb7 ti.ch"
    },
    VS: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).VS,
        name: 'Wallis',
        flag: "\u26F0\uFE0F",
        region: 'Westschweiz',
        status: 'progres',
        statusLabel: "Im \xdcbergang \u2014 MoPEC 2014 integriert",
        summary: "Das Wallis hat MoPEC 2014 integriert. Der Kanton importiert den Grossteil seiner Energie und arbeitet an seinem \xdcbergang. Geothermie und Solarenergie haben erhebliches Potenzial.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: "Integration der MoPEC 2014 Vorschriften in das kantonale Energiegesetz.",
                tag: 'loi'
            },
            {
                date: 'Aktuell',
                type: 'now',
                text: "Einschr\xe4nkungen bei neuen fossilen Installationen. Obligatorischer erneuerbarer Anteil beim Ersatz.",
                tag: 'loi'
            },
            {
                date: '2025+',
                type: 'future',
                text: "Transposition MoPEC 2025 in kantonaler Integration.",
                tag: 'loi'
            }
        ],
        mazout: 'Neubauten: fossil allein verboten. Ersatz: obligatorischer erneuerbarer Anteil.',
        gaz: "Gleiches Regime wie Heiz\xf6l.",
        propane: "In fossilen Beschr\xe4nkungen enthalten.",
        elec: "MoPEC 2014 Beschr\xe4nkungen in Kraft.",
        referendum: null,
        subventions: "Bundesprogramm Geb\xe4ude + kantonale Walliser Subventionen.",
        source: "Loi valaisanne sur l'\xe9nergie (LCEn-VS) \xb7 vs.ch"
    },
    JU: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).JU,
        name: 'Jura',
        flag: "\uD83C\uDFDE\uFE0F",
        region: 'Westschweiz',
        status: 'federal',
        statusLabel: "Bundesrahmen \u2014 MoPEC 2014 integriert",
        summary: "Der Jura wendet den MoPEC 2014 Rahmen an. Der \xdcbergang ist progressiv, unterst\xfctzt durch bundesstaatliche Mechanismen.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Anwendung der MoPEC 2014 Vorschriften.',
                tag: 'loi'
            },
            {
                date: 'Aktuell',
                type: 'now',
                text: "Fossile Beschr\xe4nkungen in Neubauten. MoPEC 2025 Transposition l\xe4uft.",
                tag: 'loi'
            }
        ],
        mazout: "Neubauten: obligatorischer erneuerbarer Anteil. Einschr\xe4nkungen beim Ersatz.",
        gaz: "Gleiches Regime wie Heiz\xf6l.",
        propane: "Unterliegt fossilen Beschr\xe4nkungen.",
        elec: "MoPEC 2014 Beschr\xe4nkungen.",
        referendum: null,
        subventions: "Bundesprogramm Geb\xe4ude.",
        source: "Loi jurassienne sur les \xe9conomies d'\xe9nergie \xb7 jura.ch"
    },
    AG: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).AG,
        name: 'Aargau',
        flag: "\uD83C\uDF3E",
        region: 'Deutschschweiz',
        status: 'moderate',
        statusLabel: 'MoPEC 2014 angewendet',
        summary: 'Der Aargau wendet die MoPEC 2014 Vorschriften an und arbeitet an der Transposition von MoPEC 2025.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: "Integration in das kantonale Energiegesetz.",
                tag: 'loi'
            },
            {
                date: 'Aktuell',
                type: 'now',
                text: "Beschr\xe4nkungen in Kraft. Obligatorischer erneuerbarer Anteil bei jedem Ersatz erforderlich.",
                tag: 'loi'
            },
            {
                date: '2025+',
                type: 'future',
                text: 'Transposition MoPEC 2025.',
                tag: 'loi'
            }
        ],
        mazout: "Beschr\xe4nkungen beim Ersatz in Kraft (obligatorischer erneuerbarer Anteil erforderlich).",
        gaz: 'Gleiches Regime.',
        propane: "Unterliegt fossilen Beschr\xe4nkungen.",
        elec: "MoPEC 2014 Beschr\xe4nkungen.",
        referendum: null,
        subventions: "Bundesprogramm Geb\xe4ude + kantonale Hilfen.",
        source: "Energiegesetz AG \xb7 ag.ch"
    },
    SO: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).SO,
        name: 'Solothurn',
        flag: "\uD83C\uDFF0",
        region: 'Deutschschweiz',
        status: 'moderate',
        statusLabel: 'MoPEC 2014 integriert',
        summary: "Solothurn wendet MoPEC 2014 mit den standardm\xe4ssigen Beschr\xe4nkungen f\xfcr fossile Brennstoffe an.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: "Integration MoPEC 2014. Fossile Beschr\xe4nkungen in Neubauten.",
                tag: 'loi'
            },
            {
                date: '2025+',
                type: 'future',
                text: 'Transposition MoPEC 2025.',
                tag: 'loi'
            }
        ],
        mazout: 'Obligatorischer erneuerbarer Anteil beim Ersatz.',
        gaz: 'Gleiches Regime.',
        propane: "Fossile Beschr\xe4nkungen.",
        elec: "MoPEC 2014 Beschr\xe4nkungen.",
        referendum: null,
        subventions: "Bundesprogramm Geb\xe4ude + kantonale Hilfen.",
        source: "Energiegesetz SO \xb7 so.ch"
    },
    LU: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).LU,
        name: 'Luzern',
        flag: "\uD83C\uDFD4\uFE0F",
        region: 'Zentralschweiz',
        status: 'moderate',
        statusLabel: 'MoPEC 2014 integriert',
        summary: 'Luzern wendet MoPEC 2014 an.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integration in das kantonale Gesetz.',
                tag: 'loi'
            },
            {
                date: '2025+',
                type: 'future',
                text: 'Transposition MoPEC 2025.',
                tag: 'loi'
            }
        ],
        mazout: 'Obligatorischer erneuerbarer Anteil beim Ersatz.',
        gaz: 'Gleiches Regime.',
        propane: "Fossile Beschr\xe4nkungen.",
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: "Bundesprogramm Geb\xe4ude + kantonale Hilfen.",
        source: "Energiegesetz LU \xb7 lu.ch"
    },
    SG: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).SG,
        name: 'Sankt Gallen',
        flag: "\uD83C\uDFA8",
        region: 'Ostschweiz',
        status: 'moderate',
        statusLabel: "Beschr\xe4nkungen in Kraft",
        summary: 'Sankt Gallen erlebte einen "Final Sprint" f\xfcr \xd6lheizungsinstallationen vor Inkrafttreten der neuen Normen (2021-2022). Die MoPEC 2014 Beschr\xe4nkungen gelten.',
        timeline: [
            {
                date: '2021-2022',
                type: 'past',
                text: "Final Sprint: zahlreiche \xd6lheizungsinstallationen vor neuen Normen.",
                tag: 'ord'
            },
            {
                date: 'Aktuell',
                type: 'now',
                text: "MoPEC 2014 angewendet. Beschr\xe4nkungen beim Ersatz.",
                tag: 'loi'
            }
        ],
        mazout: 'Obligatorischer erneuerbarer Anteil beim Ersatz erforderlich.',
        gaz: 'Gleiches Regime.',
        propane: "Fossile Beschr\xe4nkungen.",
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: "Bundesprogramm Geb\xe4ude.",
        source: "Energiegesetz SG \xb7 sg.ch"
    },
    TG: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).TG,
        name: 'Thurgau',
        flag: "\uD83C\uDF4E",
        region: 'Ostschweiz',
        status: 'federal',
        statusLabel: 'Bundesrahmen / MoPEC 2014',
        summary: 'Der Thurgau wendet MoPEC 2014 an.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integration.',
                tag: 'loi'
            }
        ],
        mazout: "MoPEC 2014 Beschr\xe4nkungen.",
        gaz: 'Gleiches Regime.',
        propane: "Fossile Beschr\xe4nkungen.",
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: "Bundesprogramm Geb\xe4ude.",
        source: "Energiegesetz TG \xb7 tg.ch"
    },
    SH: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).SH,
        name: 'Schaffhausen',
        flag: "\uD83D\uDC02",
        region: 'Deutschschweiz',
        status: 'federal',
        statusLabel: 'Bundesrahmen / MoPEC 2014',
        summary: 'Schaffhausen wendet MoPEC 2014 an.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integration.',
                tag: 'loi'
            }
        ],
        mazout: "MoPEC 2014 Beschr\xe4nkungen.",
        gaz: 'Gleiches Regime.',
        propane: "Fossile Beschr\xe4nkungen.",
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: "Bundesprogramm Geb\xe4ude.",
        source: "Energiegesetz SH \xb7 sh.ch"
    },
    ZG: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).ZG,
        name: 'Zug',
        flag: "\uD83D\uDC8E",
        region: 'Zentralschweiz',
        status: 'federal',
        statusLabel: 'Bundesrahmen / MoPEC 2014',
        summary: 'Zug wendet MoPEC 2014 an.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integration.',
                tag: 'loi'
            }
        ],
        mazout: "MoPEC 2014 Beschr\xe4nkungen.",
        gaz: 'Gleiches Regime.',
        propane: "Fossile Beschr\xe4nkungen.",
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: "Bundesprogramm Geb\xe4ude.",
        source: "Energiegesetz ZG \xb7 zg.ch"
    },
    GR: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).GR,
        name: "Graub\xfcnden",
        flag: "\uD83E\uDD85",
        region: 'Ostschweiz',
        status: 'federal',
        statusLabel: 'Bundesrahmen / MoPEC 2014',
        summary: "Graub\xfcnden wendet MoPEC 2014 an.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integration.',
                tag: 'loi'
            }
        ],
        mazout: "MoPEC 2014 Beschr\xe4nkungen.",
        gaz: 'Gleiches Regime.',
        propane: "Fossile Beschr\xe4nkungen.",
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: "Bundesprogramm Geb\xe4ude.",
        source: "Energiegesetz GR \xb7 gr.ch"
    },
    UR: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).UR,
        name: 'Uri',
        flag: "\u26F0\uFE0F",
        region: 'Zentralschweiz',
        status: 'federal',
        statusLabel: 'Bundesrahmen / MoPEC 2014',
        summary: 'Uri wendet MoPEC 2014 an.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integration.',
                tag: 'loi'
            }
        ],
        mazout: "MoPEC 2014 Beschr\xe4nkungen.",
        gaz: 'Gleiches Regime.',
        propane: "Fossile Beschr\xe4nkungen.",
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: "Bundesprogramm Geb\xe4ude.",
        source: "Energiegesetz UR \xb7 ur.ch"
    },
    SZ: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).SZ,
        name: 'Schwyz',
        flag: "\uD83C\uDFD4\uFE0F",
        region: 'Zentralschweiz',
        status: 'federal',
        statusLabel: 'Bundesrahmen / MoPEC 2014',
        summary: 'Schwyz wendet MoPEC 2014 an.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integration.',
                tag: 'loi'
            }
        ],
        mazout: "MoPEC 2014 Beschr\xe4nkungen.",
        gaz: 'Gleiches Regime.',
        propane: "Fossile Beschr\xe4nkungen.",
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: "Bundesprogramm Geb\xe4ude.",
        source: "Energiegesetz SZ \xb7 sz.ch"
    },
    OW: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).OW,
        name: 'Obwalden',
        flag: "\uD83C\uDF32",
        region: 'Zentralschweiz',
        status: 'federal',
        statusLabel: 'Bundesrahmen / MoPEC 2014',
        summary: 'Obwalden wendet MoPEC 2014 an.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integration.',
                tag: 'loi'
            }
        ],
        mazout: "MoPEC 2014 Beschr\xe4nkungen.",
        gaz: 'Gleiches Regime.',
        propane: "Fossile Beschr\xe4nkungen.",
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: "Bundesprogramm Geb\xe4ude.",
        source: "Energiegesetz OW \xb7 ow.ch"
    },
    NW: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).NW,
        name: 'Nidwalden',
        flag: "\uD83C\uDF32",
        region: 'Zentralschweiz',
        status: 'federal',
        statusLabel: 'Bundesrahmen / MoPEC 2014',
        summary: 'Nidwalden wendet MoPEC 2014 an.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integration.',
                tag: 'loi'
            }
        ],
        mazout: "MoPEC 2014 Beschr\xe4nkungen.",
        gaz: 'Gleiches Regime.',
        propane: "Fossile Beschr\xe4nkungen.",
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: "Bundesprogramm Geb\xe4ude.",
        source: "Energiegesetz NW \xb7 nw.ch"
    },
    AI: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).AI,
        name: 'Appenzell I.-Rh.',
        flag: "\uD83D\uDC04",
        region: 'Ostschweiz',
        status: 'federal',
        statusLabel: 'Bundesrahmen / MoPEC 2014',
        summary: 'AI wendet MoPEC 2014 an.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integration.',
                tag: 'loi'
            }
        ],
        mazout: "MoPEC 2014 Beschr\xe4nkungen.",
        gaz: 'Gleiches Regime.',
        propane: "Fossile Beschr\xe4nkungen.",
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: "Bundesprogramm Geb\xe4ude.",
        source: "Energiegesetz AI \xb7 ai.ch"
    },
    AR: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).AR,
        name: 'Appenzell A.-Rh.',
        flag: "\uD83D\uDC04",
        region: 'Ostschweiz',
        status: 'federal',
        statusLabel: 'Bundesrahmen / MoPEC 2014',
        summary: 'AR wendet MoPEC 2014 an.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integration.',
                tag: 'loi'
            }
        ],
        mazout: "MoPEC 2014 Beschr\xe4nkungen.",
        gaz: 'Gleiches Regime.',
        propane: "Fossile Beschr\xe4nkungen.",
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: "Bundesprogramm Geb\xe4ude.",
        source: "Energiegesetz AR \xb7 ar.ch"
    }
};



var $6ff3cbe2616436a8$export$2e2bcd8739ae039 = {
    ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039),
    GE: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).GE,
        name: 'Ginevra',
        flag: "\uD83C\uDFD9\uFE0F",
        region: 'Svizzera romanda',
        status: 'strict',
        statusLabel: 'Legislazione severa e pionieristica',
        summary: "Ginevra \xe8 il cantone svizzero pi\xf9 avanzato nella decarbonizzazione degli edifici. La legge sull'energia del 18 settembre 1988 e il suo regolamento di attuazione revisionato nel 2022 impongono misure vincolanti basate sull'indice di spesa termica (IDC).",
        timeline: [
            {
                date: '2010',
                type: 'past',
                text: "Introduzione del regime IDC per i grandi proprietari (immobili). Primo cantone a imporre il monitoraggio del consumo energetico.",
                tag: 'legge'
            },
            {
                date: "1\xb0 set. 2022",
                type: 'past',
                text: "Revisione del regolamento di attuazione (REn): abbassamento dell'IDC a 450 MJ/m\xb2/anno. In caso di sostituzione di una caldaia fossile, obbligo di installare un sistema rinnovabile (salvo impossibilit\xe0 tecnica). Eccezione: caldaia a condensazione autorizzata se \u226530% rinnovabile integrato.",
                tag: 'ord'
            },
            {
                date: "2022\u20132024",
                type: 'past',
                text: "Notifiche IDC inviate ai proprietari di villette e piccoli edifici (<5 utenti di calore). Base di calcolo su 3 anni.",
                tag: 'ord'
            },
            {
                date: 'Dal 2025',
                type: 'now',
                text: "Prime decisioni di risanamento emesse per i piccoli proprietari il cui IDC supera la soglia. Termini negoziabili tramite convenzione con il Dipartimento del territorio.",
                tag: 'ord'
            },
            {
                date: "Fino al 2035",
                type: 'future',
                text: "Rete termica GeniLac in implementazione: i proprietari in zona servita possono posticipare alcuni lavori fino all'allacciamento.",
                tag: 'info'
            },
            {
                date: '2050',
                type: 'future',
                text: 'Obiettivo zero fossile totale per il parco edilizio ginevrino. Allineato con la strategia cantonale e la LCI federale.',
                tag: 'legge'
            }
        ],
        mazout: 'Vietato durante qualsiasi sostituzione di caldaia dal 2022 (salvo deroga tecnica comprovata). Sostituzione con rinnovabile obbligatoria.',
        gaz: 'Soggetto allo stesso regime IDC dell\'olio combustibile. Sostituzione con rinnovabile durante qualsiasi cambiamento d\'impianto.',
        propane: 'Trattato come combustibile fossile, soggetto alle stesse restrizioni dell\'olio combustibile.',
        elec: 'I riscaldamenti elettrici a resistenza sono vietati nelle nuove costruzioni (MoPEC 2014 applicato). Sostituzione incoraggiata.',
        referendum: null,
        subventions: 'Programma Edifici federale + sovvenzioni cantonali ginevrine (ScanE). Fino a 30 000 CHF per la sostituzione di una caldaia fossile.',
        source: "R\xe8glement genevois sur l'\xe9nergie (REn) \u2014 DT/GE \xb7 admin.ge.ch"
    },
    VD: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).VD,
        name: 'Vaud',
        flag: "\uD83C\uDFD4\uFE0F",
        region: 'Svizzera romanda',
        status: 'voted',
        statusLabel: "Referendum UDC in corso \u2014 legge sospesa",
        summary: "Il Gran Consiglio vodese ha adottato il 3 febbraio 2026 una revisione ambiziosa della legge sull'energia (LVLEne). Tuttavia, l'UDC Vaud ha lanciato un referendum il 10 marzo 2026. L'attuale legge del 2006 rimane applicabile fino alla conclusione della procedura.",
        timeline: [
            {
                date: "1\xb0 gen. 2025",
                type: 'past',
                text: 'Decreto DACCE (RSV 730.051) in vigore: risanamento obbligatorio dei riscaldamenti e scaldacqua elettrici entro termine fissato.',
                tag: 'ord'
            },
            {
                date: '3 feb. 2026',
                type: 'past',
                text: "Gran Consiglio vodese adotta la nuova LVLEne con 99 voti favorevoli e 31 contrari. Fine del riscaldamento fossile sancita. Risanamento obbligatorio per edifici >750 m\xb2.",
                tag: 'legge'
            },
            {
                date: '10 mar. 2026',
                type: 'now',
                text: "\u26A0\uFE0F L'UDC Vaud lancia ufficialmente il referendum. Raccolta di 12 000 firme richiesta in 2 mesi.",
                tag: 'ref'
            },
            {
                date: "~met\xe0 maggio 2026",
                type: 'future',
                text: "Data limite per il deposito delle firme referendarie. Se riuscito \u2192 legge sospesa fino alla votazione.",
                tag: 'ref'
            },
            {
                date: 'Autunno 2026',
                type: 'future',
                text: 'Probabile votazione popolare vodese (se il referendum riesce). La legge del 2026 non entra in vigore prima di questo voto.',
                tag: 'ref'
            },
            {
                date: 'Gen. 2027',
                type: 'future',
                text: 'Entrata in vigore prevista della nuova LVLEne (se votazione favorevole). Legge attuale (2006) rimane fino ad allora.',
                tag: 'legge'
            },
            {
                date: '2046',
                type: 'future',
                text: 'Data limite della nuova legge: sostituzione di tutti i riscaldamenti fossili (olio, gas) con sistema rinnovabile.',
                tag: 'legge'
            }
        ],
        mazout: 'Attualmente (legge 2006): sostituzione con fossile ancora possibile con CECB obbligatorio. Nuova legge (se adottata): divieto di sostituzione con fossile, termine fino al 2046.',
        gaz: 'Stesso regime dell\'olio combustibile. La nuova legge prevede la fine del gas come combustibile per riscaldamento entro il 2046.',
        propane: 'Assimilato all\'olio combustibile nella regolamentazione vodese.',
        elec: "Riscaldamenti elettrici: risanamento obbligatorio secondo decreto DACCE in vigore dal 1\xb0 gennaio 2025.",
        referendum: {
            parti: 'UDC Vaud',
            data_lancio: '10 marzo 2026',
            firme: '12 000 in 2 mesi',
            votazione: 'Autunno 2026 (probabile)'
        },
        subventions: 'Programma Edifici federale + sovvenzioni cantonali vodesi. 120 milioni CHF previsti per la transizione (se nuova legge adottata).',
        source: "LVLEne du 16 mai 2006 \xb7 Nouvelle LVLEne adopt\xe9e le 3 f\xe9vr. 2026 \xb7 vd.ch/energie"
    },
    BE: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).BE,
        name: 'Berna',
        flag: "\uD83D\uDC3B",
        region: 'Svizzera centrale',
        status: 'voted',
        statusLabel: 'Revisione di legge respinta in votazione (2023)',
        summary: "Il cantone di Berna ha vissuto un episodio democratico significativo: la revisione della legge sull'energia volta a ridurre i riscaldamenti fossili \xe8 stata respinta di stretta misura dal popolo bernese l'11 giugno 2023 (50,6% di no). La legge in vigore rimane la versione precedente, pi\xf9 permissiva.",
        timeline: [
            {
                date: '11 giu. 2023',
                type: 'past',
                text: 'Votazione cantonale: respinta la revisione della legge sull\'energia al 50,6%. I proprietari potranno continuare a usare l\'olio combustibile. L\'argomento dell\'aumento degli affitti ha vinto il voto.',
                tag: 'ref'
            },
            {
                date: 'Attualmente',
                type: 'now',
                text: 'Legge attuale applicabile: obbligo di rinnovare i riscaldamenti elettrici entro 20 anni. Per i fossili, MoPEC 2014 parzialmente integrato.',
                tag: 'legge'
            },
            {
                date: "2025\u20132026",
                type: 'future',
                text: 'Nuova proposta legislativa attesa, dopo l\'adozione di MoPEC 2025 (agosto 2025). Il governo bernese dovrebbe presentare un nuovo progetto.',
                tag: 'legge'
            },
            {
                date: '2050',
                type: 'future',
                text: "Obiettivo federale: fine di tutti i riscaldamenti fossili. Il cantone dovr\xe0 conformarsi tramite MoPEC 2025.",
                tag: 'legge'
            }
        ],
        mazout: 'NESSUN divieto cantonale. La sostituzione con olio combustibile rimane legale. La legge revisionata essendo stata respinta, nessun obbligo di sostituzione.',
        gaz: 'Stessa situazione dell\'olio combustibile. Nessun divieto in vigore.',
        propane: 'Nessuna restrizione cantonale specifica.',
        elec: "Obbligo di sostituzione dei riscaldamenti elettrici entro 20 anni (legge attuale, gi\xe0 in vigore).",
        referendum: {
            parti: 'Referendum cittadino + ambienti economici',
            data_lancio: '2023',
            firme: 'Riuscito',
            votazione: "11 giugno 2023 \u2192 LEGGE RESPINTA (50,6% di no)"
        },
        subventions: 'Programma Edifici federale applicabile. Sovvenzioni cantonali bernesi disponibili per sostituzione volontaria.',
        source: "Loi bernoise sur l'\xe9nergie (KEnG) \xb7 R\xe9sultat votation du 11 juin 2023"
    },
    BL: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).BL,
        name: 'Basilea Campagna',
        flag: "\uD83C\uDF3F",
        region: 'Svizzera nord-occidentale',
        status: 'strict',
        statusLabel: "Tra i pi\xf9 severi \u2014 Divieto totale dal 2026",
        summary: "Basilea Campagna \xe8 uno dei cantoni pi\xf9 avanzati con un divieto totale di nuove installazioni di riscaldamento a olio dal 1\xb0 gennaio 2026, anche per le sostituzioni.",
        timeline: [
            {
                date: 'Ott. 2024',
                type: 'past',
                text: 'Entrata in vigore della legge cantonale sull\'energia: divieto di riscaldamenti fossili nelle nuove costruzioni.',
                tag: 'legge'
            },
            {
                date: "1\xb0 gen. 2026",
                type: 'past',
                text: 'Estensione del divieto: nessuna nuova installazione di riscaldamento a olio, anche in sostituzione di un riscaldamento esistente (se installazione >15 anni). Restano possibili eccezioni.',
                tag: 'legge'
            },
            {
                date: 'Attualmente',
                type: 'now',
                text: "\u26A0\uFE0F Segnalato un forte aumento delle richieste di installazione prima della data limite. Tempi amministrativi prolungati.",
                tag: 'ord'
            },
            {
                date: '2050',
                type: 'future',
                text: 'Allineamento all\'obiettivo federale zero fossile.',
                tag: 'legge'
            }
        ],
        mazout: "VIETATO dal 1\xb0 gennaio 2026 per qualsiasi nuova sostituzione (se installazione >15 anni). Sono possibili solo eccezioni precise.",
        gaz: 'Stesso divieto dell\'olio combustibile dal 2026. Solo rinnovabile autorizzato per i nuovi sistemi.',
        propane: "Assimilato ai combustibili fossili \u2014 stesso divieto.",
        elec: 'Riscaldamenti elettrici a resistenza vietati nelle nuove costruzioni.',
        referendum: null,
        subventions: 'Sovvenzioni cantonali + Programma Edifici federale. Possibili tempi amministrativi prolungati a causa dell\'elevata domanda.',
        source: "Loi sur l'\xe9nergie BL \u2014 Kantonales Energiegesetz (KEG) \xb7 bl.ch"
    },
    BS: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).BS,
        name: "Basilea Citt\xe0",
        flag: "\uD83C\uDFDB\uFE0F",
        region: 'Svizzera nord-occidentale',
        status: 'strict',
        statusLabel: "Pioniere \u2014 divieto dal 2022",
        summary: "Basilea Citt\xe0 (cantone-citt\xe0) \xe8 pioniere con un divieto dei riscaldamenti fossili durante le ristrutturazioni in vigore dal 2022, tra le prime misure di questo tipo in Svizzera.",
        timeline: [
            {
                date: '2022',
                type: 'past',
                text: "Divieto di installazione di riscaldamenti a energia fossile durante le ristrutturazioni. Cantone-citt\xe0 pioniere a livello nazionale.",
                tag: 'legge'
            },
            {
                date: 'Attualmente',
                type: 'now',
                text: 'Legge in vigore. Sostituzione di una caldaia fossile obbligatoriamente con un sistema rinnovabile.',
                tag: 'legge'
            },
            {
                date: '2050',
                type: 'future',
                text: "Obiettivo: neutralit\xe0 carbonica completa del parco edilizio.",
                tag: 'legge'
            }
        ],
        mazout: 'VIETATO durante qualsiasi ristrutturazione dal 2022. Sostituzione obbligatoria con una fonte rinnovabile.',
        gaz: 'Stesso divieto dell\'olio combustibile dal 2022.',
        propane: 'Incluso nelle restrizioni sui combustibili fossili.',
        elec: 'Riscaldamenti elettrici a resistenza vietati nelle nuove costruzioni.',
        referendum: null,
        subventions: 'Sovvenzioni cantonali basilesi disponibili + Programma federale.',
        source: "Loi cantonale BS sur l'\xe9nergie \xb7 Energiegesetz (EnG) \xb7 bs.ch"
    },
    FR: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).FR,
        name: 'Friburgo',
        flag: "\u269C\uFE0F",
        region: 'Svizzera romanda',
        status: 'moderate',
        statusLabel: 'Legislazione avanzata dal 2020',
        summary: 'Friburgo ha adottato un approccio misto: divieto di nuove installazioni fossili pure senza rinnovabile dal 2020, forte incentivo finanziario alla sostituzione dei riscaldamenti elettrici.',
        timeline: [
            {
                date: "1\xb0 gen. 2020",
                type: 'past',
                text: "Nuova legge sull'energia in vigore: impossibilit\xe0 di installare un riscaldamento a olio o gas senza associarlo a una quota di energia rinnovabile. Nuovi edifici: fossile da solo vietato.",
                tag: 'legge'
            },
            {
                date: 'Dal 2020',
                type: 'past',
                text: 'Messi a disposizione 24 milioni CHF per la sostituzione dei riscaldamenti elettrici. Aiuti finanziari e sgravi fiscali.',
                tag: 'ord'
            },
            {
                date: 'Attualmente',
                type: 'now',
                text: 'MoPEC 2014 integrato senza obbligo di ristrutturazione sistematica dei riscaldamenti fossili esistenti. Riscaldamento fossile da solo vietato per qualsiasi sostituzione secondo le nuove norme.',
                tag: 'legge'
            },
            {
                date: '2025+',
                type: 'future',
                text: 'Trasposizione di MoPEC 2025 in corso. Probabili rafforzamenti legislativi.',
                tag: 'legge'
            }
        ],
        mazout: "Vietato senza quota rinnovabile dal 2020. Per gli edifici esistenti, la sostituzione con solo fossile \xe8 soggetta a restrizioni.",
        gaz: 'Stesso regime dell\'olio combustibile dal 2020.',
        propane: 'Soggetto alle stesse restrizioni dei combustibili fossili.',
        elec: 'Sostituzione fortemente incentivata finanziariamente (24 milioni CHF). Nessun obbligo con termini rigidi come a Vaud.',
        referendum: null,
        subventions: 'Sostegni finanziari cantonali significativi (24 milioni CHF fino al 2025) + Programma Edifici federale.',
        source: "Loi fribourgeoise sur l'\xe9nergie (LCEn) \xb7 fr.ch/energie"
    },
    NE: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).NE,
        name: "Neuch\xe2tel",
        flag: "\uD83C\uDFD4\uFE0F",
        region: 'Svizzera romanda',
        status: 'strict',
        statusLabel: 'Divieto durante le ristrutturazioni',
        summary: "Neuch\xe2tel ha adottato misure severe che vietano i riscaldamenti fossili durante le ristrutturazioni, allineato a MoPEC 2014 con disposizioni proprie.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: "Integrazione completa delle prescrizioni MoPEC 2014: durante la sostituzione di un riscaldamento, l'installazione di soli sistemi fossili \xe8 vietata.",
                tag: 'legge'
            },
            {
                date: 'Attualmente',
                type: 'now',
                text: "Durante le ristrutturazioni, il riscaldamento fossile da solo \xe8 vietato. Obbligo di rinnovabile integrato.",
                tag: 'legge'
            },
            {
                date: '2025+',
                type: 'future',
                text: 'Trasposizione di MoPEC 2025 attesa.',
                tag: 'legge'
            }
        ],
        mazout: 'Vietato durante le ristrutturazioni. Sostituzione con solo fossile non autorizzata.',
        gaz: 'Stessa restrizione dell\'olio combustibile durante le ristrutturazioni.',
        propane: 'Incluso nelle restrizioni fossili.',
        elec: 'Vietati nelle nuove costruzioni (MoPEC 2014).',
        referendum: null,
        subventions: 'Programma Edifici federale + aiuti cantonali neocastellani.',
        source: "Loi neuch\xe2teloise sur l'\xe9nergie \xb7 ne.ch"
    },
    ZH: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).ZH,
        name: 'Zurigo',
        flag: "\uD83E\uDD81",
        region: 'Svizzera tedesca',
        status: 'strict',
        statusLabel: "Sostituzione sistematica obbligatoria entro il 2030",
        summary: 'Zurigo ha introdotto nel 2022 (accettato in votazione dal 62,5% dei voti) l\'obbligo di sostituire sistematicamente tutti i riscaldamenti fossili, elettrici e scaldacqua elettrici centrali con soluzioni climaticamente neutre, con scadenza al 2030.',
        timeline: [
            {
                date: 'Nov. 2021',
                type: 'past',
                text: 'Votazione popolare cantonale: il 62,5% degli zurighesi accetta la revisione della legge sull\'energia che impone l\'uscita dai fossili.',
                tag: 'ref'
            },
            {
                date: 'Set. 2022',
                type: 'past',
                text: "Entrata in vigore della legge revisionata: principio della sostituzione sistematica di tutti i riscaldamenti a olio, gas, riscaldamenti elettrici a resistenza e scaldacqua elettrici. Il Tribunale federale ha confermato la costituzionalit\xe0.",
                tag: 'legge'
            },
            {
                date: "Entro il 2030",
                type: 'future',
                text: 'Data limite: tutti i riscaldamenti fossili esistenti devono essere sostituiti con soluzioni rinnovabili.',
                tag: 'legge'
            },
            {
                date: '2050',
                type: 'future',
                text: 'Obiettivo zero fossile totale. Allineato alla LCI federale.',
                tag: 'legge'
            }
        ],
        mazout: "SOSTITUZIONE OBBLIGATORIA entro il 2030. Tra le leggi cantonali pi\xf9 severe della Svizzera.",
        gaz: "Stesso obbligo di sostituzione dell'olio combustibile, entro il 2030.",
        propane: "Assimilato ai combustibili fossili \u2014 stesso obbligo.",
        elec: "Riscaldamenti elettrici a resistenza e scaldacqua elettrici: sostituzione obbligatoria anch'essa entro il 2030.",
        referendum: {
            parti: 'Votazione del 21 nov. 2021',
            data_lancio: '2021',
            firme: 'Referendum riuscito',
            votazione: "Accettato al 62,5% \u2014 legge IN VIGORE"
        },
        subventions: 'Sovvenzioni cantonali zurighesi + Programma Edifici federale.',
        source: "Energiegesetz ZH \xb7 Arr\xeat TF confirmant constitutionnalit\xe9 \xb7 zh.ch"
    },
    GL: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).GL,
        name: 'Glarona',
        flag: "\uD83C\uDFD4\uFE0F",
        region: 'Svizzera orientale',
        status: 'moderate',
        statusLabel: 'Misure attive dal 2020',
        summary: 'Glarona fa parte dei cantoni che hanno adottato misure relativamente precoci contro i riscaldamenti fossili, con un divieto nelle nuove costruzioni.',
        timeline: [
            {
                date: "2020\u20132022",
                type: 'past',
                text: "Integrazione MoPEC 2014: divieto del riscaldamento fossile da solo nelle nuove costruzioni. Periodo di 'sprint finale' prima delle nuove norme.",
                tag: 'legge'
            },
            {
                date: 'Attualmente',
                type: 'now',
                text: 'Legge cantonale in vigore. Restrizioni sulle nuove installazioni fossili.',
                tag: 'legge'
            },
            {
                date: '2025+',
                type: 'future',
                text: 'Trasposizione MoPEC 2025 in corso.',
                tag: 'legge'
            }
        ],
        mazout: "Vietato nelle nuove costruzioni. Sostituzione nell'esistente soggetta alle condizioni MoPEC 2014.",
        gaz: 'Stesso regime dell\'olio combustibile.',
        propane: 'Soggetto alle restrizioni fossili.',
        elec: 'Restrizioni in vigore secondo MoPEC 2014.',
        referendum: null,
        subventions: 'Programma Edifici federale.',
        source: "Energiegesetz GL \xb7 gl.ch"
    },
    TI: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).TI,
        name: 'Ticino',
        flag: "\uD83C\uDF34",
        region: 'Svizzera italiana',
        status: 'progres',
        statusLabel: "In progressione \u2014 MoPEC 2014 integrato",
        summary: 'Il Ticino applica MoPEC 2014. Le nuove costruzioni devono utilizzare fonti rinnovabili. Gli edifici esistenti sono soggetti alle regole di sostituzione progressiva.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integrazione delle prescrizioni energetiche cantonali. Restrizioni sui fossili nelle nuove costruzioni.',
                tag: 'legge'
            },
            {
                date: 'Attualmente',
                type: 'now',
                text: 'Legge cantonale applicabile. Quota di rinnovabile obbligatoria durante qualsiasi sostituzione di riscaldamento.',
                tag: 'legge'
            },
            {
                date: '2025+',
                type: 'future',
                text: 'Trasposizione MoPEC 2025 prevista.',
                tag: 'legge'
            }
        ],
        mazout: 'Restrizioni durante la sostituzione (quota rinnovabile obbligatoria). Nuove costruzioni: fossile vietato.',
        gaz: 'Stesso regime dell\'olio combustibile.',
        propane: 'Soggetto alle restrizioni fossili cantonali.',
        elec: 'Riscaldamenti elettrici soggetti alle restrizioni MoPEC 2014.',
        referendum: null,
        subventions: 'Programma Edifici federale + aiuti cantonali ticinesi.',
        source: "Legge sull'energia TI \xb7 ti.ch"
    },
    VS: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).VS,
        name: 'Vallese',
        flag: "\u26F0\uFE0F",
        region: 'Svizzera romanda',
        status: 'progres',
        statusLabel: "In transizione \u2014 MoPEC 2014 integrato",
        summary: 'Il Vallese ha integrato MoPEC 2014. Il cantone importa massicciamente la sua energia e lavora alla sua transizione. La geotermia e il solare presentano un potenziale importante.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: "Integrazione delle prescrizioni MoPEC 2014 nella legge cantonale sull'energia.",
                tag: 'legge'
            },
            {
                date: 'Attualmente',
                type: 'now',
                text: 'Restrizioni sulle nuove installazioni fossili. Quota di rinnovabile obbligatoria durante la sostituzione.',
                tag: 'legge'
            },
            {
                date: '2025+',
                type: 'future',
                text: "Trasposizione MoPEC 2025 in corso d'integrazione cantonale.",
                tag: 'legge'
            }
        ],
        mazout: 'Nuove costruzioni: fossile da solo vietato. Sostituzione: quota rinnovabile obbligatoria.',
        gaz: 'Stesso regime dell\'olio combustibile.',
        propane: 'Incluso nelle restrizioni fossili.',
        elec: 'Restrizioni MoPEC 2014 in vigore.',
        referendum: null,
        subventions: 'Programma Edifici federale + sovvenzioni cantonali vallesane.',
        source: "Loi valaisanne sur l'\xe9nergie (LCEn-VS) \xb7 vs.ch"
    },
    JU: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).JU,
        name: 'Giura',
        flag: "\uD83C\uDFDE\uFE0F",
        region: 'Svizzera romanda',
        status: 'federal',
        statusLabel: "Quadro federale \u2014 MoPEC 2014 integrato",
        summary: "Il Giura applica il quadro MoPEC 2014. La transizione \xe8 progressiva, sostenuta dai meccanismi federali.",
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Applicazione delle prescrizioni MoPEC 2014.',
                tag: 'legge'
            },
            {
                date: 'Attualmente',
                type: 'now',
                text: 'Restrizioni fossili nelle nuove costruzioni. MoPEC 2025 in corso di trasposizione.',
                tag: 'legge'
            }
        ],
        mazout: 'Nuove costruzioni: quota rinnovabile obbligatoria. Restrizioni durante la sostituzione.',
        gaz: 'Stesso regime dell\'olio combustibile.',
        propane: 'Soggetto alle restrizioni fossili.',
        elec: 'Restrizioni MoPEC 2014.',
        referendum: null,
        subventions: 'Programma Edifici federale.',
        source: "Loi jurassienne sur les \xe9conomies d'\xe9nergie \xb7 jura.ch"
    },
    AG: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).AG,
        name: 'Argovia',
        flag: "\uD83C\uDF3E",
        region: 'Svizzera tedesca',
        status: 'moderate',
        statusLabel: 'MoPEC 2014 applicato',
        summary: 'Argovia applica le prescrizioni MoPEC 2014 e lavora alla trasposizione di MoPEC 2025.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: "Integrazione nella legge cantonale sull'energia.",
                tag: 'legge'
            },
            {
                date: 'Attualmente',
                type: 'now',
                text: 'Restrizioni in vigore. Quota rinnovabile richiesta durante qualsiasi sostituzione.',
                tag: 'legge'
            },
            {
                date: '2025+',
                type: 'future',
                text: 'Trasposizione MoPEC 2025.',
                tag: 'legge'
            }
        ],
        mazout: 'Restrizioni in vigore durante la sostituzione (quota rinnovabile richiesta).',
        gaz: 'Stesso regime.',
        propane: 'Soggetto alle restrizioni fossili.',
        elec: 'Restrizioni MoPEC 2014.',
        referendum: null,
        subventions: 'Programma Edifici federale + aiuti cantonali.',
        source: "Energiegesetz AG \xb7 ag.ch"
    },
    SO: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).SO,
        name: 'Soletta',
        flag: "\uD83C\uDFF0",
        region: 'Svizzera tedesca',
        status: 'moderate',
        statusLabel: 'MoPEC 2014 integrato',
        summary: 'Soletta applica MoPEC 2014 con le restrizioni standard sui combustibili fossili.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integrazione MoPEC 2014. Restrizioni fossili nelle nuove costruzioni.',
                tag: 'legge'
            },
            {
                date: '2025+',
                type: 'future',
                text: 'Trasposizione MoPEC 2025.',
                tag: 'legge'
            }
        ],
        mazout: 'Quota rinnovabile obbligatoria durante la sostituzione.',
        gaz: 'Stesso regime.',
        propane: 'Restrizioni fossili.',
        elec: 'Restrizioni MoPEC 2014.',
        referendum: null,
        subventions: 'Programma Edifici + aiuti cantonali.',
        source: "Energiegesetz SO \xb7 so.ch"
    },
    LU: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).LU,
        name: 'Lucerna',
        flag: "\uD83C\uDFD4\uFE0F",
        region: 'Svizzera centrale',
        status: 'moderate',
        statusLabel: 'MoPEC 2014 integrato',
        summary: 'Lucerna applica MoPEC 2014.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integrazione nella legge cantonale.',
                tag: 'legge'
            },
            {
                date: '2025+',
                type: 'future',
                text: 'Trasposizione MoPEC 2025.',
                tag: 'legge'
            }
        ],
        mazout: 'Quota rinnovabile obbligatoria durante la sostituzione.',
        gaz: 'Stesso regime.',
        propane: 'Restrizioni fossili.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: 'Programma Edifici + aiuti cantonali.',
        source: "Energiegesetz LU \xb7 lu.ch"
    },
    SG: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).SG,
        name: 'San Gallo',
        flag: "\uD83C\uDFA8",
        region: 'Svizzera orientale',
        status: 'moderate',
        statusLabel: 'Restrizioni in vigore',
        summary: "San Gallo ha conosciuto uno 'sprint finale' per le installazioni di olio combustibile prima dell'entrata in vigore delle nuove norme (2021-2022). Si applicano le restrizioni MoPEC 2014.",
        timeline: [
            {
                date: '2021-2022',
                type: 'past',
                text: 'Sprint finale: numerose installazioni di olio combustibile prima delle nuove norme.',
                tag: 'ord'
            },
            {
                date: 'Attualmente',
                type: 'now',
                text: 'MoPEC 2014 applicato. Restrizioni durante la sostituzione.',
                tag: 'legge'
            }
        ],
        mazout: 'Quota rinnovabile richiesta durante la sostituzione.',
        gaz: 'Stesso regime.',
        propane: 'Restrizioni fossili.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: 'Programma Edifici federale.',
        source: "Energiegesetz SG \xb7 sg.ch"
    },
    TG: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).TG,
        name: 'Turgovia',
        flag: "\uD83C\uDF4E",
        region: 'Svizzera orientale',
        status: 'federal',
        statusLabel: 'Quadro federale / MoPEC 2014',
        summary: 'La Turgovia applica MoPEC 2014.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integrazione.',
                tag: 'legge'
            }
        ],
        mazout: 'Restrizioni MoPEC 2014.',
        gaz: 'Stesso regime.',
        propane: 'Restrizioni fossili.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: 'Programma Edifici federale.',
        source: "Energiegesetz TG \xb7 tg.ch"
    },
    SH: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).SH,
        name: 'Sciaffusa',
        flag: "\uD83D\uDC02",
        region: 'Svizzera tedesca',
        status: 'federal',
        statusLabel: 'Quadro federale / MoPEC 2014',
        summary: 'Sciaffusa applica MoPEC 2014.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integrazione.',
                tag: 'legge'
            }
        ],
        mazout: 'Restrizioni MoPEC 2014.',
        gaz: 'Stesso regime.',
        propane: 'Restrizioni fossili.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: 'Programma Edifici federale.',
        source: "Energiegesetz SH \xb7 sh.ch"
    },
    ZG: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).ZG,
        name: 'Zugo',
        flag: "\uD83D\uDC8E",
        region: 'Svizzera centrale',
        status: 'federal',
        statusLabel: 'Quadro federale / MoPEC 2014',
        summary: 'Zugo applica MoPEC 2014.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integrazione.',
                tag: 'legge'
            }
        ],
        mazout: 'Restrizioni MoPEC 2014.',
        gaz: 'Stesso regime.',
        propane: 'Restrizioni fossili.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: 'Programma Edifici federale.',
        source: "Energiegesetz ZG \xb7 zg.ch"
    },
    GR: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).GR,
        name: 'Grigioni',
        flag: "\uD83E\uDD85",
        region: 'Svizzera orientale',
        status: 'federal',
        statusLabel: 'Quadro federale / MoPEC 2014',
        summary: 'I Grigioni applicano MoPEC 2014.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integrazione.',
                tag: 'legge'
            }
        ],
        mazout: 'Restrizioni MoPEC 2014.',
        gaz: 'Stesso regime.',
        propane: 'Restrizioni fossili.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: 'Programma Edifici federale.',
        source: "Energiegesetz GR \xb7 gr.ch"
    },
    UR: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).UR,
        name: 'Uri',
        flag: "\u26F0\uFE0F",
        region: 'Svizzera centrale',
        status: 'federal',
        statusLabel: 'Quadro federale / MoPEC 2014',
        summary: 'Uri applica MoPEC 2014.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integrazione.',
                tag: 'legge'
            }
        ],
        mazout: 'Restrizioni MoPEC 2014.',
        gaz: 'Stesso regime.',
        propane: 'Restrizioni fossili.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: 'Programma Edifici federale.',
        source: "Energiegesetz UR \xb7 ur.ch"
    },
    SZ: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).SZ,
        name: 'Svitto',
        flag: "\uD83C\uDFD4\uFE0F",
        region: 'Svizzera centrale',
        status: 'federal',
        statusLabel: 'Quadro federale / MoPEC 2014',
        summary: 'Svitto applica MoPEC 2014.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integrazione.',
                tag: 'legge'
            }
        ],
        mazout: 'Restrizioni MoPEC 2014.',
        gaz: 'Stesso regime.',
        propane: 'Restrizioni fossili.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: 'Programma Edifici federale.',
        source: "Energiegesetz SZ \xb7 sz.ch"
    },
    OW: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).OW,
        name: 'Obvaldo',
        flag: "\uD83C\uDF32",
        region: 'Svizzera centrale',
        status: 'federal',
        statusLabel: 'Quadro federale / MoPEC 2014',
        summary: 'Obvaldo applica MoPEC 2014.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integrazione.',
                tag: 'legge'
            }
        ],
        mazout: 'Restrizioni MoPEC 2014.',
        gaz: 'Stesso regime.',
        propane: 'Restrizioni fossili.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: 'Programma Edifici federale.',
        source: "Energiegesetz OW \xb7 ow.ch"
    },
    NW: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).NW,
        name: 'Nidvaldo',
        flag: "\uD83C\uDF32",
        region: 'Svizzera centrale',
        status: 'federal',
        statusLabel: 'Quadro federale / MoPEC 2014',
        summary: 'Nidvaldo applica MoPEC 2014.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integrazione.',
                tag: 'legge'
            }
        ],
        mazout: 'Restrizioni MoPEC 2014.',
        gaz: 'Stesso regime.',
        propane: 'Restrizioni fossili.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: 'Programma Edifici federale.',
        source: "Energiegesetz NW \xb7 nw.ch"
    },
    AI: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).AI,
        name: 'Appenzello Interno',
        flag: "\uD83D\uDC04",
        region: 'Svizzera orientale',
        status: 'federal',
        statusLabel: 'Quadro federale / MoPEC 2014',
        summary: 'AI applica MoPEC 2014.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integrazione.',
                tag: 'legge'
            }
        ],
        mazout: 'Restrizioni MoPEC 2014.',
        gaz: 'Stesso regime.',
        propane: 'Restrizioni fossili.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: 'Programma Edifici federale.',
        source: "Energiegesetz AI \xb7 ai.ch"
    },
    AR: {
        ...(0, $9712f78f8da636c4$export$2e2bcd8739ae039).AR,
        name: 'Appenzello Esterno',
        flag: "\uD83D\uDC04",
        region: 'Svizzera orientale',
        status: 'federal',
        statusLabel: 'Quadro federale / MoPEC 2014',
        summary: 'AR applica MoPEC 2014.',
        timeline: [
            {
                date: 'MoPEC 2014',
                type: 'past',
                text: 'Integrazione.',
                tag: 'legge'
            }
        ],
        mazout: 'Restrizioni MoPEC 2014.',
        gaz: 'Stesso regime.',
        propane: 'Restrizioni fossili.',
        elec: 'MoPEC 2014.',
        referendum: null,
        subventions: 'Programma Edifici federale.',
        source: "Energiegesetz AR \xb7 ar.ch"
    }
};


const $a9e15ae689b819ac$var$datasets = {
    fr: (0, $9712f78f8da636c4$export$2e2bcd8739ae039),
    en: (0, $4994066c973aafb5$export$2e2bcd8739ae039),
    de: (0, $bcff7c38517d3d4a$export$2e2bcd8739ae039),
    it: (0, $6ff3cbe2616436a8$export$2e2bcd8739ae039)
};
const $a9e15ae689b819ac$var$tagMap = {
    ref: 'tag-ref',
    loi: 'tag-loi',
    ord: 'tag-ord',
    info: 'tag-loi'
};
const $a9e15ae689b819ac$var$tagLabels = {
    fr: {
        ref: "R\xe9f\xe9rendum",
        loi: 'Loi',
        ord: 'Ordonnance',
        info: 'Info'
    },
    en: {
        ref: 'Referendum',
        loi: 'Law',
        ord: 'Regulation',
        info: 'Info'
    },
    de: {
        ref: 'Referendum',
        loi: 'Gesetz',
        ord: 'Verordnung',
        info: 'Info'
    },
    it: {
        ref: 'Referendum',
        loi: 'Legge',
        ord: 'Ordinanza',
        info: 'Info'
    }
};
const $a9e15ae689b819ac$var$statusMap = {
    strict: 'status-strict',
    moderate: 'status-moderate',
    progres: 'status-progres',
    federal: 'status-federal',
    voted: 'status-voted'
};
// Fuel translations for each language
const $a9e15ae689b819ac$var$fuelLabels = {
    fr: {
        oil: "\uD83D\uDEE2\uFE0F Mazout",
        gas: "\uD83D\uDD25 Gaz de ville",
        propane: "\u2697\uFE0F Propane / GPL",
        electric: "\u26A1 \xc9lec. r\xe9sistance"
    },
    en: {
        oil: "\uD83D\uDEE2\uFE0F Heating oil",
        gas: "\uD83D\uDD25 Natural gas",
        propane: "\u2697\uFE0F Propane / LPG",
        electric: "\u26A1 Electric resistance"
    },
    de: {
        oil: "\uD83D\uDEE2\uFE0F Heiz\xf6l",
        gas: "\uD83D\uDD25 Erdgas",
        propane: "\u2697\uFE0F Propan / Fl\xfcssiggas",
        electric: "\u26A1 Elektro-Widerstandsheizung"
    },
    it: {
        oil: "\uD83D\uDEE2\uFE0F Olio combustibile",
        gas: "\uD83D\uDD25 Gas di citt\xe0",
        propane: "\u2697\uFE0F Propano / GPL",
        electric: "\u26A1 Elettrico a resistenza"
    }
};
const $a9e15ae689b819ac$var$uiText = {
    fr: {
        cantonPrefix: 'Canton de',
        summaryTitle: "R\xe9sum\xe9 de la situation",
        timelineTitle: 'Chronologie des mesures',
        legendPast: "Mesure pass\xe9e / en vigueur",
        legendNow: 'Situation actuelle',
        legendFuture: 'Mesure future',
        legendHalted: "Suspendu / r\xe9f\xe9rendum",
        rulesTitle: "R\xe8gles par combustible",
        fuelHeader: 'Combustible',
        ruleHeader: "R\xe8gle applicable",
        subsidiesTitle: 'Subventions disponibles',
        federalTitle: "Rappel f\xe9d\xe9ral (valable tous cantons) :",
        federalText: "Taxe CO\u2082 de 120 CHF/t sur les combustibles fossiles (mazout, gaz). Montant redistribu\xe9 partiellement \xe0 la population (~64 CHF/personne/an en 2024). Programme B\xe2timents f\xe9d\xe9ral disponible partout. MoPEC 2025 adopt\xe9 le 29 ao\xfbt 2025 \u2014 transposition cantonale en cours.",
        sourcePrefix: "\uD83D\uDCCE Source :",
        sourceSuffix: "Donn\xe9es arr\xeat\xe9es au 24 avril 2026 \xb7 Les informations sont donn\xe9es \xe0 titre indicatif \u2014 consultez les autorit\xe9s cantonales pour les cas individuels.",
        referendumTitle: "\u26A0\uFE0F Proc\xe9dure r\xe9f\xe9rendaire",
        referendumParty: "Parti / Comit\xe9 :",
        referendumLaunch: 'Lancement :',
        referendumStatus: "R\xe9sultat / Statut :",
        referendumSignatures: 'Signatures requises :',
        emptySelection: "Veuillez s\xe9lectionner un canton."
    },
    en: {
        cantonPrefix: 'Canton of',
        summaryTitle: 'Situation summary',
        timelineTitle: 'Timeline of measures',
        legendPast: 'Past / active measure',
        legendNow: 'Current situation',
        legendFuture: 'Future measure',
        legendHalted: 'Suspended / referendum',
        rulesTitle: 'Rules by fuel type',
        fuelHeader: 'Fuel type',
        ruleHeader: 'Applicable rule',
        subsidiesTitle: 'Available subsidies',
        federalTitle: 'Federal reminder (valid in all cantons):',
        federalText: "CO\u2082 tax of CHF 120/t on fossil fuels (oil, gas). Amount partly redistributed to the population (~CHF 64/person/year in 2024). Federal Buildings Programme available everywhere. MoPEC 2025 adopted on 29 August 2025 \u2014 cantonal transposition in progress.",
        sourcePrefix: "\uD83D\uDCCE Source:",
        sourceSuffix: "Data current as of 24 April 2026 \xb7 The information is provided for guidance only \u2014 please consult the cantonal authorities for individual cases.",
        referendumTitle: "\u26A0\uFE0F Referendum procedure",
        referendumParty: 'Party / Committee:',
        referendumLaunch: 'Launch:',
        referendumStatus: 'Result / Status:',
        referendumSignatures: 'Required signatures:',
        emptySelection: 'Please select a canton.'
    },
    de: {
        cantonPrefix: 'Kanton',
        summaryTitle: 'Zusammenfassung der Situation',
        timelineTitle: 'Chronologie der Massnahmen',
        legendPast: 'Vergangene / geltende Massnahme',
        legendNow: 'Aktuelle Situation',
        legendFuture: "Zuk\xfcnftige Massnahme",
        legendHalted: 'Ausgesetzt / Referendum',
        rulesTitle: "Regeln nach Energietr\xe4ger",
        fuelHeader: "Energietr\xe4ger",
        ruleHeader: 'Geltende Regel',
        subsidiesTitle: "Verf\xfcgbare F\xf6rderungen",
        federalTitle: "Hinweis Bund (g\xfcltig in allen Kantonen):",
        federalText: "CO\u2082-Abgabe von 120 CHF/t auf fossile Brennstoffe (Heiz\xf6l, Gas). Betrag wird teilweise an die Bev\xf6lkerung zur\xfcckverteilt (~64 CHF/Person/Jahr im Jahr 2024). Bundesprogramm Geb\xe4ude ist \xfcberall verf\xfcgbar. MoPEC 2025 wurde am 29. August 2025 verabschiedet \u2014 die Umsetzung in den Kantonen l\xe4uft.",
        sourcePrefix: "\uD83D\uDCCE Quelle:",
        sourceSuffix: "Datenstand 24. April 2026 \xb7 Die Informationen dienen nur zur Orientierung \u2014 bitte konsultieren Sie die kantonalen Beh\xf6rden f\xfcr Einzelf\xe4lle.",
        referendumTitle: "\u26A0\uFE0F Referendumsverfahren",
        referendumParty: 'Partei / Komitee:',
        referendumLaunch: 'Start:',
        referendumStatus: 'Ergebnis / Status:',
        referendumSignatures: 'Erforderliche Unterschriften:',
        emptySelection: "Bitte w\xe4hlen Sie einen Kanton aus."
    },
    it: {
        cantonPrefix: 'Cantone di',
        summaryTitle: 'Sintesi della situazione',
        timelineTitle: 'Cronologia delle misure',
        legendPast: 'Misura passata / in vigore',
        legendNow: 'Situazione attuale',
        legendFuture: 'Misura futura',
        legendHalted: 'Sospeso / referendum',
        rulesTitle: 'Regole per tipo di combustibile',
        fuelHeader: 'Combustibile',
        ruleHeader: 'Regola applicabile',
        subsidiesTitle: 'Sovvenzioni disponibili',
        federalTitle: 'Promemoria federale (valido in tutti i cantoni):',
        federalText: "Tassa CO\u2082 di 120 CHF/t sui combustibili fossili (olio combustibile, gas). Importo parzialmente ridistribuito alla popolazione (~64 CHF/persona/anno nel 2024). Programma Edifici federale disponibile ovunque. MoPEC 2025 adottato il 29 agosto 2025 \u2014 trasposizione cantonale in corso.",
        sourcePrefix: "\uD83D\uDCCE Fonte:",
        sourceSuffix: "Dati aggiornati al 24 aprile 2026 \xb7 Le informazioni sono fornite a titolo indicativo \u2014 consultate le autorit\xe0 cantonali per i singoli casi.",
        referendumTitle: "\u26A0\uFE0F Procedura referendaria",
        referendumParty: 'Partito / Comitato:',
        referendumLaunch: 'Avvio:',
        referendumStatus: 'Risultato / Stato:',
        referendumSignatures: 'Firme richieste:',
        emptySelection: 'Selezionate un cantone.'
    }
};
function $a9e15ae689b819ac$var$getCurrentGuideLanguage() {
    return (document.documentElement.lang || 'fr').split('-')[0].toLowerCase();
}
function $a9e15ae689b819ac$var$renderCanton(code) {
    const currentLanguage = $a9e15ae689b819ac$var$getCurrentGuideLanguage();
    const cantons = $a9e15ae689b819ac$var$datasets[currentLanguage] || $a9e15ae689b819ac$var$datasets.fr;
    const labels = $a9e15ae689b819ac$var$tagLabels[currentLanguage] || $a9e15ae689b819ac$var$tagLabels.fr;
    const texts = $a9e15ae689b819ac$var$uiText[currentLanguage] || $a9e15ae689b819ac$var$uiText.fr;
    const fuels = $a9e15ae689b819ac$var$fuelLabels[currentLanguage] || $a9e15ae689b819ac$var$fuelLabels.fr;
    const canton = cantons[code];
    if (!canton) return '';
    const timeline = (canton.timeline || []).map((item)=>`
        <div class="tl-item tl-${item.type}">
            <div class="tl-date">${item.date} <span class="tl-tag ${$a9e15ae689b819ac$var$tagMap[item.tag]}">${labels[item.tag]}</span></div>
            <div class="tl-text">${item.text}</div>
        </div>
    `).join('');
    const referendum = canton.referendum ? `
        <div class="cantonal-guide__section">
            <div class="cantonal-guide__section-title">${texts.referendumTitle}</div>
            <div class="alert-box alert-red cantonal-guide__alert-box">
                <strong>${texts.referendumParty}</strong> ${canton.referendum.parti}<br>
                <strong>${texts.referendumLaunch}</strong> ${canton.referendum.date_lancement}<br>
                <strong>${texts.referendumStatus}</strong> ${canton.referendum.votation}
                ${canton.referendum.signatures ? `<br><strong>${texts.referendumSignatures}</strong> ${canton.referendum.signatures}` : ''}
            </div>
        </div>
    ` : '';
    return `
        <div class="canton-header">
            <div class="canton-flag">${canton.flag}</div>
            <div class="canton-meta">
                <h2>${texts.cantonPrefix} ${canton.name} (${code})</h2>
                <p>${canton.region}</p>
                <div class="status-badge ${$a9e15ae689b819ac$var$statusMap[canton.status]}">${canton.statusLabel}</div>
            </div>
        </div>

        <div class="cantonal-guide__section">
            <div class="cantonal-guide__section-title">${texts.summaryTitle}</div>
            <p class="cantonal-guide__summary">${canton.summary}</p>
        </div>

        <div class="cantonal-guide__section">
            <div class="cantonal-guide__section-title">${texts.timelineTitle}</div>
            <div class="timeline cantonal-guide__timeline">${timeline}</div>
            <div class="legend cantonal-guide__legend">
                <div class="legend-item"><div class="legend-dot legend-dot--past"></div> <span>${texts.legendPast}</span></div>
                <div class="legend-item"><div class="legend-dot legend-dot--now"></div> <span>${texts.legendNow}</span></div>
                <div class="legend-item"><div class="legend-dot legend-dot--future"></div> <span>${texts.legendFuture}</span></div>
                <div class="legend-item"><div class="legend-dot legend-dot--halted"></div> <span>${texts.legendHalted}</span></div>
            </div>
        </div>

        <div class="cantonal-guide__section">
            <div class="cantonal-guide__section-title">${texts.rulesTitle}</div>
            <table class="data-table cantonal-guide__data-table">
                <thead>
                    <tr>
                        <th class="cantonal-guide__fuel-column">${texts.fuelHeader}</th>
                        <th>${texts.ruleHeader}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr><td><strong>${fuels.oil}</strong></td><td>${canton.mazout}</td></tr>
                    <tr><td><strong>${fuels.gas}</strong></td><td>${canton.gaz}</td></tr>
                    <tr><td><strong>${fuels.propane}</strong></td><td>${canton.propane}</td></tr>
                    <tr><td><strong>${fuels.electric}</strong></td><td>${canton.elec}</td></tr>
                </tbody>
            </table>
        </div>

        ${referendum}

        <div class="cantonal-guide__section">
            <div class="cantonal-guide__section-title">${texts.subsidiesTitle}</div>
            <div class="alert-box alert-green cantonal-guide__alert-box">${canton.subventions}</div>
        </div>

        <div class="alert-box alert-blue cantonal-guide__alert-box cantonal-guide__alert-box--flush">
            <strong>${texts.federalTitle}</strong> ${texts.federalText}
        </div>

        <div class="source-bar cantonal-guide__source-bar">
            ${texts.sourcePrefix} ${canton.source} \xb7 ${texts.sourceSuffix}
        </div>
    `;
}
function $a9e15ae689b819ac$export$2e2bcd8739ae039() {
    const container = document.querySelector('.cantonal-guide');
    if (!container) return;
    const select = container.querySelector('#cantonSelect');
    const trigger = container.querySelector('.js-show-canton');
    const result = container.querySelector('#result');
    if (!select || !trigger || !result) return;
    trigger.addEventListener('click', ()=>{
        const code = select.value;
        if (!code) {
            const texts = $a9e15ae689b819ac$var$uiText[$a9e15ae689b819ac$var$getCurrentGuideLanguage()] || $a9e15ae689b819ac$var$uiText.fr;
            window.alert(texts.emptySelection);
            return;
        }
        result.innerHTML = $a9e15ae689b819ac$var$renderCanton(code);
        result.style.display = 'block';
        result.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    });
}



var $i0a3b = parcelRequire("i0a3b");
// Your JavaScript code here
(function($) {
    const $win = $(window);
    const $doc = $(document);
    initWeglotSwitcherIds();
    initAccountDocuments();
    initHeaderMenuToggler();
    initChipLogic();
    initListArticles('list-articles');
    initGuideModal();
    (0, $a9e15ae689b819ac$export$2e2bcd8739ae039)();
    initFaqFilters();
    initFaqAccordion();
    function initWeglotSwitcherIds() {
        const switchers = document.querySelectorAll('.country-selector');
        if (!switchers.length) return;
        switchers.forEach((switcher, index)=>{
            const input = switcher.querySelector('.weglot_choice');
            const label = switcher.querySelector('.wgcurrent[for]');
            if (!input || !label) return;
            const uniqueId = `weglot-switcher-${index + 1}`;
            input.id = uniqueId;
            label.setAttribute('for', uniqueId);
        });
    }
    function initAccountDocuments() {
        const container = document.querySelector('.js-account-documents');
        if (!container) return;
        const toggles = container.querySelectorAll('[data-account-toggle]');
        const panels = document.querySelectorAll('[data-account-panel]');
        if (!toggles.length || !panels.length) return;
        toggles.forEach((toggle)=>{
            toggle.addEventListener('click', function() {
                const target = this.getAttribute('data-account-toggle');
                toggles.forEach((button)=>{
                    const isActive = button === this;
                    button.classList.toggle('is-active', isActive);
                    button.setAttribute('aria-expanded', isActive ? 'true' : 'false');
                });
                panels.forEach((panel)=>{
                    panel.classList.toggle('is-open', panel.getAttribute('data-account-panel') === target);
                });
            });
        });
    }
    function addOverlay(ovElement) {
        const $overlay = $(`${ovElement}`);
        if (!$overlay.length) return;
        $('body').addClass('no-scroll');
        $overlay.addClass('active');
    }
    function removeOverlay(ovElement) {
        const $overlay = $(`${ovElement}`);
        if (!$overlay.length) return;
        $('body').removeClass('no-scroll');
        $overlay.removeClass('active');
    }
    function initHeaderMenuToggler() {
        if (!$('.header__menu-toggle').length) return;
        const $header = $('.header__container');
        $('.header .header__menu-toggle').on('click', function(e) {
            $(this).closest('.header__container').toggleClass('menu-open');
            addOverlay('.app-loader-overlay');
            e.preventDefault();
        });
        $('.header__menu-close svg').on('click', function(e) {
            $('.header__container').toggleClass('menu-open');
            e.preventDefault();
            removeOverlay('.app-loader-overlay');
        });
        $doc.mouseup(function(e) {
            if ($header.hasClass('menu-open')) {
                if (!$header.is(e.target) && $header.has(e.target).length === 0) {
                    $header.removeClass('menu-open');
                    removeOverlay('.app-loader-overlay');
                }
            }
        });
    }
    function initChipLogic() {
        if (!$('.section-articles').length) return;
        $('input[name="field-category[]"]').on('change', function() {
            if ($(this).val() !== 'All') $('.input--chips input[value="All"]').prop('checked', false);
            else $('.input--chips').find('input[value!="All"]').prop('checked', false);
        });
    }
    function initListArticles(elementSelector) {
        if (!$('.section-articles').length) return;
        let options = {
            valueNames: [
                {
                    data: [
                        'ljs-article'
                    ]
                }
            ],
            listClass: 'ljs-container'
        };
        let list = new (0, (/*@__PURE__*/$parcel$interopDefault($i0a3b)))(elementSelector, options);
        $('input[name="field-category[]"]').on('change', function() {
            let selectedArticleCategories = $('input[name="field-category[]"]:checked').map(function(_, el) {
                return $(el).val();
            }).get();
            if (selectedArticleCategories.includes('All') || selectedArticleCategories.length === 0) list.filter();
            else list.filter(function(item) {
                let allCategoriesString = item.values()['ljs-article'] || '';
                let allCategoriesArray = allCategoriesString.split(',').map((category)=>category.trim()).filter(Boolean);
                return selectedArticleCategories.some((category)=>allCategoriesArray.includes(category));
            });
        });
    }
    function initGuideModal() {
        const $modal = $('#guide-modal');
        const $triggers = $('.js-guide-trigger');
        const $overlay = $('.app-loader-overlay');
        if (!$modal.length || !$triggers.length || !$overlay.length) return;
        const $closeButtons = $modal.find('.guide-modal__close');
        const openModal = ()=>{
            $modal.addClass('is-active').attr('aria-hidden', 'false');
            $overlay.css('z-index', '999997');
            addOverlay('.app-loader-overlay');
        };
        const closeModal = ()=>{
            $modal.removeClass('is-active').attr('aria-hidden', 'true');
            $overlay.css('z-index', '101');
            removeOverlay('.app-loader-overlay');
        };
        $triggers.on('click', function(event) {
            event.preventDefault();
            openModal();
        });
        $closeButtons.on('click', closeModal);
        $overlay.on('click', function() {
            if ($modal.hasClass('is-active')) closeModal();
        });
        $doc.on('keydown', function(event) {
            if (event.key === 'Escape' && $modal.hasClass('is-active')) closeModal();
        });
    }
    function initFaqFilters() {
        const container = document.querySelector('.faq');
        if (!container) return;
        const buttons = container.querySelectorAll('.faq-filter-btn');
        const sections = container.querySelectorAll('[data-faq-section]');
        if (!buttons.length || !sections.length) return;
        buttons.forEach((button)=>{
            button.addEventListener('click', ()=>{
                const filter = button.getAttribute('data-filter');
                buttons.forEach((item)=>{
                    const isActive = item === button;
                    item.classList.toggle('active', isActive);
                    item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
                });
                sections.forEach((section)=>{
                    const shouldShow = filter === 'all' || section.getAttribute('data-faq-section') === filter;
                    section.hidden = !shouldShow;
                });
            });
        });
    }
    function initFaqAccordion() {
        const items = document.querySelectorAll('.faq-item');
        if (!items.length) return;
        items.forEach((item)=>{
            const button = item.querySelector('.faq-question');
            const answer = item.querySelector('.faq-answer');
            if (!button || !answer) return;
            button.addEventListener('click', ()=>{
                const isOpen = item.classList.toggle('is-open');
                button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
                answer.hidden = !isOpen;
            });
        });
    }
})(jQuery);

})();
//# sourceMappingURL=main.js.map
